


export const translations = {
  de: {
    common: {
      back: "Zurück",
      error: "FEHLER",
      save: "Speichern",
      cancel: "Abbrechen",
      close: "Schließen",
      ok: "OK",
      yes: "JA",
      no: "NEIN",
      send: "Senden",
      loading: "Lädt...",
      loadingPlayer: "Spieler wird geladen …",
      logout: "Logout",
      support: "Support",
      settings: "Einstellungen",
      legal: "Rechtliches",
      premium: "Premium-Abo",
      about: "Über VaultQuest",
      languageSettings: "Spracheinstellungen",
      accountSettings: "Kontoeinstellungen",
      changePassword: "Passwort ändern",
      deleteAccount: "Konto löschen",
      german: "Deutsch",
      english: "Englisch",
      delete: "Löschen",
    },
    surveys: {
      single: "Einfachauswahl",
      multiple: "Mehrfachauswahl",
      entryTitle: "Hilf uns, VaultQuest zu verbessern.",
      notNow: "Nicht jetzt",
      next: "Weiter",
      submit: "Feedback senden",
      thanks: "Danke für dein Feedback!",
      required: "Bitte beantworte jede Frage.",
      questionProgress: "Frage {{current}} von {{total}}",
      selectOneHint: "Eine Antwort auswählen",
      selectMultipleHint: "Mehrere Antworten möglich",
      other: "Sonstiges",
      otherPlaceholder: "Bitte kurz erläutern …",
      noPersonalData: "Bitte keine persönlichen Daten angeben.",
      otherRequired: "Bitte erläutere deine Auswahl kurz.",
      otherTooLong: "Deine Antwort darf maximal 300 Zeichen enthalten.",
      otherPlainText: "Bitte verwende nur normalen Text ohne HTML.",
      loadError: "Die Umfrage konnte nicht geladen werden.",
      submitError: "Dein Feedback konnte nicht gesendet werden.",
      unavailable: "Diese Umfrage ist aktuell nicht mehr verfügbar.",
      blockedByPriorityAction: "Schließe zuerst die aktuelle Match-Aktion ab. Danach kannst du die Umfrage öffnen.",
      notificationAction: "UMFRAGE ÖFFNEN",
      admin: {
        createTitle: "Neue Umfrage",
        titleDE: "Titel Deutsch",
        titleEN: "Titel Englisch",
        startsAt: "Startzeitpunkt",
        endsAt: "Endzeitpunkt",
        question: "Frage {{number}}",
        questionText: "Fragetext",
        option: "Antwort",
        addOption: "Antwort hinzufügen",
        addQuestion: "Frage hinzufügen",
        allowOther: "Sonstiges mit Freitext erlauben",
        otherResponses: "Anonyme Antworten anzeigen",
        hideOtherResponses: "Anonyme Antworten ausblenden",
        create: "Umfrage erstellen",
        planned: "Geplante Umfragen",
        running: "Laufende Umfragen",
        ended: "Beendete Umfragen",
        participations: "Teilnahmen",
        shown: "Angezeigt",
        deferred: "Zurückgestellt",
        endNow: "Vorzeitig beenden",
        showResults: "Ergebnisse ansehen",
        none: "Keine Umfragen vorhanden.",
        invalidDates: "Bitte gültige Start- und Endzeitpunkte wählen.",
        created: "Umfrage wurde erstellt.",
        endedMessage: "Umfrage wurde beendet.",
        loadError: "Umfragen konnten nicht geladen werden.",
        createError: "Umfrage konnte nicht erstellt werden.",
        endError: "Umfrage konnte nicht beendet werden.",
        resultsError: "Ergebnisse konnten nicht geladen werden.",
      },
    },
    authState: {
      loading: "VaultQuest wird geladen...",
      loadError: "Dein Profil konnte nicht geladen werden.",
    },
    rulesDisclaimer: {
      title: "Hinweis zum Wettbewerb",
      text:
        "Apple Inc. ist weder Sponsor noch Veranstalter dieses Wettbewerbs und ist in keiner Weise an dessen Durchführung beteiligt.\n\nDieser EA SPORTS FC-Wettbewerb steht in keiner Verbindung zu Electronic Arts Inc. oder deren Lizenzgebern und wird von diesen weder gesponsert noch unterstützt.",
    },
    competitionRules: {
      tournamentRulesTitle: "Turnierregeln",
      creatorRulesTitle: "Zusätzliche Creator-Regeln",
      tournamentAdditionalRulesTitle: "Zusätzliche Turnierregeln",
      additionalTournamentRule: "Zusätzliche Turnierregel",
      competitionTermsTitle: "Wettbewerbsbedingungen",
      competitionTermsText:
        "Für die Teilnahme gelten zusätzlich die allgemeinen VaultQuest-Wettbewerbsbedingungen.",
      openCompetitionTerms: "Wettbewerbsbedingungen ansehen",
      labels: {
        gameMode: "Spielmodus",
        matchDuration: "Spieldauer",
        format: "Format",
        tieDecision: "Entscheidung bei Gleichstand",
        teamSelection: "Teamwahl",
        platform: "Plattform",
      },
      values: {
        gameMode: {
          ultimate_team: "Ultimate Team",
          kick_off: "Anstoß",
        },
        matchDuration: "6 Minuten",
        format: {
          knockout: "K.O.-Phase (Best-of-One)",
          groupStage: "Gruppenphase / K.O.-Phase (Best-of-One)",
        },
        tieDecision: "Verlängerung + Elfmeterschießen",
        teamSelection: {
          free: "Freie Wahl",
        },
        platform: {
          all: "PlayStation / X-BOX / PC (nur NewGen)",
          playstation_new_gen: "PlayStation (New Gen)",
          xbox_new_gen: "Xbox (New Gen)",
          pc: "PC",
        },
      },
    },
    header: {
      home: "HOME",
      tournaments: "TURNIERE",
      singles: "EINZELSPIELE",
      profile: "PROFIL",
      community: "COMMUNITY",
      fairplay: "FAIRPLAY",
      agb: "AGB",
      privacy: "DATENSCHUTZERKLÄRUNG",
      impressum: "IMPRESSUM",
      competitionTerms: "WETTBEWERBSBEDINGUNGEN",
      game: "SPIEL",
      vouchers: "Gutscheine",
      shop: "Shop",
      premium: "Premium",
      faqs: "FAQs",
    },
    faq: {
      title: "FAQs",
      subtitle: "Die wichtigsten Antworten rund um VaultQuest, Turniere, Matches und Belohnungen.",
      items: [
        {
          question: "Was ist VaultQuest?",
          answer: "VaultQuest ist eine plattformübergreifende Turnierplattform für kompetitives Gaming. Du kannst an Turnieren und Einzelmatches teilnehmen, Ergebnisse melden und dir Belohnungen sichern.",
        },
        {
          question: "Welche Spiele werden aktuell unterstützt?",
          answer: "Aktuell unterstützt VaultQuest EA SPORTS FC. Weitere Spiele werden Schritt für Schritt ergänzt.",
        },
        {
          question: "Welche Plattformen kann ich nutzen?",
          answer: "VaultQuest unterstützt PlayStation 5, Xbox Series X|S und PC. Old-Gen-Konsolen wie PlayStation 4 und Xbox One werden nicht unterstützt.",
        },
        {
          question: "Wie laufen Turniere ab?",
          answer: "Du trittst einem verfügbaren Turnier bei, wartest in der Turnierlobby auf den Start und spielst anschließend gegen den dir zugewiesenen Gegner. VaultQuest führt dich durch Match, Ergebnisreport und Weiterkommen.",
        },
        {
          question: "Wie funktionieren Ergebnismeldungen?",
          answer: "Nach einem Match melden die Spieler ihr Ergebnis. Stimmen die Meldungen überein, wird das Ergebnis automatisch verarbeitet. Bei abweichenden Meldungen kann ein Konfliktfall entstehen.",
        },
        {
          question: "Was passiert bei einem Konflikt?",
          answer: "Bei einem Konflikt können die beteiligten Spieler Beweise hochladen. Ein Admin prüft den Fall und entscheidet anhand der vorhandenen Informationen.",
        },
        {
          question: "Wie erhalte ich meine Belohnung?",
          answer: "Wenn du ein belohnungsberechtigtes Turnier gewinnst, erhältst du deinen Gutscheincode über das VaultQuest-Benachrichtigungssystem und zusätzlich an deine hinterlegte E-Mail-Adresse.",
        },
        {
          question: "Wo bekomme ich Hilfe?",
          answer: "Wenn du Unterstützung brauchst, kannst du das Support-Formular in der App nutzen oder VaultQuest über die angegebenen Kontaktwege erreichen.",
        },
      ],
    },
matchChat: {
  systemWelcome: "Willkommen im Match-Chat. Nutzt diesen Bereich, um euch bei Bedarf abzusprechen. Bitte bleibt fair und respektvoll. Falls ihr Unterstützung benötigt oder ein dringendes Problem auftritt, könnt ihr jederzeit den Support-Button verwenden. Ein Admin tritt dann diesem Chat bei und unterstützt euch.",
  systemAdminJoined: "Ein Admin ist dem Chat beigetreten.",
  systemAdminLeft: "Der Admin hat den Chat verlassen.",
  adminLabel: "🛡 Admin",
  inputPlaceholder: "Nachricht schreiben...",
  send: "Senden",
  adminHelp: {
    button: "Support anfordern",
    informed: "Ein Admin wurde informiert.",
    limitReached: "Du hast dein Admin-Help-Limit für dieses Match erreicht.",
    confirmTitle: "Admin hinzuziehen",
    confirmBody:
      "Möchtest du wirklich einen Admin zu diesem Chat hinzuziehen?\n\nDer Chatverlauf wird anschließend auch für den Admin sichtbar.",
    cancel: "Abbrechen",
    confirm: "Admin hinzuziehen",
    error: "Admin Help konnte nicht angefordert werden.",
  },
  states: {
    joinToRead: "Tritt dem Chat bei, um Nachrichten zu lesen.",
    waitingForPlayers: "Der Chat ist verfügbar, sobald beide Spieler feststehen.",
  },
  errors: {
    loadFailed: "Chat konnte nicht geladen werden.",
    sendFailed: "Nachricht konnte nicht gesendet werden.",
    inappropriateLanguage:
      "Diese Nachricht kann wegen unangemessener Sprache nicht gesendet werden.",
  },
},
home: {
  greeting: "Willkommen zurück, {{name}}!",
  greetingSubtitle: "Bereit für dein nächstes Turnier?",
  community: "COMMUNITY",
  communityText: "Freunde, Leaderboards, Quests und mehr entdecken",
  joinTournament: "TURNIERE",
  joinTournamentText: "Spiele in Cups und gewinne Preise",
  singles: "MATCHES",
  singlesText: "Tritt in schnellen Matches an",
  profile: "MEIN PROFIL",
  profileText: "Deine Ergebnisse und Fortschritte",
  profileSection: "PROFIL",
  prizesSection: "PREISE",
  myPrizes: "MEINE GEWINNE",
  myPrizesText: "Auszahlungen und Sachpreise anfordern",
  fairplay: "FAIRPLAY",
  fairplayText: "Vertrauenslevel und Regelwerk für faire Matches",
  creatorTournaments: "CREATOR CUP",
  creatorTournamentsText: "Plane dein eigenes Turnier",
  adminPanelText: "Konflikte, Support, Admin Help",
  upcomingTitle: "DEMNÄCHST",
  activeMatchesTitle: "AKTIVE MATCHES",
  socialSection: "SOCIALS",
  creatorSection: "CREATOR",
  adminSection: "ADMIN",
  showAll: "Alle anzeigen",
  open: "Öffnen",
  toTournament: "Zum Turnier",
  toMatch: "Zum Match",
  players: "Spieler",
  today: "Heute",
  tomorrow: "Morgen",
  tournamentFallback: "Turnier",
  tournamentMatchMeta: "Turniermatch bereit",
  singleMatchFallback: "Einzelmatch",
  singleMatchMeta: "Ergebnis ausstehend",
  vs: "gegen",
  playerOne: "Spieler 1",
  loadingPlayers: "Spielerdaten werden geladen…",
  playerTwo: "Spieler 2",
  status: {
    open: "OFFEN",
    running: "LÄUFT",
    finished: "BEENDET",
    full: "VOLL",
    cancelled: "ENTFÄLLT",
    active: "AKTIV",
  },
},

topBar: {
  coins: "Coins",
  trust: "Trust",
  messages: "Nachrichten",
},

community: {
  title: "Community",
  subtitle: "Vernetze dich, vergleiche dich und erlebe mehr VaultQuest.",
  leaderboards: "Leaderboards",
  leaderboardsText: "Ranglisten und Platzierungen ansehen",
  friends: "Freundesliste",
  friendsText: "Freunde verwalten und Profile öffnen",
  quests: "Quests",
  questsText: "Belohnungen und Fortschritt ansehen",
  surveys: {
    title: "Umfragen",
    openOne: "1 offene Umfrage",
    openMany: "{{count}} offene Umfragen",
  },
  myPrizes: {
    title: "Meine Gewinne",
    text: "Auszahlungen und Sachpreise anfordern",
  },
  questProgressTitle: "Dein Quest-Fortschritt",
  questProgressCount: "{{completed}} / {{total}} erledigt",
  questProgressFallback: "Öffne deine Quests, um Fortschritt und Belohnungen anzusehen.",
  questReadyToClaim: "{{count}} bereit zum Einsammeln",
  allQuests: "Alle Quests",
  followVaultQuest: "Folge VaultQuest",
  instagramText: "Updates & Einblicke",
  tiktokText: "Clips & Highlights",
  reportBlock: {
    title: "Nutzer melden / blockieren",
    text: "Melde Verstöße oder blockiere Freundschaftsanfragen.",
  },
  privateTournaments: {
    title: "Private Turniere",
    text: "Gib hier den Code ein, um das Turnier zu finden.",
    modalTitle: "Privates Turnier",
    modalText: "Gib den 6-stelligen Code ein, den du vom Creator erhalten hast.",
    placeholder: "Code",
    delete: "Löschen",
    unlock: "Bestätigen",
    cancel: "Abbrechen",
    checking: "Prüfe...",
    error: "Der Code konnte nicht geprüft werden.",
    outsideCalendar:
      "Das private Turnier wurde freigeschaltet, liegt aber außerhalb der aktuell sichtbaren 8 Tage im Turnierkalender.",
  },
},

myPrizes: {
  title: "Meine Gewinne",
  subtitle: "Hier findest du deine auszahlbaren Gewinne und Sachpreise aus Special- und Creator-Cups.",
  loading: "Gewinne werden geladen...",
  empty: "Du hast aktuell keine anforderbaren Gewinne.",
  unknownTournament: "VaultQuest Turnier",
  types: {
    tournament: "Turnier",
    special: "Special Cup",
    creator: "Creator Cup",
    evening: "Evening Cup",
    nightly: "Nightly Cup",
  },
  prizeTypes: {
    payout: "Auszahlung",
    physical: "Sachpreis",
  },
  status: {
    payout: {
      claimable: "Auszahlbar",
      requested: "Auszahlung wird bearbeitet",
      pending: "Auszahlung wird bearbeitet",
      processing: "Auszahlung wird bearbeitet",
      needs_action: "Korrektur erforderlich",
      completed: "Auszahlung erfolgt",
      cancelled: "Nicht mehr verfügbar",
      forfeited: "Nicht mehr verfügbar",
    },
    physical: {
      claimable: "Anforderbar",
      requested: "Sachpreis wird bearbeitet",
      pending: "Sachpreis wird bearbeitet",
      processing: "Sachpreis wird bearbeitet",
      needs_action: "Korrektur erforderlich",
      completed: "Versendet",
      cancelled: "Nicht mehr verfügbar",
      forfeited: "Nicht mehr verfügbar",
    },
  },
  actions: {
    requestPayout: "Auszahlung anfordern",
    requestPhysical: "Sachpreis anfordern",
    correctDetails: "Daten korrigieren",
    submitting: "Sendet...",
    reload: "Neu laden",
  },
  modal: {
    payoutTitle: "Auszahlung anfordern",
    physicalTitle: "Sachpreis anfordern",
    method: "Auszahlungsmethode",
    methodLocked: "Methode: {{method}}",
    summary: "Zusammenfassung",
  },
  privacy: {
    paypal: "Deine PayPal-E-Mail-Adresse wird nur für die Abwicklung deiner Auszahlung gespeichert und nach erfolgter Auszahlung unwiderruflich gelöscht.",
    bank: "Deine Bankdaten werden nur für die Abwicklung deiner Auszahlung gespeichert und nach erfolgter Auszahlung unwiderruflich gelöscht.",
    shipping: "Deine Versandadresse wird nur für den Versand deines Sachpreises gespeichert und nach Abschluss des Versands unwiderruflich gelöscht.",
  },
  help: {
    iban: "Deine IBAN wird automatisch formatiert.",
  },
  placeholders: {
    iban: "DE12 3456 7890 1234 5678 90",
  },
  methods: {
    paypal: "PayPal",
    bank: "Banküberweisung",
    voucher: "Gutschein",
    shipping: "Versand",
  },
  providers: {
    psn: "PSN",
    xbox: "Xbox",
    amazon: "Amazon",
    zalando: "Zalando",
    steam: "Steam",
  },
  fields: {
    paypalEmail: "PayPal-E-Mail-Adresse",
    accountHolder: "Empfängername",
    iban: "IBAN",
    voucherProvider: "Gutscheinanbieter",
    recipientName: "Empfänger",
    street: "Straße",
    houseNumber: "Hausnummer",
    postalCode: "PLZ",
    city: "Ort",
    country: "Land",
  },
  errors: {
    load: "Deine Gewinne konnten nicht geladen werden.",
    generic: "Die Anfrage konnte nicht verarbeitet werden.",
    paypal: "Bitte überprüfe deine PayPal-E-Mail-Adresse.",
    iban: "Bitte überprüfe deine IBAN.",
    accountHolder: "Bitte gib den Empfängernamen ein.",
    voucherProvider: "Bitte wähle einen Gutscheinanbieter aus.",
    shipping: "Bitte fülle alle Versandfelder aus.",
    notClaimable: "Dieser Gewinn kann nicht mehr angefordert werden.",
    exists: "Für diesen Gewinn existiert bereits eine Anfrage. Der Status wurde aktualisiert.",
  },
  needsActionReasons: {
    invalid_payment_details: "Bitte überprüfe deine Zahlungsdaten.",
    invalid_paypal_email: "Bitte überprüfe deine PayPal-E-Mail-Adresse.",
    invalid_bank_details: "Bitte überprüfe deine Bankdaten.",
    invalid_iban: "Bitte überprüfe deine IBAN.",
    invalid_shipping_address: "Bitte überprüfe deine Versandadresse.",
    incomplete_shipping_address: "Bitte überprüfe deine Versandadresse.",
    missing_information: "Bitte ergänze die fehlenden Angaben.",
    additional_details_required: "Bitte ergänze die fehlenden Angaben.",
    other_details_required: "Bitte prüfe deine Angaben.",
    other: "Bitte prüfe deine Angaben.",
    unknown: "Bitte prüfe deine Angaben.",
  },
  tournamentCard: {
    wonPayout: "Du hast {{prize}} gewonnen.",
    wonPhysical: "Du hast {{prize}} gewonnen.",
  },
},

adminPrizeFulfillments: {
  kicker: "ADMIN",
  title: "Preisabwicklungen",
  subtitle: "Auszahlungen, Gutscheine und Sachpreise prüfen und abschließen.",
  filtersLabel: "Preisabwicklungen filtern",
  listLabel: "Preisabwicklungen",
  detailLabel: "Details zur Preisabwicklung",
  loading: "Preisabwicklungen werden geladen...",
  loadingDetail: "Detail wird geladen...",
  empty: "Keine passenden Preisabwicklungen gefunden.",
  selectHint: "Wähle links eine Preisabwicklung aus.",
  filters: {
    all: "Alle",
    open: "Offen",
    payout: "Auszahlungen",
    physical: "Sachpreise",
    needs_action: "Korrektur erforderlich",
    processing: "In Bearbeitung",
    completed: "Abgeschlossen",
  },
  prizeTypes: {
    payout: "Auszahlung",
    physical: "Sachpreis",
  },
  methods: {
    paypal: "PayPal",
    bank: "Banküberweisung",
    voucher: "Gutschein",
    shipping: "Versand",
  },
  providers: {
    psn: "PSN",
    xbox: "Xbox",
    amazon: "Amazon",
    zalando: "Zalando",
    steam: "Steam",
  },
  status: {
    pending: "Offen",
    processing: "In Bearbeitung",
    needsAction: "Korrektur erforderlich",
    completedPayout: "Auszahlung erfolgt",
    completedPhysical: "Versendet",
    cancelled: "Storniert",
    unknown: "Unbekannt",
  },
  fields: {
    requestId: "Request-ID",
    awardId: "Award-ID",
    username: "User",
    tournament: "Turnier",
    type: "Typ",
    placement: "Platzierung",
    prizeType: "Preisart",
    prize: "Preis",
    method: "Methode",
    requestedAt: "Angefordert",
    needsActionReason: "Korrekturgrund",
    statusReason: "Hinweis",
    paypalEmail: "PayPal-E-Mail",
    recipientName: "Empfänger",
    iban: "IBAN",
    street: "Straße",
    city: "Ort",
    country: "Land",
    voucherProvider: "Gutscheinanbieter",
  },
  privateDetails: {
    title: "Private Abwicklungsdaten",
    paymentDeleted: "Zahlungsdaten nach Abschluss gelöscht",
    shippingDeleted: "Versandadresse nach Abschluss gelöscht",
  },
  reasons: {
    invalid_payment_details: "Zahlungsdaten ungültig",
    invalid_iban: "IBAN ungültig",
    invalid_paypal_email: "PayPal-E-Mail ungültig",
    incomplete_shipping_address: "Versandadresse unvollständig",
    additional_details_required: "Weitere Angaben erforderlich",
    other_details_required: "Weitere Angaben erforderlich",
    unknown: "Korrektur erforderlich",
  },
  needsAction: {
    title: "Korrektur anfordern",
    reason: "Grund",
    note: "Interner Hinweis ohne sensible Daten",
  },
  complete: {
    title: "Preisabwicklung abschließen",
    text: "Bitte bestätige nur, wenn die Auszahlung erfolgt, der Gutschein zugewiesen oder der Sachpreis versendet wurde.",
  },
  actions: {
    refresh: "Aktualisieren",
    loading: "Lädt...",
    close: "Schließen",
    cancel: "Abbrechen",
    working: "Wird verarbeitet...",
    markProcessing: "In Bearbeitung",
    requestCorrection: "Korrektur anfordern",
    sendCorrection: "Korrektur senden",
    completePayout: "Auszahlung erfolgt",
    completeShipping: "Versand abgeschlossen",
    completeVoucher: "Gutschein zuweisen",
    confirmComplete: "Abschließen",
  },
  messages: {
    processing: "Preisabwicklung wurde auf in Bearbeitung gesetzt.",
    needsAction: "Korrektur wurde angefordert.",
    completed: "Preisabwicklung wurde abgeschlossen.",
  },
  errors: {
    load: "Preisabwicklungen konnten nicht geladen werden.",
    detail: "Die Preisabwicklung konnte nicht geöffnet werden.",
    generic: "Die Aktion konnte nicht verarbeitet werden.",
    noVoucher: "Kein passender Gutschein verfügbar.",
    needsActionOpen: "Diese Preisabwicklung wartet noch auf korrigierte Angaben.",
    alreadyCompleted: "Diese Preisabwicklung ist bereits abgeschlossen.",
    cannotComplete: "Diese Preisabwicklung kann nicht abgeschlossen werden.",
  },
},

reportBlock: {
  title: "Nutzer melden / blockieren",
  intro: "Melde Regelverstöße oder blockiere neue Freundschaftsanfragen.",
  usernameLabel: "Username eingeben",
  usernamePlaceholder: "Username eingeben...",
  check: "Prüfen",
  userFound: "Gefunden: {{username}}",
  actions: {
    report: "Nutzer melden",
    block: "Nutzer blockieren",
  },
  categories: {
    harassment: "Belästigung",
    insult: "Beleidigung",
    cheating: "Cheating",
    spam: "Spam",
    inappropriateUsername: "Unangemessener Benutzername",
    other: "Sonstiges",
  },
  report: {
    title: "Nutzer melden",
    description: "Problem mit einem Nutzer? Sende uns eine Meldung.",
    reasonLabel: "Grund der Meldung",
    additionalInformation: "Zusätzliche Informationen (optional)",
    additionalPlaceholder: "Weitere Details zur Meldung...",
    submit: "Meldung senden",
    sending: "Sende...",
    success: "Vielen Dank. Deine Meldung wurde erfolgreich übermittelt.",
  },
  block: {
    title: "Nutzer blockieren",
    text: "Blockierte Nutzer können dir keine neuen Freundschaftsanfragen senden.",
    button: "Nutzer blockieren",
    blocking: "Blockiere...",
    confirmTitle: "Nutzer blockieren",
    confirmText: "Möchtest du diesen Nutzer wirklich blockieren?",
    confirmButton: "Blockieren",
    success: "Der Nutzer wurde erfolgreich blockiert.",
    listTitle: "Blockierte Nutzer",
    emptyTitle: "Keine blockierten Nutzer",
    empty: "Du hast aktuell niemanden blockiert.",
    loading: "Blockierte Nutzer werden geladen...",
    blockedSince: "Blockiert seit",
    total: "{{count}} blockierte Nutzer",
    searchPlaceholder: "Blockierte Nutzer suchen",
    noSearchResults: "Keine blockierten Nutzer gefunden.",
    unblock: "Blockierung aufheben",
    unblocking: "Hebt auf...",
    unblockConfirmTitle: "Blockierung aufheben",
    unblockConfirmText: "Möchtest du die Blockierung von {{username}} wirklich aufheben?",
    unblockConfirmButton: "Aufheben",
    cancel: "Abbrechen",
    unblockSuccess: "Die Blockierung wurde aufgehoben.",
    alreadyBlocked: "{{username}} ist bereits blockiert.",
  },
  errors: {
    emptyUsername: "Bitte gib einen Username ein.",
    notFound: "Es wurde kein Nutzer mit diesem Benutzernamen gefunden.",
    self: "Du kannst dich nicht selbst melden oder blockieren.",
    otherRequired: "Bitte ergänze bei Sonstiges eine kurze Beschreibung.",
    invalid: "Bitte prüfe deine Eingaben.",
    unauthenticated: "Bitte melde dich erneut an.",
    permissionDenied: "Du hast für diese Aktion keine Berechtigung.",
    network: "Netzwerkfehler. Bitte versuche es gleich erneut.",
    reportSaveFailed: "Meldung konnte nicht gespeichert werden.",
    blockSaveFailed: "Blockierung konnte nicht gespeichert werden.",
    unblockSaveFailed: "Blockierung konnte nicht aufgehoben werden.",
    generic: "Die Aktion konnte nicht abgeschlossen werden.",
  },
},

game: {
  selectorLabel: "Spielauswahl",
  statusActive: "Aktiv",
  moreGamesSoon: "Weitere Spiele folgen bald.",
  disclaimer:
    "EA Sports FC ist eine Marke von Electronic Arts. VaultQuest steht in keiner Verbindung zu Electronic Arts.",
},

dashboard: {
  leaveTournament: {
    lockedTitle: "TURNIER KANN NICHT VERLASSEN WERDEN",
    lockedText: "Du kannst dieses Turnier nicht mehr verlassen.",
    startedTitle: "TURNIER BEREITS GESTARTET",
    startedText: "Dieses Turnier läuft bereits und kann nicht mehr verlassen werden.",
    notLoggedInTitle: "NICHT EINGELOGGT",
    notLoggedInText: "Bitte logge dich ein, um ein Turnier zu verlassen.",
    genericError: "Beim Verlassen ist ein Fehler aufgetreten. Bitte erneut versuchen.",
  },
  admin: {
    title: "Admin Nachricht senden",
    enterRecipient: "Bitte mindestens einen Empfänger-Username eingeben.",
    enterTitle: "Bitte einen Titel eingeben.",
    enterMessage: "Bitte eine Nachricht eingeben.",
    sentSuccess: "Admin-Nachricht erfolgreich gesendet.",
    sentPushWarning: "Admin-Nachricht wurde in der App erstellt, aber die Push-Zustellung war nicht oder nur teilweise erfolgreich.",
    sentNoPushTarget: "Admin-Nachricht wurde in der App erstellt. Für mindestens einen Empfänger ist aktuell kein Push-Ziel vorhanden.",
    sentError: "Fehler beim Senden der Admin-Nachricht.",
    recipientPlaceholder: "Empfänger-Usernames, mit Komma trennen",
    titlePlaceholder: "Titel",
    messagePlaceholder: "Freie Admin-Nachricht",
    sending: "Sende...",
  },
  support: {
    missingMessageTitle: "FEHLENDE NACHRICHT",
    missingMessageText: "Bitte beschreibe dein Problem oder Anliegen.",
    sentTitle: "ANFRAGE GESENDET",
    sentText: "Deine Support-Anfrage wurde erfolgreich gesendet.",
    errorText: "Beim Senden deiner Support-Anfrage ist ein Fehler aufgetreten.",
    modalTitle: "SUPPORT",
    titlePlaceholder: "Titel (optional)",
    messagePlaceholder: "Beschreibe dein Problem oder Anliegen",
    sending: "SENDET...",
  },
  passwordReset: {
    noEmailTitle: "KEINE E-MAIL GEFUNDEN",
    noEmailText: "Für dieses Konto wurde keine E-Mail-Adresse gefunden.",
    sentTitle: "E-MAIL GESENDET",
    sentText: "Wir haben dir eine E-Mail zum Zurücksetzen deines Passworts gesendet.",
    errorText: "Die E-Mail zum Zurücksetzen konnte nicht gesendet werden.",
    modalTitle: "PASSWORT ÄNDERN",
    modalText: "WIR SENDEN EINEN LINK ZUM ZURÜCKSETZEN AN DEINE HINTERLEGTE E-MAIL-ADRESSE.",
    sending: "SENDET...",
  },
  challenge: {
    acceptedTitle: "HERAUSFORDERUNG ANGENOMMEN",
    acceptedText: "Die Herausforderung wurde angenommen. Das Match wurde erstellt.",
    declinedTitle: "HERAUSFORDERUNG ABGELEHNT",
    declinedText: "Die Herausforderung wurde abgelehnt.",
    bannedTitle: "ACCOUNT GESPERRT",
    bannedUntilText: "Dein Account wurde vorübergehend gesperrt. Eine Teilnahme ist bis {{date}} nicht möglich.",
    bannedText: "Dein Account wurde vorübergehend gesperrt. Eine Teilnahme an Einzelspielen ist aktuell nicht möglich.",
    unavailableTitle: "NICHT MEHR VERFÜGBAR",
    unavailableText: "Diese Herausforderung ist nicht mehr offen.",
    notEnoughCoinsTitle: "NICHT GENUG COINS",
    notEnoughCoinsText: "Du hast nicht genug Coins, um die Herausforderung anzunehmen.",
    invalidTitle: "HERAUSFORDERUNG NICHT MEHR GÜLTIG",
    invalidText: "Der Einladende hat nicht mehr genug Coins. Die Herausforderung kann nicht angenommen werden.",
    notPossibleTitle: "NICHT MÖGLICH",
    notPossibleText: "Du kannst auf diese Herausforderung nicht antworten.",
    notFoundTitle: "NICHT GEFUNDEN",
    notFoundText: "Die Herausforderung wurde nicht gefunden.",
    errorText: "Beim Antworten auf die Herausforderung ist ein Fehler aufgetreten.",
  },
  errors: {
    logoutFailed: "Logout fehlgeschlagen:",
  },
  friendRequest: {
    notPossibleTitle: "NICHT MÖGLICH",
    cannotAddSelf: "Du kannst dir nicht selbst eine Freundschaftsanfrage senden.",
    alreadyFriendsTitle: "BEREITS BEFREUNDET",
    alreadyFriendsText: "Ihr seid bereits befreundet.",
    alreadyPendingTitle: "ANFRAGE BEREITS GESENDET",
    alreadyPendingText: "Es existiert bereits eine offene Freundschaftsanfrage.",
    sentTitle: "FREUNDSCHAFTSANFRAGE GESENDET",
    sentText: "Die Freundschaftsanfrage wurde erfolgreich gesendet.",
    alreadyExistsTitle: "BEREITS VORHANDEN",
    alreadyExistsText: "Es existiert bereits eine Freundschaft oder offene Anfrage.",
    invalidText: "Diese Freundschaftsanfrage konnte nicht gesendet werden.",
    notAllowedTitle: "NICHT ERLAUBT",
    notAllowedText: "Du darfst diesem Nutzer aktuell keine Anfrage senden.",
    errorText: "Beim Senden der Freundschaftsanfrage ist ein Fehler aufgetreten.",
  },
  joinMessage: {
    alreadyStarted: "⛔ Turnier ist bereits gestartet",
    notFound: "❌ Turnier nicht gefunden",
    notJoinable: "⛔ Turnier ist nicht beitretbar",
    saved: "✅ Beitritt gespeichert",
    error: "❌ Fehler beim Beitreten",
  },
  match: {
    notLoggedIn: "Nicht eingeloggt.",
    missingData: "Fehlende Daten (matchId/reportType).",
    enterValidNumbers: "Bitte gültige Zahlen eingeben.",
    noNegativeScores: "Scores dürfen nicht negativ sein.",
    noDrawAllowed: "Bitte trage ein Ergebnis mit eindeutigem Gewinner ein.",
    saveError: "Fehler beim Speichern: {{code}}\n{{message}}",
    notParticipant: "Du bist kein Teilnehmer dieses Matches.",
    cannotConfirmOwnResult: "Du kannst dein eigenes gemeldetes Ergebnis nicht bestätigen.",
    notReported: "Dieses Match ist nicht im Status 'reported'.",
    alreadyDisputed: "Dieses Match wurde bereits angefochten.",
    confirmError: "Fehler beim Bestätigen des Ergebnisses.",
    cannotDisputeOwnResult: "Du kannst dein eigenes gemeldetes Ergebnis nicht ablehnen. Nur dein Gegner kann ablehnen.",
    noLongerReported: "Dieses Match ist nicht mehr im Status 'reported'.",
    disputeError: "Fehler beim Widersprechen",
  },
  result: {
    eliminatedText: "Schade. Du bist leider aus dem Turnier ausgeschieden.",
    wonTitle: "TURNIER GEWONNEN",
    wonText: "Herzlichen Glückwunsch! Du hast das Turnier gewonnen. Dein Gutscheincode wird dir über das VaultQuest-Benachrichtigungssystem zugesandt.",
    secondPlaceText: "Glückwunsch! Du hast den 2. Platz erreicht.",
thirdPlaceText: "Glückwunsch! Du hast den 3. Platz erreicht.",
  },
  resultModal: {
    eliminated: {
      title: "AUSGESCHIEDEN",
      text: "Schade. Du bist leider aus dem Turnier ausgeschieden.",
      thanks: "Danke fürs Mitspielen!",
    },
    third: {
      title: "3. PLATZ",
      text: "Glückwunsch! Du hast den 3. Platz erreicht.",
    },
    second: {
      title: "2. PLATZ",
      text: "Glückwunsch! Du hast den 2. Platz erreicht.",
    },
    winner: {
      title: "TURNIER GEWONNEN",
      text: "Herzlichen Glückwunsch! Du hast das Turnier gewonnen.",
    },
  },
  
  profile: {
    loading: "Lade Profil...",
    notFound: "Profil nicht gefunden.",
  },
  premium: {
    title: "PREMIUM KOMMT BALD 🚀",
    text: "Wir arbeiten aktuell an einem Premium-Abo mit exklusiven Features, besseren Belohnungen und weiteren Vorteilen.\n\nBleib dran – es lohnt sich 👀",
  },
  about: {
    version: "VERSION 1.0",
    text: "VaultQuest ist eine plattformübergreifende Turnierplattform für kompetitives Gaming. Aktuell unterstützt VaultQuest EA SPORTS FC. Weitere Spiele werden Schritt für Schritt ergänzt. Miss dich in Turnieren und Matches mit anderen Spielern und sichere dir Belohnungen. Wir entwickeln VaultQuest kontinuierlich weiter und arbeiten bereits an neuen Features für kommende Updates.",
  },
  lobby: {
    title: "{{time}} UHR - TURNIERLOBBY",
    rulesLine1: "TURNIER-",
    rulesLine2: "REGELN",
    tournamentLobby: "TURNIERLOBBY",
    startIn: "START IN",
    hoursShort: "STD",
    minutesShort: "MIN",
    secondsShort: "SEK",
    viewRules: "REGELN ANSEHEN",
    participants: "TEILNEHMER",
    you: "DU",
    viewProfile: "Profil ansehen",
    addFriend: "Freund hinzufügen",
    reportUser: "Nutzer melden",
    blockUser: "Nutzer blockieren",
    leaveTournament: "TURNIER VERLASSEN",
  },
  notifications: {
    messages: "Nachrichten",
    none: "Du hast aktuell keine Benachrichtigungen.",
    notification: "Benachrichtigung",
    noPreview: "Keine Vorschau verfügbar.",
    content: "Inhalt",
    selectOne: "Wähle links eine Benachrichtigung aus, um sie hier vollständig zu sehen.",
    dateUnavailable: "Datum nicht verfügbar",
    challengeInviteText: "{{name}} hat dich eingeladen.",
    aUser: "Ein Nutzer",
    noContent: "Kein Inhalt verfügbar.",
    stake: "Einsatz: {{amount}} Coins",
    expiresIn: "Läuft ab in: {{time}}",
    statusAccepted: "Status: Einladung angenommen",
    statusDeclined: "Status: Einladung abgelehnt",
    statusExpired: "Status: Einladung abgelaufen",
    statusCancelled: "Status: Einladung abgebrochen",
    statusMissing: "Status: Einladung nicht mehr verfügbar",
    statusError: "Status: Einladung konnte nicht geladen werden",
    processing: "VERARBEITE...",
    friendRequestAccepted: "FREUNDSCHAFTSANFRAGE ANGENOMMEN",
friendRequestDeclined: "FREUNDSCHAFTSANFRAGE ABGELEHNT",
modalConfirm: "VERSTANDEN",
  },
  leaveModal: {
    title: "WILLST DU DIESES TURNIER WIRKLICH VERLASSEN?",
    time: "{{time}} UHR",
    players: "{{count}} TEILNEHMER",
    hint: "⚠️ HINWEIS: WENN DU DAS TURNIER VERLÄSST, BIST DU NICHT MEHR TEILNEHMER UND MUSST GGF. ERNEUT BEITRETEN.",
  },
  rulesModal: {
    title: "TURNIERREGELN",
    ruleFallback: "Regel {{number}}",
    emptyValue: "—",
    noRules: "Für dieses Turnier sind aktuell keine Regeln hinterlegt.",
  },
  deleteAccount: {
    title: "KONTO LÖSCHEN",
    text: "Diese Aktion kann nicht rückgängig gemacht werden.",
    irreversibleHighlight: "nicht rückgängig",
    warningTitle: "WAS PASSIERT, WENN DU DEIN KONTO LÖSCHST:",
    warningProfile: "Dein Profil, Statistiken, Turnierverlauf und Coins gehen verloren.",
    warningFriends: "Deine Freunde, Nachrichten und Einstellungen werden gelöscht.",
    warningProgress: "Du verlierst alle Fortschritte und Ranglisten-Platzierungen.",
    warningEvidence: "Hochgeladene Nachweise und gespeicherte Dateien werden entfernt.",
    warningIrreversible: "Diese Aktion kann nicht rückgängig gemacht werden.",
    passwordLabel: "PASSWORT BESTÄTIGEN",
    passwordPlaceholder: "Bitte gib dein Passwort ein",
    showPassword: "Passwort anzeigen",
    hidePassword: "Passwort verbergen",
    confirmation: "Ich habe verstanden, dass mein Konto und alle Daten dauerhaft gelöscht werden.",
    confirmationHighlight: "dauerhaft gelöscht",
    cancel: "ABBRECHEN",
    confirmDelete: "KONTO LÖSCHEN",
    confirmWithApple: "Mit Apple bestätigen",
    appleConfirmationHint: "Bestätige die endgültige Kontolöschung sicher mit Apple und Face ID. Danach wird die Apple-Verknüpfung widerrufen.",
    iosRequired: "Für Apple-verknüpfte Accounts ist die Kontolöschung derzeit in der VaultQuest-iOS-App erforderlich.",
    passwordRequired: "Bitte bestätige zuerst dein Passwort.",
    reauthFailed: "Die sichere Bestätigung ist fehlgeschlagen. Es wurden keine Daten gelöscht.",
    appleRevokeFailed: "Die Apple-Verknüpfung konnte nicht widerrufen werden. Es wurden keine Daten gelöscht. Bitte versuche es später erneut.",
    error: "Fehler beim Löschen des Kontos.",
    deleting: "LÖSCHE...",
  },
  dailyBonus: {
    title: "Dein täglicher Bonus",
    coins: "Coins",
    streakLabel: "Tage in Folge",
    collect: "Einsammeln",
    disclaimer: "Komme täglich vorbei, um deinen Bonus einzusammeln.",
    dayLabel: "Tag {{day}}",
    collecting: "Wird eingesammelt...",
    alreadyClaimed: "Der heutige Bonus wurde bereits eingesammelt.",
    claimUnavailable: "Der Bonus konnte nicht eingesammelt werden. Bitte lade den aktuellen Status neu.",
    claimError: "Der Bonus konnte nicht eingesammelt werden. Bitte versuche es erneut.",
  },
},


tournaments: {
  days: {
    today: "HEUTE",
    tomorrow: "MORGEN",
  },
  startInfo: {
    today: "HEUTE",
    tomorrow: "MORGEN",
    startsIn: "Startet in {{time}}",
    hoursShort: "Std.",
    minutesShort: "Min.",
  },
  noPrize: "Kein Preis",
  prizePoolLabel: "PREISPOOL",
  common: {
    clock: "UHR",
    participants: "TEILNEHMER",
  },
  overviewTabs: {
    active: "AKTIV",
    mine: "ANGEMELDET",
    favorites: "FAVORITEN",
    planned: "GEPLANT",
    finished: "BEENDET",
  },
  emptyStates: {
    active: "Keine aktiven Turniere.",
    mine: "Keine kommenden eigenen Turniere.",
    favorites: "Du hast noch keine Turniere als Favorit gespeichert.",
    planned: "Keine Turniere für diesen Tag.",
    finished: "Keine kürzlich beendeten Turniere.",
  },
  status: {
    open: "OFFEN",
    finished: "ABGESCHLOSSEN",
    started: "GESTARTET",
    didNotStart: "STARTET NICHT",
    closed: "GESCHLOSSEN",
    invalid: "UNGÜLTIG",
  },
  card: {
    players: "SPIELER",
    clock: "UHR",
    coins: "COINS",
    private: "PRIVAT",
    viewRules: "REGELN ANSEHEN",
    viewAllPrizes: "ALLE PREISE ANZEIGEN",
    joined: "DU BIST BEIGETRETEN",
    joinNotPossible: "BEITRITT NICHT MÖGLICH",
    joinTournament: "TURNIER BEITRETEN",
    followTournament: "TURNIER VERFOLGEN",
    noWinner: "KEIN SIEGER",
  },
  prizesModal: {
    title: "Preise",
    first: "1. Platz",
    second: "2. Platz",
    third: "3. Platz",
    empty: "–",
  },
  success: {
    title: "DU HAST DICH ERFOLGREICH FÜR FOLGENDES TURNIER REGISTRIERT:",
    info: "KURZ VOR TURNIERBEGINN ERHÄLTST DU ÜBER DAS VAULTQUEST-BENACHRICHTIGUNGSSYSTEM DEN NAMEN DEINES GEGNERS. FÜGE DEINEN GEGNER AUF DER KONSOLE HINZU, UM DEIN MATCH ZU STARTEN.",
    backToOverview: "ZURÜCK ZUR ÜBERSICHT",
    showMyTournament: "MEIN TURNIER ANZEIGEN",
    leaveTournament: "TURNIER VERLASSEN",
  },
  joinModal: {
    warning: "BEACHTE BITTE, DASS DER EINSATZ DER COINS BEI DER TURNIERTEILNAHME AUTOMATISCH EINGEZOGEN UND NICHT MEHR ERSTATTET WERDEN KANN!",
  },
  privateJoin: {
    title: "PRIVATES TURNIER",
    text: "Gib den 6-stelligen Turniercode ein, um beizutreten.",
    confirm: "Bestätigen",
    requiredText: "Für dieses private Turnier musst du zuerst den Turniercode eingeben.",
    invalidCode: "Der Code ist ungültig oder gehört nicht zu diesem Turnier.",
  },
  modals: {
    notLoggedInTitle: "NICHT EINGELOGGT",
    notLoggedInText: "Bitte logge dich ein, um einem Turnier beizutreten.",
    joinNotPossibleTitle: "BEITRITT NICHT MÖGLICH",
    alreadyStartedText: "Dieses Turnier ist bereits gestartet.",
    notJoinableText: "Dieses Turnier ist nicht mehr beitretbar.",
    accountBannedTitle: "ACCOUNT GESPERRT",
    accountBannedPermanentText: "Dein Account wurde dauerhaft gesperrt. Eine Teilnahme an Turnieren ist nicht möglich.",
    accountBannedTemporaryText: "Dein Account wurde vorübergehend gesperrt. Eine Teilnahme an Turnieren ist aktuell nicht möglich.",
    alreadyStartedJoinBlockedText: "Das Turnier hat bereits gestartet, ein Beitritt ist nicht mehr möglich.",
    tournamentFullTitle: "TURNIER VOLL",
    tournamentFullText: "Dieses Turnier ist bereits voll.",
    notEnoughCoinsTitle: "NICHT GENUG COINS",
    notEnoughCoinsText: "Du hast nicht genug Coins, um beizutreten.",
    errorTitle: "FEHLER",
    joinErrorText: "Beim Beitreten ist ein Fehler aufgetreten. Bitte erneut versuchen.",
  },
},


tournamentRunning: {
  oClock: "UHR",
  round1: "1. Runde",
  round2: "2. Runde",
  round3: "3. Runde",
round4: "4. Runde",
round5: "5. Runde",
  roundOf16: "Achtelfinale",
  quarterFinal: "Viertelfinale",
  semiFinal: "Halbfinale",
  final: "Finale",
  thirdPlace: "Platz 3",

  tabs: {
    myMatch: "MATCH",
    myTournament: "TURNIER",
    groupStage: "GRUPPENPHASE",
    bracket: "TURNIERBAUM",
    statistics: "STATISTIKEN",
    chat: "CHAT",
    conflict: "KONFLIKT",
    rules: "REGELN",
  },
  playerMatchStates: {
    groupNextMatch: { title: "NÄCHSTES GRUPPENSPIEL WIRD VORBEREITET", text: "Dein nächstes Gruppenspiel wird freigegeben, sobald es spielbereit ist." },
    groupWaiting: { title: "DEINE GRUPPENSPIELE SIND BEENDET", text: "Die übrigen Spiele deiner Gruppe laufen noch. Danach steht deine Platzierung fest." },
    groupRuling: { title: "DEINE PLATZIERUNG WIRD ENTSCHIEDEN", text: "Entscheidungsspiele bestimmen deine endgültige Platzierung. Sobald dein nächstes Entscheidungsspiel bereit ist, wird es hier angezeigt." },
    groupEliminated: { title: "DEINE GRUPPENPHASE IST BEENDET", text: "Du hast dich diesmal nicht für die KO-Phase qualifiziert." },
    qualifiedFirstKoWaiting: { title: "DU BIST FÜR DIE KO-PHASE QUALIFIZIERT", text: "Dein Gegner wird noch ermittelt. Sobald die Paarung feststeht, wird dein erstes KO-Match vorbereitet." },
    nextMatchKnown: { title: "DEIN NÄCHSTES MATCH STEHT FEST", text: "Dein Gegner steht fest. Der Check-in wird in Kürze geöffnet." },
    nextRoundWaiting: { title: "DU BIST EINE RUNDE WEITER!", text: "Dein Gegner wird noch ermittelt. Sobald die Paarung feststeht, wird dein Match vorbereitet." },
    koRoundWaiting: { title: "DU BIST EINE RUNDE WEITER!", text: "Dein Gegner wird noch ermittelt. Sobald die Paarung feststeht, wird dein Match vorbereitet." },
    quarterfinalWaiting: { title: "DU STEHST IM VIERTELFINALE!", text: "Dein Gegner wird noch ermittelt. Sobald die Paarung feststeht, wird dein Match vorbereitet." },
    semifinalWaiting: { title: "DU STEHST IM HALBFINALE!", text: "Dein Gegner wird noch ermittelt. Sobald die Paarung feststeht, wird dein Match vorbereitet." },
    finalWaiting: { title: "DU STEHST IM FINALE!", text: "Dein Finalgegner wird noch ermittelt. Sobald die Paarung feststeht, wird dein Match vorbereitet." },
    bronzeWaiting: { title: "DU SPIELST UM PLATZ 3.", text: "Dein Gegner wird noch ermittelt. Sobald die Paarung feststeht, wird dein Match vorbereitet." },
    activeSeries: { title: "DEINE BEGEGNUNG LÄUFT NOCH", text: "Ein weiteres Spiel dieser Begegnung steht noch aus. Erst danach steht fest, wer die nächste Runde erreicht." },
    disqualified: { title: "DISQUALIFIZIERT", text: "Du bist aufgrund der Check-in-Regeln aus dieser Begegnung ausgeschieden." },
    knockoutEliminated: { title: "DEIN TURNIER IST BEENDET", text: "Du bist aus der KO-Phase ausgeschieden." },
    tournamentWinner: { title: "DU HAST DAS TURNIER GEWONNEN!", text: "Das Finale ist beendet. Herzlichen Glückwunsch zum Turniersieg!" },
    tournamentRunnerUp: { title: "DU BIST ZWEITER!", text: "Das Finale ist beendet. Du hast den zweiten Platz erreicht." },
    thirdPlace: { title: "DU HAST PLATZ 3 ERREICHT!", text: "Dein Spiel um Platz 3 ist beendet." },
    tournamentCompleted: { title: "DEIN TURNIER IST BEENDET", text: "Für dich steht kein weiteres Match an." },
    tournamentNotContinued: { title: "DAS TURNIER KONNTE NICHT FORTGESETZT WERDEN", text: "Aus dem terminalen Turnierbaum konnte kein gültiger Turniersieger mehr ermittelt werden." },
    noCurrentMatch: { title: "DU HAST AKTUELL KEIN MATCH", text: "Sobald ein neues Match für dich feststeht, wird es hier angezeigt." },
  },
  groupStage: {
    group: "Gruppe",
    matchDay: "Spieltag",
    noGroups: "Die Gruppenphase wird vorbereitet.",
    nextMatchWaiting: "Dein nächstes Gruppenmatch wird vorbereitet. Der Gegner ist noch nicht bereit.",
    knockoutOpponentWaiting: "Herzlichen Glückwunsch zum Erreichen der K.O.-Phase. Dein Gegner wird dir gleich zugeteilt.",
    waitingStates: {
      nextMatchPending: {
        title: "NÄCHSTES GRUPPENSPIEL WIRD VORBEREITET",
        text: "Dein nächstes Gruppenspiel wird freigegeben, sobald es spielbereit ist.",
      },
      ownMatchesComplete: {
        title: "DEINE GRUPPENSPIELE SIND BEENDET",
        text: "Die übrigen Spiele deiner Gruppe laufen noch. Sobald die Gruppe abgeschlossen ist, steht fest, ob du die KO-Phase erreicht hast.",
      },
      qualifiedKoPending: {
        title: "DU BIST FÜR DIE KO-PHASE QUALIFIZIERT",
        text: "Deine Gruppe ist abgeschlossen. Dein erstes KO-Match wird freigegeben, sobald die Paarung vollständig feststeht.",
      },
      groupCompleteEliminated: {
        title: "DEINE GRUPPENPHASE IST BEENDET",
        text: "Du hast die KO-Phase leider nicht erreicht.",
      },
      ownTiebreakerPending: {
        title: "ENTSCHEIDUNGSSPIEL AUSSTEHEND",
        text: "Deine Platzierung ist noch nicht entschieden. Dein nächstes Entscheidungsspiel wird freigegeben, sobald es spielbereit ist.",
      },
      qualificationDecisionPending: {
        title: "ENTSCHEIDUNG IN DEINER GRUPPE OFFEN",
        text: "Die regulären Gruppenspiele sind beendet. Zusätzliche Entscheidungsspiele müssen noch die endgültige Platzierung klären.",
      },
      openGroupConflict: {
        title: "ENTSCHEIDUNG ZUM GRUPPENSPIEL OFFEN",
        text: "Ein Ergebnis deines Gruppenspiels wird noch geprüft. Deine Gruppenphase ist erst nach der Entscheidung abgeschlossen.",
      },
    },
    thirdPlaceWaiting: "Dein Spiel um Platz 3 wird vorbereitet.",
    tournamentComplete: "Für dich steht kein weiteres Match an.",
    eliminated: "Du bist aus dem Turnier ausgeschieden.",
    doubleNoShowEliminated: "Du bist ausgeschieden. Du und dein Gegner habt den Check-in verpasst.",
    matches: "Gruppenspiele",
    noMatches: "Für diese Gruppe sind noch keine Spiele vorhanden.",
    tableView: "Tabelle",
    detailedTable: "Detaillierte Tabelle",
    qualified: "Qualifiziert",
    decisionTitle: "Rulings",
    decisionDescription: "Bei Gleichstand absolvieren die betroffenen Spieler zusätzliche Ruling Games, bis die Platzierung geklärt ist.",
    decisionRound: "Ruling Round",
    decisionMatches: "Ruling Games",
    status: {
      notStarted: "Noch nicht gestartet",
      scheduled: "Angesetzt",
      checkIn: "Check-in",
      running: "Läuft",
      completed: "Abgeschlossen",
      invalid: "Ungültig",
      bye: "Spielfrei",
    },
    table: {
      rank: "Platz",
      player: "Spieler",
      played: "Spiele",
      wins: "Siege",
      losses: "Niederlagen",
      goalsFor: "Tore",
      goalsAgainst: "Gegentore",
      goalDifference: "Diff.",
      points: "Punkte",
    },
  },
  statistics: {
    playedMatches: "Gespielte Matches",
    totalGoals: "Tore insgesamt",
    topScorer: "Meiste Tore eines Users",
    biggestWin: "Höchster Sieg",
    conflicts: "Anzahl Konflikte",
    refunds: "Anzahl Refunds",
    noData: "—",
  },
  bracket: {
    jumpToMyMatch: "📍 ZU MEINEM MATCH",
    noMatch: "Match wird vorbereitet",
    checkInHints: {
      missingSuffix: "nicht eingecheckt",
      neither: "Beide nicht eingecheckt",
    },
    status: {
      waiting: "Wartet",
      running: "Läuft",
      reported: "Gemeldet",
      disputed: "Konflikt",
      finished: "Abgeschlossen",
      cancelled: "Abgebrochen",
      checkIn: "Check-in",
      decisionRequired: "TIE-BREAKER AUSSTEHEND",
      decisionCheckIn: "TIE-BREAKER · CHECK-IN",
      decisionActive: "TIE-BREAKER",
      noShow: "No-Show",
      rageQuit: "Rage Quit",
      disqualified: "Disqualifiziert",
      void: "Ungültig",
      doubleNoShow: "Double No-Show",
      bye: "Freilos",
    },
    legend: {
      finished: "Beendet",
      running: "Läuft",
      waiting: "Wartet",
      bye: "Freilos",
    },
  },

  matchStart: "SPIELBEGINN",
  opponent: "Gegner",
  you: "DU",
  tournamentContinues: "TURNIER LÄUFT WEITER...",
  opponentBeingDetermined: "GEGNER WIRD ERMITTELT...",
  eliminatedHint: "DU KANNST DEN TURNIERVERLAUF WEITERHIN UNTER „TURNIER“ MITVERFOLGEN.",
  liveNow: "LÄUFT JETZT...",
  latestReportTime: "SPÄTESTE MELDEZEIT:",
  earliestReportTime: "FRÜHESTE MELDEZEIT",
  reportingAllowedFrom: "Ergebnis melden möglich ab",
  reportedResult: "GEMELDETES ERGEBNIS",

  status: {
  eliminated: "STATUS: DU BIST AUSGESCHIEDEN",
  opponentSoon: "STATUS: DEIN GEGNER WIRD GERADE ERMITTELT",
  yourMatchAgainst: "STATUS: DEIN MATCH GEGEN",
  invalid: "STATUS: TURNIER UNGÜLTIG",
  firstPlace: "GLÜCKWUNSCH! DU HAST DAS TURNIER GEWONNEN",
secondPlace: "GLÜCKWUNSCH! DU HAST DEN 2. PLATZ ERREICHT",
thirdPlace: "GLÜCKWUNSCH! DU HAST DEN 3. PLATZ ERREICHT",
},

  viewProfile: "PROFIL ANSEHEN",
  addFriend: "FREUND ADDEN",
  opponentIdHint:
  "Hier kannst du die EA-ID/Konsolen-ID deines Gegners einsehen.",

  conflictReasonNoReport: "KONFLIKTGRUND: KEINE ERGEBNISMELDUNG",
  reporterMissedDeadline: "REPORTER HAT BIS ZUR MELDEFRIST KEIN ERGEBNIS GEMELDET",
  rageQuitReported: "RAGE QUIT GEMELDET:",
  leftTheMatch: "HAT DAS SPIEL VERLASSEN",
  connectionIssuesReported: "VERBINDUNGSPROBLEME GEMELDET:",
  disconnectedAt: "ABGEBROCHEN IN:",
  minute: "MINUTE",
  opponentDidNotAppear: "GEGNER NICHT ERSCHIENEN",
  reportedAgainAfterPresence: "ERNEUT GEMELDET NACH BESTÄTIGTER ANWESENHEIT",
  noShowReported: "NO-SHOW GEMELDET",
  reportType: "REPORTTYP",
  reporter: "REPORTER",
  reportedBy: "GEMELDET VON",
  dual: {
    you: "DU",
    opponent: "GEGNER",
    reportedBy: "GEMELDET VON",
    yourReport: "DEINE MELDUNG",
    opponentReportedResultDecision:
      "DEIN GEGNER HAT BEREITS EIN ERGEBNIS GEMELDET.",
    opponentReportedRageQuitDecision:
      "DEIN GEGNER HAT BEREITS EINEN RAGE QUIT GEMELDET.",
    opponentReportedConnectionDecision:
      "DEIN GEGNER HAT BEREITS VERBINDUNGSPROBLEME GEMELDET.",
    confirmResult: "ERGEBNIS BESTÄTIGEN",
    confirmRageQuit: "RAGE QUIT BESTÄTIGEN",
    confirmConnectionIssue: "VERBINDUNGSPROBLEME BESTÄTIGEN",
    submitDifferentReport: "ANDERE MELDUNG ABGEBEN",
    connectionEvidenceHint:
      "WICHTIG: ERSTELLE JETZT BEREITS FOTOS DES ENDERGEBNISSES INKLUSIVE TEAMNAMEN UND EA-/KONSOLEN-ID. FALLS ES IM RESUME-MATCH ERNEUT ZU PROBLEMEN ODER UNTERSCHIEDLICHEN ANGABEN KOMMT, BENÖTIGST DU DIESE BEWEISBILDER.",
    responseCountdownLabel:
      "ZEIT, UM DAS ERGEBNIS ZU BESTÄTIGEN ODER EIN ANDERES ERGEBNIS ZU MELDEN:",
    reporterResponseCountdownLabel:
      "DEIN GEGNER HAT NOCH ZEIT, UM AUF DEINEN REPORT ZU REAGIEREN:",
    waitForOpponent:
      "DU HAST DEIN ERGEBNIS GEMELDET. WARTE, BIS DEIN GEGNER EBENFALLS EIN ERGEBNIS GEMELDET HAT.",
    opponentReported: "DEIN GEGNER HAT FOLGENDES ERGEBNIS GEMELDET:",
    resultReported: "ERGEBNIS GEMELDET",
    rageQuit: "RAGE QUIT",
    rageQuitBy: "RAGE QUIT VON {{username}}",
    leftMatch: "{{username}} HAT DAS SPIEL VERLASSEN",
    rageQuitReportedBy: "{{username}} hat einen Rage Quit gemeldet.",
    reportedRageQuitPlayer: "Rage Quit von",
    connectionIssue: "VERBINDUNGSPROBLEME",
    connectionIssueMinute: "VERBINDUNGSPROBLEM IN MINUTE {{minute}}",
    minute: "{{minute}}. MINUTE",
    waiting: "KEIN ERGEBNIS GEMELDET",
    autoConfirmed: "ERGEBNIS AUTOMATISCH BESTÄTIGT",
    conflictOpened: "KONFLIKTFALL ERÖFFNET",
    resumeCreated: "RESUME-MATCH ERSTELLT BZW. MATCH WURDE FORTGESETZT",
    processing: "BEIDE ERGEBNISSE WURDEN GEMELDET. DIE AUSWERTUNG LÄUFT.",
  },

  conflictCaseOpened: "KONFLIKTFALL ERÖFFNET",
  conflictStatusOpen: "OFFEN",
  conflictStatusInReview: "IN BEARBEITUNG",
  conflictStatusDone: "ERLEDIGT",
  conflictStatusReason: "Grund",
  conflictInfoText:
    "Ein Konfliktfall wurde erstellt und wird manuell geprüft. Bitte fertige Fotos des Ergebnisses (Teamname + ID) an und lade sie hoch.",
  playerReports: "Meldungen der Spieler",
  conflictCreatedHint: "EIN KONFLIKTFALL WURDE ERSTELLT UND WIRD MANUELL GEPRÜFT. BITTE FERTIGE FOTOS DES ERGEBNISSES (TEAMNAME + ID) UND LADE SIE HOCH.",
  conflictReasons: {
    scoreWinnerMismatch: "Die gemeldeten Ergebnisse stimmen nicht überein.",
    scoreRageQuitMismatch:
      "Das gemeldete Ergebnis passt nicht zur Rage-Quit-Meldung.",
    scoreConnectionIssueMismatch:
      "Ein Spieler meldet ein Endergebnis, der andere einen Spielabbruch.",
    rageQuitLoserMismatch: "Beide Spieler melden unterschiedliche Spieler als Verlierer.",
    rageQuitConnectionIssueMismatch:
      "Eine Meldung beschreibt einen Rage Quit, die andere Verbindungsprobleme.",
    invalidConnectionIssueReport:
      "Die Angaben zum Spielabbruch sind unvollständig oder ungültig.",
    connectionIssueScoreMismatch:
      "Die gemeldeten Spielstände beim Verbindungsabbruch stimmen nicht überein.",
    connectionIssueMinuteMismatch:
      "Die gemeldeten Minuten des Spielabbruchs stimmen nicht überein.",
    unsupportedCombination:
      "Die beiden Meldungen können nicht automatisch zusammengeführt werden.",
    dualReportConflict:
      "Die beiden Meldungen widersprechen sich und müssen geprüft werden.",
    repeatConnectionIssue:
      "Es wurden erneut Verbindungsprobleme gemeldet. Das Match wird geprüft.",
    repeatNoShow:
      "Es wurde erneut gemeldet, dass ein Spieler nicht erschienen ist.",
    reportTimeout:
      "Es wurde innerhalb der Meldefrist kein Ergebnis eingetragen.",
  },
  conflictUi: {
    title: "KONFLIKTFALL",
    emptyState: "Für dieses Match wurde aktuell kein Konfliktfall erstellt.",
    collectingTitle: "BEWEISE WERDEN GESAMMELT",
    reviewReadyTitle: "ZUR PRÜFUNG VORGELEGT",
    inReviewTitle: "IN BEARBEITUNG",
    reviewReadyText: "Der Konfliktfall wurde zur Prüfung an einen Admin weitergeleitet. Bitte warte, bis der Admin den Fall geprüft hat.",
    inReviewText: "Ein Admin prüft deinen Konfliktfall aktuell. Bitte warte auf die Entscheidung.",
    doneText: "Dieser Konfliktfall wurde entschieden.",
    evidenceDeadline: "BEWEISFRIST",
    bothSubmittedText: "Beide Spieler haben ihre Beweisabgabe abgeschlossen.\nDer Konfliktfall wurde zur Prüfung an einen Admin weitergeleitet.\nBitte warte, bis der Admin den Fall geprüft hat.",
    deadlineExpiredText: "Die Beweisfrist ist abgelaufen.\nDer Konfliktfall wurde zur Prüfung an einen Admin weitergeleitet.\nBitte warte, bis der Admin den Fall geprüft hat.",
    yourEvidence: "DEINE BELEGE",
    yourSubmissionCompleted: "DEINE BEWEISABGABE WURDE ABGESCHLOSSEN ✓",
    opponentEvidence: "BEWEISABGABE DES GEGNERS",
    yourReport: "DEINE MELDUNG",
    opponentReport: "MELDUNG DES GEGNERS",
    postReadyTimeline: {
      absence_report: { title: "MELDUNG VON {{username}}", text: "{{username}} als abwesend gemeldet" },
      presence_confirmation: { title: "REAKTION VON {{username}}", text: "Anwesenheit bestätigt" },
      repeat_absence_report: { title: "ERNEUTE MELDUNG VON {{username}}", text: "{{username}} erneut als abwesend gemeldet" },
      presence_timeout: { title: "ANWESENHEITSFRIST ABGELAUFEN", text: "{{username}} hat die Anwesenheit nicht rechtzeitig bestätigt" },
    },
    noReport: "Keine Meldung abgegeben",
    scoreReport: "Ergebnis: {{score}}",
    rageQuitByTitle: "RAGE QUIT DURCH",
    rageQuitConflictSummary: "Rage Quit durch {{username}}",
    connectionIssueTitle: "VERBINDUNGSPROBLEM",
    connectionIssueMinuteLine: "In der {{minute}}. Spielminute",
    connectionIssueScoreIntro: "bei einem Spielstand von:",
    rageQuitOpponent: "Rage Quit – Gegner hat das Spiel verlassen",
    rageQuitSelf: "Rage Quit – du hast das Spiel verlassen",
    rageQuitBy: "Rage Quit durch: {{username}}",
    connectionIssueReport: "Verbindungsproblem in Minute {{minute}} bei {{score}}",
    connectionIssueReportNoMinute: "Verbindungsproblem bei {{score}}",
    open: "OFFEN",
    submitted: "ABGESCHLOSSEN ✓",
    image: "Bild",
    evidenceDeadlineHint: "Du hast bis zum Ablauf der Beweisfrist Zeit, deine Belege hochzuladen.",
    noImageHint: "Du solltest nach Möglichkeit Bildbelege hochladen. Kommentare dienen nur als zusätzliche Erklärung und ersetzen keine Bildbelege.",
    photoUploadFailed: "Foto konnte nicht hochgeladen werden. Bitte versuche es erneut.",
    waitForPhotoUpload: "Bitte warte, bis deine Fotos vollständig hochgeladen wurden.",
    commentTitle: "ZUSÄTZLICHER KOMMENTAR",
    commentHelp: "Du kannst zusätzliche Informationen zum Konflikt angeben. Kommentare dienen nur als Erklärung und ersetzen keine Bildbelege.",
    saveComment: "KOMMENTAR SPEICHERN",
    autosaving: "Kommentar wird gespeichert...",
    autosaved: "Kommentar gespeichert.",
    saving: "SPEICHERT...",
    commentSaved: "Kommentar gespeichert.",
    commentSavedQuiet: "GESPEICHERT ✓",
    commentSaveError: "Kommentar konnte nicht gespeichert werden.",
    finishButton: "BEWEISABGABE ABSCHLIESSEN",
    finishing: "SCHLIESST AB...",
    finishConfirm: "Möchtest du deine Beweisabgabe abschließen?\n\nDanach kannst du keine weiteren Bilder oder Kommentare hinzufügen oder ändern.",
    finishWithoutImageConfirm: "Du hast keine Bildbelege hochgeladen.\n\nKommentare dienen nur als zusätzliche Erklärung und ersetzen keine Bildbelege.\n\nMöchtest du deine Beweisabgabe wirklich ohne Bildbelege abschließen?",
    finishModalTitle: "BEWEISABGABE ABSCHLIESSEN",
    finishModalText: "Möchtest du deine Beweisabgabe abschließen?\n\nDanach kannst du keine weiteren Bilder oder Kommentare hinzufügen oder ändern.",
    finishModalCancel: "ABBRECHEN",
    finishModalConfirm: "BEWEISABGABE ABSCHLIESSEN",
    finishWithoutImageTitle: "OHNE BILDBELEGE ABSCHLIESSEN?",
    finishWithoutImageText: "Du hast keine Bildbelege hochgeladen.\n\nKommentare dienen nur als zusätzliche Erklärung und ersetzen keine Bildbelege.\n\nMöchtest du deine Beweisabgabe wirklich ohne Bildbelege abschließen?",
    finishWithoutImageBack: "ZURÜCK",
    finishWithoutImageConfirmButton: "TROTZDEM ABSCHLIESSEN",
    submissionFinished: "Beweisabgabe abgeschlossen.",
    finishError: "Beweisabgabe konnte nicht abgeschlossen werden.",
    yourStatus: "Deine Beweisabgabe",
    matchTabHint: "Für dieses Match wurde ein Konfliktfall erstellt. Details zum Konflikt und die Möglichkeit, Belege einzureichen, findest du im Tab „Konflikt“.",
    goToConflict: "ZUM KONFLIKT",
    reasons: {
      resultDispute: "Widersprüchliche Ergebnismeldungen",
      reportTimeout: "Keine Ergebnismeldung innerhalb der Meldefrist",
      connectionIssue: "Verbindungsproblem",
      repeatConnectionIssue: "Wiederholtes Verbindungsproblem",
      repeatNoShow: "Gegner trotz Anwesenheitsbestätigung nicht erschienen",
      rageQuit: "Rage Quit",
      generic: "Konfliktfall",
    },
    explanations: {
      resultDispute: "Die Ergebnismeldungen stimmen nicht überein. Reiche Belege ein, die das tatsächliche Spielergebnis zeigen.",
      reportTimeout: "Bis zum Ablauf der Meldefrist wurde kein Ergebnis bestätigt. Beide Spieler können jetzt Belege zum Matchverlauf einreichen.",
      connectionIssue: "Es wurde ein Verbindungsproblem gemeldet. Reiche Belege ein, die den Spielstand und den Matchverlauf nachvollziehbar machen.",
      repeatConnectionIssue: "Es wurden erneut Verbindungsprobleme gemeldet. Reiche Belege ein, die den Matchverlauf nachvollziehbar machen.",
      repeatNoShow: "Ein Spieler wurde nach bestätigter Anwesenheit erneut als nicht erschienen gemeldet. Reiche Belege zum Matchverlauf ein.",
      rageQuit: "Es wurde ein Rage Quit gemeldet. Reiche Belege ein, die den Matchverlauf und das Ergebnis zeigen.",
      generic: "Dieser Konfliktfall wird geprüft. Reiche Belege ein, die den Matchverlauf nachvollziehbar machen.",
    },
  },
  uploadTimeRemaining: "Upload-Zeit verbleibend",
  uploadTimeExpired: "UPLOAD-ZEIT ABGELAUFEN",
  selectImages: "BILDER AUSWÄHLEN",
  addPhotos: "FOTOS HINZUFÜGEN",
  uploadingPhotos: "FOTOS WERDEN HOCHGELADEN...",
  maxAmountReached: "MAXIMALE ANZAHL ERREICHT",
  uploadPhotos: "FOTOS HOCHLADEN",
  photoUpload: "FOTO HOCHLADEN",
  supportedEvidenceFormats: "Unterstützte Formate: JPG, PNG - Max. 10 MB",
  imagesUploaded: "BILDER HOCHGELADEN",
  selected: "AUSGEWÄHLT",
  remove: "Entfernen",

  waitForPresenceConfirmation: "WARTE, BIS DEIN GEGNER SEINE ANWESENHEIT BESTÄTIGT HAT",
  reportResult: "ERGEBNIS MELDEN",
  waitForOpponentReport: "WARTE AUF DEN REPORT DEINES GEGNERS",
  waitForOpponentAgreement: "BITTE WARTE, BIS DEIN GEGNER DEM ERGEBNIS ZUGESTIMMT HAT",
  automaticDecisionIn: "AUTOMATISCHE ENTSCHEIDUNG IN",
  lastChance: "LETZTE CHANCE",
  responseTime: "ANTWORTZEIT",
  confirmResult: "ERGEBNIS BESTÄTIGEN",
  rejectResult: "ERGEBNIS ABLEHNEN",
  noCurrentMatch: "DU HAST AKTUELL KEIN MATCH",

  noMatchesInThisRound: "NOCH KEINE MATCHES IN DIESER RUNDE",
  bye: "Freilos",
  myMatchTitle: "Dein Match",
  vs: "vs",
  invalid: "UNGÜLTIG",

  matchReportTitle: "MATCH-REPORT",
  scoreEntrySubtitle: "Endergebnis eintragen",
  matchReportSubtitle: "Was ist in diesem Match passiert?",
  matchReportCards: {
    a: { title: "Ergebnis melden", description: "Korrektes Endergebnis eintragen" },
    b: { title: "Wir spielen noch", description: "Gibt euch 10 Minuten mehr Zeit" },
    c: { title: "Gegner nicht erschienen", description: "Mein Gegner ist nicht zum Match erschienen" },
    d: { title: "Rage Quit", description: "Mein Gegner hat das Match vorzeitig verlassen" },
    e: { title: "Verbindungsprobleme", description: "Das Match konnte wegen Verbindungsproblemen nicht regulär beendet werden" },
  },
  selectMatchingOption: "BITTE WÄHLE DIE ZUTREFFENDE OPTION AUS...",
  player1: "Spieler 1",
  player2: "Spieler 2",
  unknownPlayer: "Unbekannter Spieler",
  sendResult: "ERGEBNIS SENDEN",
  option: "OPTION",

  options: {
    a: "ERGEBNIS EINTRAGEN",
    b: "WIR SPIELEN NOCH - ERGEBNIS FOLGT",
    c: "MEIN GEGNER IST NICHT ERSCHIENEN",
    d: "RAGE QUIT",
    e: "VERBINDUNGSPROBLEME",
  },

  whoLeftTheMatch: "WER HAT DAS SPIEL VERLASSEN?",
  rageQuitSelectionSubtitle: "Wähle den betreffenden Spieler aus.",
  rageQuitOpponentLabel: "DEIN GEGNER",
  me: "ICH",
  myOpponent: "MEIN GEGNER",
  cancel: "ABBRECHEN",

  connectionIssues: "VERBINDUNGSPROBLEME",
  gameMinute: "SPIELMINUTE",
  whichMinuteDisconnected: "IN WELCHER SPIELMINUTE IST DIE VERBINDUNG ABGEBROCHEN?",
  whatWasTheScore: "WIE WAR DER SPIELSTAND?",
  send: "SENDEN",

  readyToPlay: "SPIELBEREIT?",
  opponentSaysNoShow: "DEIN GEGNER MELDET, DASS DU NICHT ERSCHIENEN BIST.",
  iAmReadyToPlay: "ICH BIN SPIELBEREIT",
presenceConfirmedTitle: "ANWESENHEIT BESTÄTIGT",
opponentConfirmed: "DEIN GEGNER HAT SEINE ANWESENHEIT BESTÄTIGT. BITTE VERSUCHT NUN ERNEUT, EUER MATCH ZU STARTEN.",



  connectionResumeTitle: "WIEDERHOLUNGSSPIEL",
resumeContinueUntil: "SPIELT BIS ZUR",
resumeMinute: "MINUTE",
resumeIfDraw: "FALLS DANACH GLEICHSTAND HERRSCHT:",
resumePlayFullExtraTime: "SPIELT INKLUSIVE VERLÄNGERUNG UND ELFMETERSCHIESSEN ZU ENDE.",
resumePlay: "SPIELT WEITERE",
resumeMoreMinutes: "MINUTEN",
currentScore: "AKTUELLER SPIELSTAND",
continue: "WEITER",
firstMatch: "ERSTES SPIEL",
finalResult: "FINALES ERGEBNIS",
game1: "SPIEL 1",
game2: "SPIEL 2",
total: "GESAMT",
resumeMatchHint:
  "WICHTIG: GIB NUR DAS ERGEBNIS DIESES SPIELS EIN. DAS VORHERIGE ERGEBNIS WIRD AUTOMATISCH ADDIERT.",

  resumeEvidence: {
  title: "WICHTIGER HINWEIS",
  text:
    "Bitte erstellt jetzt Screenshots oder Fotos des Ergebnisses des ersten Spiels (Verbindungsabbruch-Spiel). Falls es später zu einem Konflikt kommt, können diese Bilder als Beweise benötigt werden. Ohne entsprechende Beweise kann eine Entscheidung erschwert werden.",
  confirm: "VERSTANDEN",
},

resumeInstructions: {
  leading:
    "Das Spiel wurde in der {{minute}}. Minute bei einem Spielstand von {{scoreP1}}:{{scoreP2}} für {{leader}} abgebrochen. Spielt ein neues Spiel bis zur {{targetMinute}}. Minute. Sollte {{trailingPlayer}} ausgleichen, spielt das Spiel inklusive Verlängerung und Elfmeterschießen zu Ende.",

  draw:
    "Das Spiel wurde in der {{minute}}. Minute bei einem Spielstand von {{scoreP1}}:{{scoreP2}} abgebrochen. Spielt ein neues Spiel bis zur {{targetMinute}}. Minute. Sollte immer noch Gleichstand sein, spielt das Spiel inklusive Verlängerung und Elfmeterschießen zu Ende.",
},

  alerts: {
    maxEvidenceImages: "Du kannst maximal 3 Beweisbilder hochladen.",
    enterBothScores: "Bitte trage beide Scores ein (0 ist erlaubt).",
    extensionNotPossible: "Verlängerung nicht möglich.",
    validMinute: "Bitte eine gültige Spielminute von 1 bis 120 eintragen.",
    validScores: "Bitte gültige Scores eingeben.",
    saveError: "Fehler beim Speichern. Bitte erneut versuchen.",
    confirmError: "Fehler beim Bestätigen.",
    confirmDeadlineExpired: "Die Frist zur Bestätigung ist abgelaufen.",
    confirmAlreadyProcessed: "Dieses Ergebnis wurde bereits verarbeitet.",
    confirmLifecycleChanged: "Der Matchzustand hat sich geändert. Bitte lade das Match neu.",
    confirmConflict: "Für dieses Match besteht bereits ein Konfliktfall.",
    selectAtLeastOneImage: "Bitte wähle mindestens ein Bild aus.",
    photosUploaded: "Fotos erfolgreich hochgeladen.",
    uploadDeadlineExpired: "Die Upload-Frist ist abgelaufen.",
    alreadyUploadedThree: "Du hast bereits drei Bilder hochgeladen.",
    photoUploadError: "Fehler beim Hochladen der Fotos.",
  },
},

singleGames: {
  stake: {
    title: "COINS FÜR DAS MATCH WÄHLEN",
    subtitle: "Wähle die Anzahl der Coins, die du für dieses Match einsetzen möchtest.",
    levels: {
      0: { title: "NIEDRIGER EINSATZ", description: "Play It Safe." },
      1: { title: "MITTLERER EINSATZ", description: "Raise The Stakes." },
      2: { title: "HOHER EINSATZ", description: "High Risk. High Reward." },
    },
  },
 mode: {
  title: "WÄHLE BITTE AUS, OB DU EINE/N FREUND/IN HERAUSFORDERN ODER EIN FREIES SPIEL SUCHEN MÖCHTEST",
  challengeFriend: "EINEN FREUND HERAUSFORDERN",
  searchFreeGame: "FREIES SPIEL SUCHEN",
  random: "ZUFÄLLIGER GEGNER",
  friend: "FREUND",
},
confirm: "BESTÄTIGEN",
friendLimitTitle: "LIMIT ERREICHT",
friendLimitText: "Du kannst nur 3 Freundschaftsspiele pro Tag spielen.",
friendLimitCounter: "Freundschaftsspiele heute",
limitReached: "LIMIT ERREICHT",
  queue: {
    searchingOpponent: "SUCHE GEGNER",
    cancelSearch: "SUCHE ABBRECHEN",
  },
  challenge: {
    title: "GIB DEN BENUTZERNAMEN EIN, DEN DU HERAUSFORDERN MÖCHTEST",
    usernamePlaceholder: "Benutzername eingeben",
    stakeLabel: "Einsatz: {{stake}} Coins",
    checkingUser: "PRÜFE BENUTZER...",
    challengeFriend: "FREUND HERAUSFORDERN",
  },
  modals: {
    ok: "OK",
    alreadyFriendsTitle: "BEREITS BEFREUNDET",
    alreadyFriendsText: "Ihr seid bereits befreundet.",
    friendRequestPendingTitle: "ANFRAGE BEREITS GESENDET",
    friendRequestPendingText: "Es existiert bereits eine offene Freundschaftsanfrage.",
    friendRequestSentTitle: "FREUNDSCHAFTSANFRAGE GESENDET",
    friendRequestSentText: "Die Freundschaftsanfrage wurde erfolgreich gesendet.",
    alreadyExistsTitle: "BEREITS VORHANDEN",
    alreadyExistsText: "Es existiert bereits eine Freundschaft oder offene Anfrage.",
    notPossibleTitle: "NICHT MÖGLICH",
    friendRequestNotPossibleText: "Diese Freundschaftsanfrage konnte nicht gesendet werden.",
    notAllowedTitle: "NICHT ERLAUBT",
    friendRequestNotAllowedText: "Du darfst diesem Nutzer aktuell keine Anfrage senden.",
    errorTitle: "FEHLER",
    friendRequestErrorText: "Beim Senden der Freundschaftsanfrage ist ein Fehler aufgetreten.",
    usernameMissingTitle: "BENUTZERNAME FEHLT",
    usernameMissingText: "Bitte gib einen Benutzernamen ein.",
    accountLoadErrorText: "Dein Account konnte nicht geladen werden. Bitte erneut versuchen.",
    userNotFoundTitle: "BENUTZER NICHT GEFUNDEN",
    userNotFoundText: "Es wurde kein Benutzer mit diesem Benutzernamen gefunden.",
    usernameResolveErrorText: "Der Benutzername konnte nicht korrekt aufgelöst werden. Bitte erneut versuchen.",
    notFriendTitle: "KEIN FREUND",
    notFriendText: "Dieser Benutzer befindet sich nicht in deiner Freundesliste.",
    cannotChallengeSelfText: "Du kannst dich nicht selbst herausfordern.",
    challengeSentTitle: "HERAUSFORDERUNG GESENDET",
    challengeSentText: "Die Herausforderung an {{username}} wurde erfolgreich gesendet.",
    accountBannedTitle: "ACCOUNT GESPERRT",
    accountTemporarilyBannedUntilText: "Dein Account wurde vorübergehend gesperrt. Eine Teilnahme ist bis {{date}} nicht möglich.",
    accountTemporarilyBannedText: "Dein Account wurde vorübergehend gesperrt. Eine Teilnahme an Einzelspielen ist aktuell nicht möglich.",
    challengeAlreadyOpenTitle: "HERAUSFORDERUNG BEREITS OFFEN",
    challengeAlreadyOpenText: "An diesen Freund wurde bereits eine offene Herausforderung gesendet.",
    notEnoughCoinsTitle: "NICHT GENUG COINS",
    notEnoughCoinsChallengeText: "Du hast nicht genug Coins, um diese Herausforderung zu senden.",
    selectedUserNotFoundText: "Der ausgewählte Benutzer konnte nicht gefunden werden.",
    challengeSendErrorText: "Beim Senden der Herausforderung ist ein Fehler aufgetreten. Bitte erneut versuchen.",
    accountPermanentlyBannedText: "Dein Account wurde dauerhaft gesperrt. Eine Teilnahme an Einzelspielen ist nicht möglich.",
    notEnoughCoinsSingleGameText: "Du hast nicht genug Coins, um ein Einzelspiel zu starten.",
    startGameErrorText: "Beim Starten des Spiels ist ein Fehler aufgetreten. Bitte erneut versuchen.",
    cancelSearchErrorText: "Die Spielsuche konnte nicht korrekt abgebrochen werden. Bitte erneut versuchen.",
    queueJoinErrorText:
  "Die Spielsuche konnte nicht gestartet werden. Bitte überprüfe deine Internetverbindung und versuche es erneut.",
  },
},



singleMatch: {
  you: "DU",
  console: {
    rulesLoadError: "Fehler beim Laden der Single-Match-Regeln:",
  },
  alerts: {
    validNumbers: "Bitte gültige Zahlen eingeben.",
    scoresNotNegative: "Scores dürfen nicht negativ sein.",
    noDraws: "Bitte trage ein Ergebnis mit eindeutigem Gewinner ein.",
    saveError: "Fehler beim Speichern. Bitte erneut versuchen.",
    confirmError: "Fehler beim Bestätigen.",
    rejectError: "Fehler beim Ablehnen.",
    enterBothScores: "Bitte trage beide Scores ein (0 ist erlaubt).",
    validMinute: "Bitte eine gültige Spielminute von 1 bis 120 eintragen.",
    validScores: "Bitte gültige Scores eingeben.",
    reportingTooEarly:
  "Ergebnisse können erst ab {{time}} gemeldet werden.",
  },
  labels: {
    opponent: "Gegner",
    player1: "SPIELER 1",
    player2: "SPIELER 2",
    latestReportTimeValue: "{{time}} UHR",
    earliestReportTimeValue: "{{time}} Uhr",
  },
  states: {
    loading: "Lade Match...",
    loadError: "Fehler beim Laden: {{error}}",
    notFound: "Match nicht gefunden.",
  },
  tabs: {
    yourMatch: "DEIN MATCH",
    chat: "CHAT",
    stake: "EINSATZ",
    matchRules: "MATCH-REGELN",
  },
  match: {
    showdown: "SHOWDOWN",
    statusYourMatchAgainst: "STATUS: DEIN MATCH GEGEN",
    opponentEaInfo: "HIER KANNST DU DIE EA-ID/KONSOLEN-ID DEINES GEGNERS EINSEHEN.",
    viewProfile: "PROFIL ANSEHEN",
    addFriend: "FREUND ADDEN",
    liveNow: "LÄUFT JETZT...",
    latestReportTime: "SPÄTESTE MELDEZEIT:",
    earliestReportTime: "FRÜHESTE MELDEZEIT:",
    waitForOpponentPresence: "WARTE, BIS DEIN GEGNER SEINE ANWESENHEIT BESTÄTIGT HAT",
    reportResult: "ERGEBNIS MELDEN",
    waitForOpponentReport: "WARTE AUF DEN REPORT DEINES GEGNERS",
  },
  report: {
    resultReported: "ERGEBNIS GEMELDET",
    rageQuitSubtitle: "RAGE QUIT – {{username}} HAT DAS SPIEL VERLASSEN",
    connectionSubtitle: "VERBINDUNGSPROBLEME – ABGEBROCHEN IN: {{minute}}. MINUTE",
    reportedResult: "GEMELDETES ERGEBNIS",
    reportedBy: "GEMELDET VON: {{username}}",
    waitForOpponentResponse: "WARTE AUF DIE ANTWORT DEINES GEGNERS",
    autoDecisionIn: "AUTOMATISCHE ENTSCHEIDUNG IN: {{seconds}}s",
    lastChance: "LETZTE CHANCE: {{seconds}}s",
    responseTime: "ANTWORTZEIT: {{seconds}}s",
    confirmResult: "ERGEBNIS BESTÄTIGEN",
    rejectResult: "ERGEBNIS ABLEHNEN",
    game1: "Spiel 1",
game2: "Spiel 2",
total: "Gesamt",
  },
  dual: {
    you: "DU",
    opponent: "GEGNER",
    reportedBy: "GEMELDET VON",
    yourReport: "DEINE MELDUNG",
    opponentReportedResultDecision:
      "DEIN GEGNER HAT BEREITS EIN ERGEBNIS GEMELDET.",
    opponentReportedRageQuitDecision:
      "DEIN GEGNER HAT BEREITS EINEN RAGE QUIT GEMELDET.",
    opponentReportedConnectionDecision:
      "DEIN GEGNER HAT BEREITS VERBINDUNGSPROBLEME GEMELDET.",
    confirmResult: "ERGEBNIS BESTÄTIGEN",
    confirmRageQuit: "RAGE QUIT BESTÄTIGEN",
    confirmConnectionIssue: "VERBINDUNGSPROBLEME BESTÄTIGEN",
    submitDifferentReport: "ANDERE MELDUNG ABGEBEN",
    connectionEvidenceHint:
      "WICHTIG: ERSTELLE JETZT BEREITS FOTOS DES ENDERGEBNISSES INKLUSIVE TEAMNAMEN UND EA-/KONSOLEN-ID. FALLS ES IM RESUME-MATCH ERNEUT ZU PROBLEMEN ODER UNTERSCHIEDLICHEN ANGABEN KOMMT, BENÖTIGST DU DIESE BEWEISBILDER.",
    responseCountdownLabel:
      "ZEIT, UM DAS ERGEBNIS ZU BESTÄTIGEN ODER EIN ANDERES ERGEBNIS ZU MELDEN:",
    reporterResponseCountdownLabel:
      "DEIN GEGNER HAT NOCH ZEIT, UM AUF DEINEN REPORT ZU REAGIEREN:",
    waitForOpponent:
      "DU HAST DEIN ERGEBNIS GEMELDET. WARTE, BIS DEIN GEGNER EBENFALLS EIN ERGEBNIS GEMELDET HAT.",
    opponentReported: "DEIN GEGNER HAT FOLGENDES ERGEBNIS GEMELDET:",
    resultReported: "ERGEBNIS GEMELDET",
    rageQuit: "RAGE QUIT",
    rageQuitBy: "RAGE QUIT VON {{username}}",
    leftMatch: "{{username}} HAT DAS SPIEL VERLASSEN",
    rageQuitReportedBy: "{{username}} hat einen Rage Quit gemeldet.",
    reportedRageQuitPlayer: "Rage Quit von",
    connectionIssue: "VERBINDUNGSPROBLEME",
    connectionIssueMinute: "VERBINDUNGSPROBLEM IN MINUTE {{minute}}",
    minute: "{{minute}}. MINUTE",
    waiting: "KEIN ERGEBNIS GEMELDET",
    autoConfirmed: "ERGEBNIS AUTOMATISCH BESTÄTIGT",
    conflictOpened: "KONFLIKTFALL ERÖFFNET",
    resumeCreated: "RESUME-MATCH ERSTELLT BZW. MATCH WURDE FORTGESETZT",
    processing: "BEIDE ERGEBNISSE WURDEN GEMELDET. DIE AUSWERTUNG LÄUFT.",
  },
  evidence: {
    selectAtLeastOneImage: "Bitte wähle mindestens ein Bild aus.",
    photosUploaded: "Fotos erfolgreich hochgeladen.",
    uploadExpired: "Die Upload-Frist ist abgelaufen.",
    threeImagesAlreadyUploaded: "Du hast bereits drei Bilder hochgeladen.",
    uploadError: "Fehler beim Hochladen der Fotos.",
  },
  conflict: {
    conflictCreated: "EIN KONFLIKTFALL WURDE ERSTELLT UND WIRD MANUELL GEPRÜFT. BITTE FERTIGE FOTOS DES ERGEBNISSES (TEAMNAME + ID) UND LADE SIE HOCH.",
    uploadTimeRemaining: "Upload-Zeit verbleibend",
    maxThreeEvidenceImages: "Du kannst maximal 3 Beweisbilder hochladen.",
    uploadExpired: "UPLOAD-ZEIT ABGELAUFEN",
    selectImages: "BILDER AUSWÄHLEN",
    photosUploading: "FOTOS WERDEN HOCHGELADEN...",
    maxReached: "MAXIMALE ANZAHL ERREICHT",
    uploadPhotos: "FOTOS HOCHLADEN",
    imagesUploaded: "{{count}}/3 BILDER HOCHGELADEN",
    imagesSelected: "{{count}} AUSGEWÄHLT",
    remove: "ENTFERNEN",
    repeatConnectionIssue: "ES WURDEN WIEDERHOLT VERBINDUNGSPROBLEME GEMELDET. DAS MATCH WIRD GEPRÜFT. ES SIND KEINE WEITEREN AKTIONEN ERFORDERLICH.",
repeatNoShow: "ES WURDEN WIEDERHOLT ANWESENHEITSPROBLEME GEMELDET. DAS MATCH WIRD GEPRÜFT. ES SIND KEINE WEITEREN AKTIONEN ERFORDERLICH.",
  },
  conflictReasons: {
    scoreWinnerMismatch: "Die gemeldeten Ergebnisse stimmen nicht überein.",
    scoreRageQuitMismatch:
      "Das gemeldete Ergebnis passt nicht zur Rage-Quit-Meldung.",
    scoreConnectionIssueMismatch:
      "Ein Spieler meldet ein Endergebnis, der andere einen Spielabbruch.",
    rageQuitLoserMismatch: "Beide Spieler melden unterschiedliche Spieler als Verlierer.",
    rageQuitConnectionIssueMismatch:
      "Eine Meldung beschreibt einen Rage Quit, die andere Verbindungsprobleme.",
    invalidConnectionIssueReport:
      "Die Angaben zum Spielabbruch sind unvollständig oder ungültig.",
    connectionIssueScoreMismatch:
      "Die gemeldeten Spielstände beim Verbindungsabbruch stimmen nicht überein.",
    connectionIssueMinuteMismatch:
      "Die gemeldeten Minuten des Spielabbruchs stimmen nicht überein.",
    unsupportedCombination:
      "Die beiden Meldungen können nicht automatisch zusammengeführt werden.",
    dualReportConflict:
      "Die beiden Meldungen widersprechen sich und müssen geprüft werden.",
    repeatConnectionIssue:
      "Es wurden erneut Verbindungsprobleme gemeldet. Das Match wird geprüft.",
    repeatNoShow:
      "Es wurde erneut gemeldet, dass ein Spieler nicht erschienen ist.",
    reportTimeout:
      "Es wurde innerhalb der Meldefrist kein Ergebnis eingetragen.",
  },
  stake: {
    stake: "EINSATZ: {{stake}} COINS",
    pot: "POT: {{pot}} COINS",
    fee: "GEBÜHR: 5% ({{feeCoins}} COINS)",
    payout: "AUSZAHLUNG: {{payout}} COINS",
    netWin: "NETTO-GEWINN: +{{netWin}} COINS",
  },
  reportModal: {
    title: "MATCH-REPORT",
    scoreSubtitle: "Endergebnis eintragen",
    subtitle: "Was ist in diesem Match passiert?",
    cards: {
      a: { title: "Ergebnis melden", description: "Korrektes Endergebnis eintragen" },
      b: { title: "Wir spielen noch", description: "Gibt euch 10 Minuten mehr Zeit" },
      c: { title: "Gegner nicht erschienen", description: "Mein Gegner ist nicht zum Match erschienen" },
      d: { title: "Rage Quit", description: "Mein Gegner hat das Match vorzeitig verlassen" },
      e: { title: "Verbindungsprobleme", description: "Das Match konnte wegen Verbindungsproblemen nicht regulär beendet werden" },
    },
    chooseOption: "BITTE WÄHLE DIE ZUTREFFENDE OPTION AUS...",
    optionLabel: "OPTION {{key}}",
    optionA: "ERGEBNIS EINTRAGEN",
    optionB: "WIR SPIELEN NOCH - ERGEBNIS FOLGT",
    optionC: "MEIN GEGNER IST NICHT ERSCHIENEN",
    optionD: "RAGE QUIT",
    optionE: "VERBINDUNGSPROBLEME",
    sendResult: "ERGEBNIS SENDEN",
  },
 resume: {
  infoText:
    "Wichtig:\nGib nur das Ergebnis dieses Spiels ein.\nDas vorherige Ergebnis wird automatisch addiert.",

  fullExplanation:
    "DAS SPIEL WURDE UNTERBROCHEN.\n\n" +
    "SPIELE EIN NEUES SPIEL BIS ZUR ANGEGEBENEN MINUTE.\n\n" +
    "WENN DEIN GEGNER AUSGLEICHT, SPIELE DAS MATCH INKLUSIVE VERLÄNGERUNG UND ELFMETERSCHIESSEN KOMPLETT ZU ENDE.\n\n" +
    "GIB AM ENDE NUR DAS ERGEBNIS DIESES SPIELS EIN.",

  modalTitle: "SPIEL FORTSETZEN",
  confirm: "VERSTANDEN",
  finalResultLabel: "Finales Ergebnis:",
  overallResultLabel: "Gesamtergebnis",
  game2InputLabel: "Spiel 2",

  previousResultLabel: "Vorheriges Ergebnis",
  onlyThisMatchLabel: "Jetzt nur das Ergebnis aus dem zweiten Spiel eintragen.",
},

resumeEvidence: {
  title: "Wichtiger Hinweis",
  text:
    "Bitte erstellt jetzt Screenshots oder Fotos des Ergebnisses des ersten Spiels (Verbindungsabbruch-Spiel). Falls es später zu einem Konflikt kommt, können diese Bilder als Beweise benötigt werden. Ohne entsprechende Beweise kann eine Entscheidung erschwert werden.",
  confirm: "Verstanden",
},


resumeInstructions: {
  finished:
    "Das Spiel wurde in der {{minute}}. Minute beendet. Spielt ein komplett neues Spiel.",

  leading:
    "Das Spiel wurde in der {{minute}}. Minute bei einem Spielstand von {{scoreP1}}:{{scoreP2}} für {{leader}} abgebrochen. Spielt ein neues Spiel bis zur {{targetMinute}}. Minute. Sollte {{trailingPlayer}} ausgleichen, spielt das Spiel inklusive Verlängerung und Elfmeterschiessen bis zum Ende weiter.",

  draw:
    "Das Spiel wurde in der {{minute}}. Minute bei einem Spielstand von {{scoreP1}}:{{scoreP2}} abgebrochen. Spielt ein neues Spiel bis zur {{targetMinute}}. Minute. Sollte weiterhin Gleichstand sein, spielt das Spiel bis zum Elfmeterschießen zu Ende.",
},

  finished: {
    winTitle: "SIEG!",
    lossTitle: "NIEDERLAGE",
    winText: "Du hast das Spiel gewonnen. Dir wurden {{payoutAmount}} Coins gutgeschrieben.",
    lossText: "Du hast das Spiel leider verloren. Dein Einsatz von {{stakeCoins}} Coins ist weg.",
    ok: "OK",
  },
  rageQuit: {
    title: "WER HAT DAS SPIEL VERLASSEN?",
    question: "Wähle den betreffenden Spieler aus.",
    opponentLabel: "DEIN GEGNER",
    me: "ICH",
    myOpponent: "MEIN GEGNER",
    cancel: "ABBRECHEN",
  },
  connection: {
    title: "VERBINDUNGSPROBLEME",
    minuteLabel: "SPIELMINUTE",
    minuteQuestion: "IN WELCHER SPIELMINUTE IST DIE VERBINDUNG ABGEBROCHEN?",
    minutePlaceholder: "1-120",
    scoreQuestion: "WIE WAR DER SPIELSTAND?",
    send: "SENDEN",
    cancel: "ABBRECHEN",
  },
  noShow: {
  title: "SPIELBEREIT?",
  text: "DEIN GEGNER MELDET, DASS DU NICHT ERSCHIENEN BIST.",
  confirmReady: "ICH BIN SPIELBEREIT",
  presenceConfirmedTitle: "ANWESENHEIT BESTÄTIGT",
  opponentConfirmed: "Dein Gegner hat seine Anwesenheit bestätigt. Bitte versucht nun erneut, euer Match zu starten.",
},
  
  rulesLabels: {
  gameMode: "SPIELMODUS",
  matchDuration: "SPIELDAUER",
  format: "FORMAT",
  tieDecision: "ENTSCHEIDUNG BEI GLEICHSTAND",
  teamSelection: "TEAMWAHL",
  platform: "PLATTFORM",
},
rulesValues: {
  gameMode: "ONLINE-MODUS MIT INDIVIDUELL ZUSAMMENGESTELLTEN TEAMS",
  matchDuration: "6 MINUTEN",
  format: "BEST-OF-ONE",
  groupStageFormat: "Gruppenphase / K.O.-Phase (Best-of-One)",
  tieDecision: "VERLÄNGERUNG + ELFMETERSCHIESSEN",
  teamSelection: "FREIE WAHL",
  platform: "PLAYSTATION / X-BOX / PC (NUR NEW GEN)",
},
},


profile: {
  loading: "PROFIL WIRD GELADEN...",
  loadError: "PROFIL KONNTE NICHT GELADEN WERDEN",

  tabs: {
    profile: "PROFIL",
    stats: "STATISTIKEN",
    history: "HISTORIE",
  },

  labels: {
    joinDate: "BEITRITTSDATUM",
    memberSince: "MITGLIED SEIT",
    trustLevel: "VERTRAUENSLEVEL",
    username: "VAULTQUEST-USERNAME",
    console: "KONSOLE",
    platform: "PLATTFORM",
    consoleId: "KONSOLEN-ID",
    epicId: "EPIC-ID",
    eaId: "EA-ID",
    utName: "ULTIMATE TEAM",
  },

  sections: {
    gaming: "GAMING",
  },

  stats: {
    overall: "GESAMTSTATISTIK",
    overview: "ÜBERSICHT",
    total: "GESAMT",
    tournaments: "TURNIERE",
    singles: "MATCHES",
    matches: "MATCHES",
    played: "GESPIELTE SPIELE",
    wins: "SIEGE",
    losses: "NIEDERLAGEN",
    winRate: "WIN-RATE",
    fairPlayStreak: "FAIR-PLAY-STREAK",
    gamesLabel: "SPIELE",
    tournamentGames: "TURNIERSPIELE",
    singleGames: "EINZELSPIELE",
    coins: "ERWIRTSCHAFTETE COINS",
    bestTournamentLeaderboardRank: "BESTE LEADERBOARD-PLATZIERUNG",
    bestSingleLeaderboardRank: "BESTE LEADERBOARD-PLATZIERUNG",
  },

  history: {
    title: "LETZTE 10 SPIELE",
    loading: "LÄDT...",
    empty: "NOCH KEINE MATCHES VORHANDEN",
    tournamentMatch: "TURNIERMATCH",
    singleMatch: "MATCH",
    opponent: "GEGNER",
    result: "ERGEBNIS:",
    win: "SIEG",
    loss: "NIEDERLAGE",
  },
},

fairPlayCommunity: {
  trustLevel: "VERTRAUENSLEVEL",
  rules: "REGELWERK",
  friends: "FREUNDESLISTE",
  leaderboards: "LEADERBOARDS",
  quests: "Quests",
},

fairPlayPage: {
  title: "FairPlay",
  intro: "Fairness und Vertrauen sind die Grundlage von VaultQuest. Hier siehst du dein Vertrauenslevel und die wichtigsten Regeln.",
  yourTrustLevel: "Dein Vertrauenslevel",
  currentLevel: "Aktuelles Vertrauenslevel",
  allTrustLevels: "Alle Vertrauenslevel",
  rulesTitle: "Regelwerk",
  trustText: "Dein Vertrauenslevel spiegelt deine Zuverlässigkeit, Teilnahme an Spielen und korrekt eingereichte Ergebnisse wider. Nachgewiesenes unfaires Verhalten kann dein Level senken.",
},



trustLevel: {
  page1: {
    title: "DEIN VERTRAUENSLEVEL",
    info: "DEIN VERTRAUENSLEVEL SPIEGELT DEINE ZUVERLÄSSIGKEIT, TEILNAHME AN SPIELEN UND KORREKT EINGEREICHTE ERGEBNISSE WIDER. PRO NACHGEWIESENEM UNFAIREN VERHALTEN SINKT ES UM EIN LEVEL.",
    currentLevel: "VERTRAUEN: LEVEL {{level}}",
  },
  page2: {
    title: "ÜBERSICHT VERTRAUENSLEVEL",
  },
  table: {
    level: "LEVEL",
    name: "NAME",
    meaning: "BEDEUTUNG",
  },
  levels: {
    7: { name: "VORBILDLICH", meaning: "DURCHGEHEND FAIR" },
    6: { name: "ZUVERLÄSSIG", meaning: "VERTRAUENSWÜRDIG" },
    5: { name: "SOLIDE", meaning: "MEIST FAIR" },
    4: { name: "ACHTSAM", meaning: "GELEGENTLICH UNFAIR" },
    3: { name: "WARNSTUFE", meaning: "UNFAIR" },
    2: { name: "RISIKOSPIELER", meaning: "MEHRFACH UNFAIR" },
    1: { name: "PERMABANN", meaning: "DAUERHAFT UNFAIR" },
  },
},


rules: {
  page1: {
    title: "GRUNDPRINZIPIEN",
    bullets: [
      "EHRLICHE UND KORREKTE ERGEBNISANGABE",
      "RESPEKTVOLLER UMGANG MITEINANDER",
      "FAIRNESS GEGENÜBER ALLEN MITSPIELERN",
      "KEINE SPIELABBRÜCHE OHNE GRUND",
    ],
  },
  page2: {
    title: "VERBOTENES VERHALTEN",
    bullets: [
      "FÄLSCHEN/MANIPULIEREN VON SPIELERGEBNISSEN",
      "CHEATING",
      "BELEIDIGUNGEN",
      "NUTZUNG MEHRERER ACCOUNTS ZUR VORTEILNAHME",
      "WEITERGABE DES EIGENEN ACCOUNTS AN DRITTE",
    ],
  },
  page3: {
    title: "KONFLIKTFÄLLE",
    bullets: [
      "UNSTIMMIGKEITEN BEI ERGEBNISANGABEN WERDEN AUTOMATISCH IN FORM EINES KONFLIKTFALLS GEMELDET",
      "NACHWEISE (SCREENSHOTS) HELFEN BEI DER KLÄRUNG",
      "KONFLIKTFALL WIRD GEPRÜFT UND NEUTRAL BEWERTET",
    ],
  },
  page4: {
    title: "KONSEQUENZEN BEI VERSTÖSSEN",
    bullets: [
      "ABZUG DES VERTRAUENSLEVELS",
      "TEMPORÄRE SPERRE FÜR MATCHES UND TURNIERE",
      "BEI WIEDERHOLTEN ODER SCHWEREN VERSTÖSSEN DAUERHAFTE SPERRE",
    ],
  },
},


friends: {
  tabs: {
    myFriends: "MEINE FREUNDE",
    searchFriends: "FREUNDE SUCHEN",
    requests: "ANFRAGEN",
  },
  actions: {
    openMenu: "Menü öffnen",
    viewProfile: "PROFIL ANSEHEN",
    removeFriend: "FREUND ENTFERNEN",
    sendRequest: "FREUNDSCHAFTSANFRAGE SENDEN",
    sending: "SENDE...",
    addFriend: "FREUND HINZUFÜGEN",
    accept: "ANNEHMEN",
    decline: "ABLEHNEN",
    removing: "ENTFERNE...",
    yesRemove: "JA, ENTFERNEN",
  },
  search: {
    placeholder: "USERNAME EINGEBEN",
    searching: "SUCHE…",
    title: "FREUNDE FINDEN",
    subtitle: "Suche nach einem VaultQuest-Spieler",
  },
  labels: {
    trustLevel: "Vertrauenslevel",
  },
  empty: {
    noFriends: "Du hast noch keine Freunde. Nutze „Freunde suchen“ oder schau in „Anfragen“.",
    noIncomingRequests: "KEINE OFFENEN ANFRAGEN",
    requestsHint: "Neue Freundschaftsanfragen erscheinen hier.",
  },
  requests: {
    from: "Anfrage von: {{name}}",
    noLongerPending: "Diese Anfrage ist nicht mehr pending.",
    wantsToBeFriend: "möchte dein Freund sein",
  },
  modal: {
    removeFriendConfirm: "Willst du {{name}} wirklich entfernen?",
  },
  status: {
    profileNotConnected: "Profil ansehen ({{name}}) ist noch nicht verbunden.",
    friendRemoved: "Freund entfernt: {{name}}",
    alreadyFriends: "Ihr seid bereits befreundet.",
    alreadyPending: "Es existiert bereits eine offene Freundschaftsanfrage.",
    requestSent: "Freundschaftsanfrage gesendet.",
    requestNotAllowed: "Du kannst diesem Nutzer aktuell keine Freundschaftsanfrage senden.",
    enterUsername: "Bitte einen Username eingeben.",
    userNotFound: "❌ User nicht gefunden.",
    cannotAddSelf: "Du kannst dir selbst keine Anfrage schicken.",
    requestAccepted: "✅ Anfrage angenommen.",
    requestDeclined: "✅ Anfrage abgelehnt.",
    requestError: "Beim Senden der Freundschaftsanfrage ist ein Fehler aufgetreten.",
    errorWithDetails: "❌ Fehler: {{code}} {{message}}",
  },
},



leaderboards: {
  unknownUser: "Unbekannt",
  filterTitle: "LEADERBOARD FILTER",
  tabs: {
    tournaments: "TURNIERE",
    singles: "MATCHES",
  },
  monthlyOverall: "MONATLICH GESAMT",
  archive: {
    month: "Monat auswählen",
    year: "Jahr auswählen",
    apply: "Anwenden",
  },
  reward: {
    title: "Monatspreise",
    place: "Platz",
  },
  table: {
    rank: "PLATZ",
    name: "NAME",
    player: "SPIELER",
    points: "PUNKTE",
  },
  empty: "Noch keine Spieler im Leaderboard (Mindestanforderung).",
  emptyTitle: "NOCH KEINE SPIELER",
  emptyDescription: "Aktuell erfüllt niemand die Mindestanforderungen für dieses Leaderboard.",
  emptyAction: "Spiele weitere Matches, um aufgenommen zu werden.",
},


rewards: {
  title: "QUESTS",
  claim: "EINSAMMELN",
  claiming: "WIRD EINGESAMMELT...",
  coins: "Coins",
  rewardLabel: "Belohnung",
  progress: "Fortschritt",
  categories: {
    matches: "Matches", tournaments: "Turniere", tournamentTypes: "Turnierarten",
    wins: "Siege", community: "Community", achievements: "Erfolge",
    loyalty: "Treue", leaderboard: "Leaderboard", performance: "Match-Erfolge",
  },
  status: {
    locked: "Noch nicht erreicht", available: "Bereit", claimed: "Abgeschlossen",
    lockedLong: "Noch nicht erreicht", availableLong: "Erreicht – Belohnung verfügbar", claimedLong: "Belohnung eingesammelt",
  },

  items: {
    firstMatchPlayed: { name: "Erstes Match", description: "Spiele dein erstes Match" },
    matches5: { name: "Getting Started", description: "Spiele 5 Matches" },
    matches10: { name: "Warmgespielt", description: "Spiele 10 Matches" },
    matches20: { name: "Matchday Regular", description: "Spiele 20 Matches" },
    matches50: { name: "Dauerbrenner", description: "Spiele 50 Matches" },
    matches100: { name: "Centurion", description: "Spiele 100 Matches" },
    firstTournamentPlayed: { name: "Part of it.", description: "Nimm an deinem ersten Turnier teil." },
    tournaments10Played: { name: "Patron", description: "Nimm an 10 Turnieren teil" },
    firstTournamentWon: { name: "Turniersieg", description: "Gewinne dein erstes Turnier" },
    tournaments5Won: { name: "Pokalsammler", description: "Gewinne 5 Turniere" },
    tournaments10Won: { name: "Titeljäger", description: "Gewinne 10 Turniere" },
    tournaments25Won: { name: "Champion", description: "Gewinne 25 Turniere" },
    eveningCups5: { name: "Evening Eve", description: "Nimm an 5 Evening Cups teil" },
    nightlyCups5: { name: "Night owl", description: "Nimm an 5 Nightly Cups teil" },
    specialCups1: { name: "Special Guest", description: "Nimm an einem Special Cup teil" },
    specialCups5: { name: "Special Patron", description: "Nimm an 5 Special Cups teil" },
    creatorCups3: { name: "Creator", description: "Nimm an 3 Creator Cups teil" },
    wins1: { name: "First Win", description: "Gewinne ein Match" },
    wins10: { name: "Winning Ways", description: "Gewinne 10 Matches" },
    wins20: { name: "Siegertyp", description: "Gewinne 20 Matches" },
    wins50: { name: "Winning Machine", description: "Gewinne 50 Matches" },
    wins100: { name: "Veteran", description: "Gewinne 100 Matches" },
    winStreak3: { name: "Siegesserie", description: "Gewinne 3 Matches in Folge" },
    winStreak5: { name: "Unaufhaltsam", description: "Gewinne 5 Matches in Folge" },
    friend1: { name: "Freund", description: "Füge deinen ersten Freund hinzu" },
    friends5: { name: "Sozial unterwegs", description: "Du bist mit 5 Nutzern befreundet" },
    friends10: { name: "Freundesgruppe", description: "Du bist mit 10 Nutzern befreundet" },
    friends20: { name: "Gut vernetzt", description: "Du bist mit 20 Nutzern befreundet" },
    coins1000Single: { name: "Earnings", description: "Verdiene 1000 Coins durch Matches" },
    coins5000Single: { name: "Incoming", description: "Verdiene 5000 Coins durch Matches" },
    coins10000Single: { name: "Revenue", description: "Verdiene 10000 Coins durch Matches" },
    login3Days: { name: "Drangeblieben", description: "Logge dich 3 Tage in Folge ein" },
    login10Days: { name: "Stammgast", description: "Logge dich 10 Tage in Folge ein" },
    login25Days: { name: "Treues Häschen", description: "Logge dich 25 Tage in Folge ein" },
    leaderboardTop10: { name: "Top Ten", description: "Erreiche in den Leaderboards die Top 10" },
    leaderboardTop3: { name: "Podium", description: "Erreiche in den Leaderboards die Top 3" },
    leaderboardRank1: { name: "Number One", description: "Erreiche in den Leaderboards Platz 1" },
    leaderboardTop10Months3: { name: "Established", description: "Erreiche in 3 Monaten die Top 10" },
    leaderboardTop3Months3: { name: "Podiumpatron", description: "Erreiche in 3 Monaten die Top 3" },
    leaderboardRank1Months3: { name: "Dynasty", description: "Erreiche in 3 Monaten Platz 1" },
    goals10: { name: "Torgefahr", description: "Erziele insgesamt 10 Tore" },
    goals25: { name: "Knipser", description: "Erziele insgesamt 25 Tore" },
    goals50: { name: "Finisher", description: "Erziele insgesamt 50 Tore" },
    goals100: { name: "Torjäger", description: "Erziele insgesamt 100 Tore" },
    dominantWin: { name: "Dominant", description: "Gewinne ein reguläres Match mit mindestens 3 Toren Unterschied" },
    cleanSheetWin: { name: "Clean Sheet", description: "Gewinne ein reguläres Match ohne Gegentor" },
  },
},

rewardPrompt: {
  eyebrow: "Quest-Belohnung",
  titleOne: "Belohnung bereit",
  titleMany: "{{count}} Belohnungen bereit",
  textOne: "Du hast eine Quest abgeschlossen. Deine Coins warten auf dich.",
  textMany: "Du hast mehrere Quests abgeschlossen. Sammle deine Coins jetzt ein.",
  more: "+{{count}} weitere Belohnungen",
  cta: "Zu meinen Quests",
  later: "Später",
},


shop: {
  title: "Shop",
  comingSoon: "Der Shop ist bald verfügbar.",
  moreInfo: "Hier kannst du bald Coins kaufen.",
},

vouchers: {
  title: "Gutscheine",
  empty: "Du hast aktuell noch keine Gutscheine gewonnen.",
  valueLabel: "Wert",
  codeLabel: "Code",
  unknownProvider: "Unbekannter Anbieter",
  copyCode: "Code kopieren",
  copied: "Kopiert",
  receivedAtLabel: "Erhalten am:",
  remove: "Entfernen",
  providerLabel: "Anbieter",
},


landing: {
  heroTitle: "Enter the Vault. Start your Quest.",
  heroClaim: "Die Turnierplattform für kompetitives Gaming.",
  heroSubtitle: "Das Turnier beginnt hier. Tritt gegen Gegner an, spiele um den Sieg und sichere dir echte Belohnungen.",
  startButton: "Jetzt kostenlos starten",
  newGenNotice: "VaultQuest unterstützt ausschließlich Konsolen der aktuellen Generation (PS5 & Xbox Series X|S). Old-Gen-Konsolen wie PS4 oder Xbox One werden nicht unterstützt.",
  howItWorksTitle: "Wie funktioniert VaultQuest?",
  joinTournamentTitle: "Turnier beitreten",
  joinTournamentText: "Die Turnierkarte zeigt dir alle Informationen rund um Turnierstatus, Belohnungen, Teilnehmerplätze, Uhrzeit und Teilnahmegebühren.",
  matchViewTitle: "Match-Ansicht",
  matchViewText: "Die Match-Ansicht zeigt dir, gegen wen du als nächstes spielst. Tippe auf \"Profil ansehen\", um die Konsolendaten deines Gegners zu erfahren, diesen zu adden und das Match zu starten.",
  reportTitle: "Ergebnis melden",
  reportText: "Option A: Trage euer Ergebnis ein.\nOption B: Gibt euch 10 Minuten mehr Zeit.\nOption C: Falls dein Gegner nicht erschienen ist.\nOption D: Trage ein, ob du oder dein Gegner ragegequittet ist.\nOption E: Falls ihr Verbindungsprobleme hattet, trage ein, wie der Spielstand war und in welcher Spielminute das Match abgebrochen wurde. Ein Admin wird sich bei euch melden, um den Rest zu klären.",
  conflictTitle: "Konfliktfall",
  conflictText: "Falls dein Gegner ein falsches Ergebnis reported hat, kannst du das Ergebnis ablehnen. Daraus folgt ein Konfliktfall, der es dir und deinem Gegner ermöglicht, bis zu 3 Bilder des Ergebnisses hochzuladen. Auf Grundlage der Bilder wird über das Weiterkommen oder Ausscheiden entschieden. Achte darauf, dass auf den Bildern der Spielstand, die Konsolen-ID und der Teamname zu sehen ist.",
  winTitle: "Turniersieg",
  winText: "Falls du wider Erwarten ein Turnier gewinnen solltest, erhältst du deinen Gutscheincode über das VaultQuest-Benachrichtigungssystem und über deine bei uns hinterlegte Mail-Adresse.",
  whyTitle: "Warum VaultQuest?",
realCompetitionTitle: "Echte Wettbewerbe",
realCompetitionText: "Spiele gegen echte Gegner in strukturierten Turnieren.",
noticeText: "Achte bitte darauf, wahrheitsgemäße Angaben innerhalb der dafür vorgesehenen Fristen abzugeben. Jede Handlung, die nicht den VaultQuest-Werten entspricht, wird zielgerichtet und konsequent geahndet.",
fastMatchesTitle: "Schnelle Matches",
fastMatchesText: "Keine langen Sessions – spielen, Ergebnisse sehen und Belohnungen erhalten.",
skillTitle: "Skill entscheidet",
skillText: "Deine Performance im Match zählt.",
rewardsTitle: "Echte Belohnungen",
rewardsText: "Gewinne Gutscheine durch deine Turniersiege.",
betaText: "Wir freuen uns über dein Feedback und entwickeln VaultQuest kontinuierlich weiter.",
mobileBannerLabel: "Hinweis:",
mobileBanner: "VaultQuest ist aktuell für mobile Geräte optimiert. Auf Desktop (PC/Mac) kann es zu Einschränkungen in der Bedienung kommen.",
optimizedForTitle: "Optimiert für",
optimizedSmartphones: "Smartphones",
optimizedDesktop: "Desktop (PC/Mac)",
optimizedForText: "Für die beste Spielerfahrung empfehlen wir die Nutzung auf mobilen Geräten. Die Desktop-Version wird kontinuierlich weiter optimiert.",
supportedPlatformsTitle: "Unterstützte Plattformen",
visionTitle: "Unsere Vision",
visionPoint1Title: "Etablierung",
visionPoint1Text: "Wir wollen VaultQuest als führende Turnierplattform in Deutschland etablieren - fair, zugänglich und für jeden spielbar.",
visionPoint2Title: "Mehr als nur Spielen",
visionPoint2Text: "Wir arbeiten kontinuierlich daran, die Plattform weiterzuentwickeln und den Wert der Gewinne zu steigern – mit besseren Belohnungen und mehr Möglichkeiten für Spieler.",
visionPoint3Title: "Echte Competition",
visionPoint3Text: "Unser Ziel ist es, Turniere zu schaffen, die sich wie echte Events anfühlen – spannend, fair und mit echten Rewards.",
feedbackTitle: "Feedback",
feedbackText: "Du hast Verbesserungsvorschläge oder Wünsche? Teile dein Feedback gerne über das Support-Formular in der App, per E-Mail oder über unsere Social-Media-Kanäle mit uns.",
impressum: "Impressum",
privacy: "Datenschutz",
terms: "AGB",
contact: "Kontakt",
faqs: "FAQs",
},

login: {
  emailOrUsernamePlaceholder: "E-Mail/Benutzername",
  passwordPlaceholder: "Passwort",
  forgotPassword: "Passwort vergessen?",
  submit: "Enter the Vault",
  noAccountRegister: "Noch kein Account? Jetzt registrieren",
  apple: {
    button: "Mit Apple anmelden",
    loading: "Apple-Anmeldung läuft…",
    or: "oder",
    errors: {
      accountCollision: "Für diese E-Mail besteht bereits ein VaultQuest-Konto. Melde dich zunächst mit deiner bisherigen Anmeldemethode an.",
      incompleteResponse: "Apple konnte die Anmeldung nicht vollständig abschließen. Bitte versuche es erneut.",
      invalidNonce: "Die sichere Apple-Anmeldung konnte nicht bestätigt werden. Bitte versuche es erneut.",
      network: "Netzwerkfehler. Bitte prüfe deine Verbindung.",
      generic: "Apple-Anmeldung fehlgeschlagen. Bitte versuche es erneut.",
    },
  },
  errors: {
    invalidCredentials: "E-Mail/Benutzername oder Passwort ist falsch.",
    tooManyRequests: "Zu viele Login-Versuche. Bitte warte kurz.",
    network: "Netzwerkfehler. Bitte Verbindung prüfen.",
    generic: "Login fehlgeschlagen. Bitte erneut versuchen."
  }
},

appleOnboarding: {
  eyebrow: "Apple-Anmeldung",
  title: "Hast du bereits einen VaultQuest-Account?",
  description: "Wenn du VaultQuest bereits mit E-Mail und Passwort genutzt hast, kannst du deinen bestehenden Account sicher mit Apple verbinden.",
  linkExisting: "Bestehenden Account verbinden",
  createNew: "Neuen Account erstellen",
  confirmLink: "Account sicher verbinden",
  linking: "Accounts werden verbunden…",
  linkHint: "Dein bestehendes Profil, deine Coins und Statistiken bleiben unverändert. Zur Bestätigung öffnet sich Apple noch einmal.",
  errors: {
    missingCredentials: "Bitte gib E-Mail/Benutzername und Passwort ein.",
    invalidCredentials: "E-Mail/Benutzername oder Passwort ist falsch.",
    appleAlreadyLinked: "Dieser Account ist bereits mit einer anderen Apple-Anmeldung verbunden.",
    generic: "Die Accounts konnten nicht verbunden werden. Es wurden keine Profildaten verändert.",
  },
},

reset: {
  title: "Passwort zurücksetzen",
  description:
    "Gib hier deine E-Mail-Adresse ein. Du erhältst eine E-Mail mit einem Link, über den du dein Passwort zurücksetzen kannst.",
  emailPlaceholder: "E-Mail",
  sendButton: "Reset-Mail senden",
  backToLogin: "← Zurück zum Login",
  messages: {
    neutralSuccess:
      "Wenn ein Konto mit dieser E-Mail existiert, haben wir dir soeben eine Nachricht zum Zurücksetzen deines Passworts gesendet."
  },
  errors: {
    enterEmailFirst: "Bitte gib zuerst deine E-Mail-Adresse ein.",
    invalidEmail: "Bitte gib eine gültige E-Mail-Adresse ein.",
    tooManyRequests: "Zu viele Versuche. Bitte warte kurz und versuche es später erneut.",
    generic: "Das hat leider nicht geklappt. Bitte versuche es erneut."
  }
},

resetPasswordPage: {
  loading: "Lade...",
  title: "Passwort zurücksetzen",
  newPasswordPlaceholder: "Neues Passwort",
  repeatPasswordPlaceholder: "Passwort wiederholen",
  submit: "Passwort ändern",
  toLogin: "Zum Login",
  success: "Dein Passwort wurde erfolgreich geändert.",
  errors: {
    invalidOrExpired: "Dieser Link ist ungültig oder abgelaufen.",
    passwordTooShort: "Das Passwort muss mindestens 6 Zeichen enthalten.",
    passwordMismatch: "Die Passwörter stimmen nicht überein.",
    generic: "Passwort konnte nicht geändert werden.",
  },
},

emailVerification: {
  title: "E-Mail-Adresse bestätigen",
  description:
    "Wir haben dir eine E-Mail zur Bestätigung deiner E-Mail-Adresse geschickt. Bitte öffne dein Postfach und klicke auf den Bestätigungslink.",
  buttons: {
    check: "Ich habe meine E-Mail bestätigt",
    checking: "Prüfe...",
    resend: "E-Mail erneut senden",
    sending: "Sendet...",
    resendCooldown: "Erneut senden in {{seconds}}s",
    logout: "Abmelden",
  },
  messages: {
    verified: "Danke, deine E-Mail-Adresse wurde bestätigt.",
    notVerified: "Deine E-Mail wurde noch nicht bestätigt.",
    sent: "Wir haben dir eine neue Bestätigungs-E-Mail gesendet.",
    tooManyRequests: "Bitte warte kurz, bevor du eine neue E-Mail anforderst.",
    sendFailed: "Die Bestätigungs-E-Mail konnte nicht gesendet werden.",
    checkFailed: "Die Bestätigung konnte gerade nicht geprüft werden.",
  },
},


register: {
  title: "Registrieren",
  accountStepTitle: "Accountdaten",
  gamingStepTitle: "Gamingdaten",
  usernamePlaceholder: "Benutzername",
  emailPlaceholder: "E-Mail",
  passwordPlaceholder: "Passwort",
  passwordRepeatPlaceholder: "Passwort bestätigen",
  agePlaceholder: "Alter auswählen",
  agePlaceholderOptional: "Alter optional",
  minimumAgeConfirmation: "Ich bin mindestens 13 Jahre alt.",
  requiredFieldHint: "* Pflichtfeld",
  next: "Weiter",
  consoleIdPlaceholder: "Konsolen-ID",
  eaIdPlaceholder: "EA-ID",
  consoleTypePlaceholder: "Art der Konsole",
  consoleOptions: {
   playstation: "PlayStation (nur NewGen)",
xbox: "Xbox (nur NewGen)",
pc: "PC", 
  },
  back: "← Zurück",
  submit: "Registrieren",
  backToLogin: "← Zurück zum Login",
  terms: "AGB",
  privacy: "Datenschutzerklärung",
  acceptPrefix: "Ich habe die",
  acceptMiddle: "und die",
  acceptSuffix: "gelesen und bin damit einverstanden.",
  aiConflictConsentTitle: "KI-gestützter Konfliktanalyse zustimmen (optional)",
  aiConflictConsentTextBeforePrivacy:
    "Ich stimme zu, dass im Falle eines Konflikts konfliktbezogene Daten, Match-Chat-Nachrichten und hochgeladene Nachweise durch OpenAI verarbeitet werden können, um VaultQuest-Administratoren bei der Konfliktprüfung zu unterstützen. Die endgültige Entscheidung trifft weiterhin ein VaultQuest-Administrator. Weitere Informationen findest du in der",
  aiConflictConsentTextAfterPrivacy: ".",
  aiConflictConsentAdultOnly: "Die KI-gestützte Konfliktanalyse ist nur für volljährige Nutzer verfügbar.",
  errors: {
    usernameRequired: "Bitte Benutzername eingeben.",
    ageRequired: "Bitte Alter auswählen.",
    ageMinimum: "Du musst mindestens 13 Jahre alt sein.",
    minimumAgeConfirmationRequired: "Bitte bestätige, dass du mindestens 13 Jahre alt bist.",
    acceptLegalRequired: "Bitte AGB und Datenschutzerklärung akzeptieren.",
    emailRequired: "Bitte E-Mail eingeben.",
    passwordRequired: "Bitte Passwort eingeben.",
    passwordTooShort: "Das Passwort muss mindestens 6 Zeichen lang sein.",
    passwordMismatch: "Passwörter stimmen nicht überein.",
    consoleIdRequired: "Bitte Konsolen-ID eingeben.",
    consoleTypeRequired: "Bitte Konsole auswählen.",
    eaIdRequired: "Bitte EA-ID eingeben.",
    emailOrUsernameTaken: "E-Mail oder Benutzername bereits vergeben.",
    invalidEmail: "Bitte gib eine gültige E-Mail-Adresse ein.",
    generic: "Registrierung fehlgeschlagen.",
    usernameInvalid: "Der Benutzername muss 3–15 Zeichen lang sein und darf nur Buchstaben, Zahlen und Unterstriche enthalten.",
    usernameReserved: "Dieser Benutzername ist reserviert.",
    usernameTooShort: "Der Benutzername muss mindestens 3 Zeichen lang sein.",
    usernameTooLong: "Der Benutzername darf maximal 15 Zeichen lang sein.",
    usernameNotAllowed: "Dieser Benutzername ist nicht erlaubt.",
  }
},

authProfileCompletion: {
  title: "Profil vervollständigen",
  subtitle: "Lege deinen VaultQuest-Username und deine Gaming-Plattform fest.",
  submit: "Profil erstellen",
  saving: "Profil wird erstellt...",
  errors: {
    usernameTaken: "Dieser Benutzername ist bereits vergeben.",
    providerRequired: "Diese Anmeldung kann den Profilabschluss noch nicht verwenden.",
    generic: "Dein Profil konnte nicht erstellt werden. Bitte versuche es erneut.",
  },
},



bottomBar: {
  tournaments: "Turniere",
  singleGames: "Matches",
  home: "Home",
  vouchers: "Gutscheine",
  community: "Community",
},



menu: {
  title: "Menü",
  settings: "Einstellungen",
  support: "Support",
  rateVaultQuest: "VaultQuest bewerten",
  rateVaultQuestMissingAppStoreId: "Die App-Store-Verknüpfung ist noch nicht konfiguriert.",
  rateVaultQuestOpenFailed: "Die Bewertung konnte nicht geöffnet werden. Bitte versuche es später erneut.",
  premium: "Premium-Abo",
  legal: "Rechtliches",
  about: "Über VaultQuest",
  faqs: "FAQs",
  logout: "Logout",
  terms: "AGB",
  privacy: "Datenschutz",
  imprint: "Impressum",
  competitionTerms: "Wettbewerbsbedingungen",
  accountSettings: "Kontoeinstellungen",
  language: {
    german: "Deutsch",
    english: "English",
  },
  account: {
    signInMethod: "Anmeldemethode",
    signInMethods: "Anmeldemethoden",
    signInWithApple: "Apple",
    signInWithPassword: "E-Mail & Passwort",
    username: "Username",
    email: "E-Mail",
    consoleType: "Konsolenart",
    consoleId: "Konsolen-ID",
    eaId: "EA-ID",
    saveGamingIds: "Spielprofil speichern",
    saved: "Spielprofil wurde gespeichert.",
    saveError: "Spielprofil konnte nicht gespeichert werden.",
    gamingIdsHint: "EA-ID und Konsolen-ID brauchst du erst, wenn du an Spielen oder Turnieren teilnehmen möchtest.",
    ageGroup: {
      title: "Altersgruppe",
      placeholder: "Altersgruppe auswählen",
      save: "Altersgruppe speichern",
      saved: "Altersgruppe wurde gespeichert.",
      savedAndConsentRevoked: "Altersgruppe wurde gespeichert. Die KI-Zustimmung wurde widerrufen.",
      invalid: "Bitte wähle eine gültige Altersgruppe aus.",
      saveError: "Altersgruppe konnte nicht gespeichert werden. Bitte versuche es erneut.",
    },
    aiConflictConsent: {
      title: "KI-gestützte Konfliktanalyse",
      description: "Erlaubt die Verarbeitung konfliktbezogener Daten durch OpenAI zur Unterstützung der Konfliktprüfung. Die endgültige Entscheidung trifft weiterhin ein VaultQuest-Administrator.",
      statusOn: "Zustimmung erteilt",
      statusOff: "Keine Zustimmung erteilt",
      savedOn: "Zustimmung zur KI-gestützten Konfliktanalyse gespeichert.",
      savedOff: "Zustimmung zur KI-gestützten Konfliktanalyse widerrufen.",
      adultOnly: "Die KI-gestützte Konfliktanalyse ist nur für volljährige Nutzer verfügbar.",
      saveError: "Die Einstellung konnte nicht gespeichert werden. Bitte versuche es erneut.",
    },
    emailChange: {
      title: "E-Mail-Adresse ändern",
      modalTitle: "E-Mail-Adresse ändern",
      modalText: "Bitte bestätige zuerst dein aktuelles Passwort.\n\nWir senden dir anschließend eine VaultQuest-Bestätigung an deine neue E-Mail-Adresse. Die neue Adresse wird erst übernommen, nachdem du diesen Link geöffnet hast.",
      currentPassword: "Aktuelles Passwort",
      newEmail: "Neue E-Mail-Adresse",
      confirmEmail: "Neue E-Mail-Adresse bestätigen",
      submit: "E-Mail-Adresse ändern",
      verificationSent: "Wir haben dir eine VaultQuest-Bestätigung an deine neue E-Mail-Adresse gesendet. Bitte öffne den Link in dieser E-Mail, damit die Änderung wirksam wird.",
      errors: {
        noEmail: "Für diesen Account wurde keine aktuelle E-Mail-Adresse gefunden.",
        passwordRequired: "Bitte gib dein aktuelles Passwort ein.",
        reauthFailed: "Das Passwort ist nicht korrekt.",
        invalidEmail: "Bitte gib eine gültige neue E-Mail-Adresse ein.",
        emailMismatch: "Die neuen E-Mail-Adressen stimmen nicht überein.",
        sameEmail: "Die neue E-Mail-Adresse entspricht bereits deiner aktuellen E-Mail-Adresse.",
        alreadyInUse: "Diese E-Mail-Adresse wird bereits für einen anderen Account verwendet.",
        tooManyRequests: "Zu viele Versuche. Bitte warte kurz und versuche es später erneut.",
        requestFailed: "Die E-Mail-Änderung konnte nicht gestartet werden.",
        recentLoginRequired: "Bitte bestätige dein Passwort erneut und versuche es noch einmal.",
      },
    },
    changePassword: "Passwort ändern",
    disableBiometricLogin: "Face ID deaktivieren",
    deleteAccount: "Konto löschen",
    dataExport: {
      title: "Meine Daten exportieren",
      modalTitle: "Datenexport anfordern",
      modalText: "Du kannst eine Kopie aller aktuell über dich gespeicherten personenbezogenen Daten anfordern.\n\nDie Erstellung des Exports kann einige Minuten dauern.",
      description: "Du kannst eine Kopie aller aktuell über dich gespeicherten personenbezogenen Daten anfordern. Die Erstellung des Exports kann einige Minuten dauern.",
      passwordPlaceholder: "Passwort bestätigen",
      requestButton: "Export anfordern",
      confirmWithApple: "Mit Apple bestätigen",
      appleConfirmationHint: "Bestätige den Datenexport sicher mit Apple und Face ID.",
      iosRequired: "Für diesen Apple-Account ist die sichere Bestätigung derzeit in der VaultQuest-iOS-App erforderlich.",
      requested: "Exportauftrag wurde erstellt.",
      status: "Exportstatus",
      noEmail: "Für diesen Account wurde keine E-Mail-Adresse gefunden.",
      passwordRequired: "Bitte bestätige zuerst dein Passwort.",
      reauthFailed: "Passwortbestätigung fehlgeschlagen.",
      appleReauthFailed: "Die sichere Bestätigung mit Apple ist fehlgeschlagen. Bitte versuche es erneut.",
      recentAuthRequired: "Die sichere Bestätigung ist abgelaufen oder ungültig. Bitte starte den Datenexport erneut.",
      activeExists: "Für dein Konto wurde bereits ein Datenexport angefordert. Aus Sicherheitsgründen kann nur alle 24 Stunden ein neuer Export erstellt werden.",
      activeExistsWithRetry: "Für dein Konto wurde bereits ein Datenexport angefordert. Aus Sicherheitsgründen kann nur alle 24 Stunden ein neuer Export erstellt werden. Ein neuer Export ist voraussichtlich wieder ab {{time}} möglich.",
      requestError: "Exportauftrag konnte nicht erstellt werden.",
      statuses: {
        idle: "Noch kein Export",
        queued: "In Warteschlange",
        processing: "Wird verarbeitet",
        completed: "Abgeschlossen",
        failed: "Fehlgeschlagen",
      },
    },
  },
},

profileCompletion: {
  title: "Profil vervollständigen",
  text: "Bevor du an Spielen oder Turnieren teilnehmen kannst, musst du zunächst deine EA-ID und deine Konsolen-ID hinterlegen.",
  path: "Du kannst dies jederzeit unter Einstellungen → Kontoeinstellungen nachholen.",
  button: "Jetzt vervollständigen",
  dashboardHint: "Profil noch nicht vollständig.",
  dashboardCta: "Jetzt vervollständigen",
  friendTitle: "Spielprofil des Freundes unvollständig",
  friendText: "{{username}} hat seine EA-ID und Konsolen-ID noch nicht vollständig hinterlegt und kann deshalb aktuell nicht zu einem Freundschaftsspiel herausgefordert werden.",
  otherPlayerTitle: "Spielprofil des anderen Spielers unvollständig",
  otherPlayerText: "Der andere Spieler hat seine EA-ID und Konsolen-ID noch nicht vollständig hinterlegt. Das Freundschaftsspiel kann aktuell nicht gestartet werden.",
},

creatorTournaments: {
  title: "CREATOR CUP",
  intro: "Plane dein eigenes Turnier.",
  detailsSection: "TURNIERDETAILS",
  prizesSection: "PREISE",
  rulesSection: "REGELN",
  optionsSection: "OPTIONEN",
  requestsTitle: "DEINE CUP-ANFRAGEN",
  requestPlayers: "Teilnehmer",
  tournamentNamePlaceholder: "z. B. VQ Cup by Timon",
  firstPlace: "1. PLATZ",
  secondPlace: "2. PLATZ",
  thirdPlaceOptional: "3. PLATZ (OPTIONAL)",
  optional: "OPTIONAL",
  thirdPlaceShortDescription: "Aktiviere ein Spiel um den 3. Platz.",
  groupStageShortDescription: "Aktiviere eine Gruppenphase vor der K.o.-Phase.",
  readyTitle: "Bereit für deinen Cup?",
  readyText: "Deine Turnieranfrage wird vom VaultQuest-Team geprüft.",
  closeForm: "Formular schließen",
  newRequest: "+ Neue Turnieranfrage",
  editRequestTitle: "Turnieranfrage bearbeiten",
  newRequestTitle: "Neue Turnieranfrage",
  tournamentName: "Turniername",
  date: "Datum",
  startTime: "Startzeit",
  participants: "Maximale Teilnehmeranzahl",
  entryFee: "Startgebühr",
  entryFeeText: "{{coins}} Coins (festgelegt von VaultQuest)",
  prize: "Preis",
  prizePlaceholder: "20 € Amazon Gutschein",
  prizePool: "Preispool",
  prizePoolPlaceholder: "z. B. 200 €, PS5 oder PS5 + 200 €",
  prizePoolHelp: "Gib hier den gesamten Preispool so ein, wie er auf der Turnierkarte angezeigt werden soll. Beispiel: „200 €“, „PS5“ oder „PS5 + 200 €“. Die genaue Verteilung auf die Platzierungen wird weiterhin über die einzelnen Preisfelder festgelegt.",
  prizePoolRequired: "Bitte gib einen Preispool an.",
  prizePoolTooLong: "Der Preispool darf maximal 50 Zeichen lang sein.",
  prizes: "Preise",
  firstPrize: "Preis für Platz 1",
  secondPrize: "Preis für Platz 2",
  thirdPrize: "Preis für Platz 3",
  prizeEnabled: "Aktiv",
  prizeTypePayout: "Auszahlung",
  prizeTypePhysical: "Sachpreis",
  prizeAmountPlaceholder: "Betrag in €",
  prizePhysicalPlaceholder: "Sachpreis",
  prizeDescriptionPlaceholder: "Beschreibung optional",
  firstPrizePlaceholder: "1. Platz: z. B. 20 € Amazon-Gutschein",
  secondPrizePlaceholder: "2. Platz: optional",
  thirdPrizePlaceholder: "3. Platz: optional",
  thirdPrizeRequiresThirdPlaceHint: "Um einen Preis für den Drittplatzierten festzulegen, musst du das Spiel um Platz 3 aktivieren.",
  confirmClearThirdPrize: "Der Preis für Platz 3 wird entfernt. Fortfahren?",
  firstPrizeRequired: "Bitte gib einen Preis für Platz 1 an.",
  thirdPrizeNeedsSecond: "Ein Preis für Platz 3 ist nur mit einem Preis für Platz 2 möglich.",
  thirdPrizeNeedsThirdPlace: "Ein Preis für Platz 3 ist nur mit aktivem Spiel um Platz 3 möglich.",
  gameMode: "Spielmodus",
  teamChoice: "Teamwahl",
  teamChoiceCustom: "Individuell",
  teamChoicePlaceholder: "z. B. Nur Bundesliga-Teams",
  platform: "Plattform",
  rules: "Regeln",
  customRules: "Eigene Regeln",
  rulesIntro: "Diese sechs Grundregeln werden bei jedem Turnier angezeigt. Nur die dafür vorgesehenen Werte können angepasst werden.",
  rulesLoading: "Standardregeln werden geladen...",
  ruleFallback: "Regel",
  removedRules: "Entfernte Regeln",
  removeRule: "Entfernen",
  restoreRule: "Hinzufügen",
  customRulesHint: "Optional: Ergänze bis zu 5 eigene Regeln.",
  customRulePlaceholder: "Eigene Regel",
  addCustomRule: "+ Eigene Regel hinzufügen",
  visibility: "Zugang",
  standardRules: "Standard VaultQuest Regeln",
  customRulesOption: "Eigene Regeln",
  public: "Öffentlich",
  private: "Privat (Einladungscode)",
  thirdPlaceEnabled: "Spiel um Platz 3",
  thirdPlaceDescription:
    "Nach dem Halbfinale wird zusätzlich ein Match zwischen den beiden Halbfinalverlierern ausgespielt.",
  groupStageEnabled: "Gruppenphase",
  groupStageDescription:
    "Vor der K.o.-Phase wird eine Gruppenphase gespielt. Verfügbar für 8 bis 128 Teilnehmer.",
  groupStageUnavailable: "Die Gruppenphase ist nur für 8 bis 128 Teilnehmer verfügbar.",
  knockoutMultiLegMode: "KO-MODUS",
  multiLegNone: "Kein Hin-/Rückspiel",
  multiLegFromR16: "Ab Achtelfinale",
  multiLegFromQf: "Ab Viertelfinale",
  multiLegSfOnly: "Nur Halbfinale",
  finalLegs: "FINALE",
  finalLegCount: "{{count}} Spiel(e)",
  reviewNotice:
    "Diese Turnieranfrage wird zunächst vom VaultQuest-Team geprüft. Erst nach Genehmigung wird daraus ein offizielles Community-Turnier.",
  saveAgain: "Turnieranfrage erneut einreichen",
  saveRequest: "Turnieranfrage senden",
  saving: "Speichere...",
  cancel: "Abbrechen",
  loading: "Lade Turnieranfragen...",
  empty: "Du hast bisher keine Turnieranfragen erstellt.",
  loadError: "Turnieranfragen konnten nicht geladen werden.",
  saveError: "Turnieranfrage konnte nicht gespeichert werden.",
  createdMessage: "Turnieranfrage wurde erstellt und wartet auf Genehmigung.",
  updatedMessage: "Turnieranfrage wurde erneut eingereicht und wartet auf Genehmigung.",
  approved: "Genehmigt",
  rejected: "Abgelehnt",
  needsChanges: "Änderungen erforderlich",
  deleted: "Turnier gelöscht",
  withdrawn: "Zurückgezogen",
  pending: "Wartet auf Genehmigung",
  status: "Status",
  approvedAt: "Genehmigt am",
  approvedBy: "Genehmigt von",
  createdAt: "Erstellt",
  changeRequest: "Änderungswunsch",
  rejectionReason: "Ablehnungsgrund",
  editRequest: "Anfrage bearbeiten",
  editPendingRequest: "Anfrage bearbeiten",
  withdrawRequest: "Anfrage zurückziehen",
  openTournament: "Zum Turnier",
  hideSwipeLabel: "Löschen",
  hideConfirmTitle: "Turnier aus Übersicht entfernen?",
  hideConfirmText:
    "Dieses Turnier wird nur aus deiner persönlichen Übersicht entfernt.\n\nDas Turnier selbst wird nicht gelöscht.",
  hideDelete: "Löschen",
  hideCancel: "Abbrechen",
  hideError: "Der Eintrag konnte nicht aus deiner Übersicht entfernt werden.",
  withdrawnMessage: "Turnieranfrage wurde zurückgezogen.",
  withdrawError: "Turnieranfrage konnte nicht zurückgezogen werden.",
  timeSuffix: "Uhr",
},

competitionTerms: {
  title: "Wettbewerbsbedingungen",
  updated: "Stand: August 2026",
  intro:
    "Diese Wettbewerbsbedingungen gelten für alle über VaultQuest durchgeführten Turniere und Wettbewerbe. Mit der Teilnahme an einem Turnier erkennen Teilnehmer diese Wettbewerbsbedingungen sowie die für das jeweilige Turnier angezeigten Turnierregeln an.",
  sections: [
    {
      title: "1. Veranstalter und Sponsor",
      blocks: [
        {
          text: "Die über VaultQuest angebotenen Wettbewerbe werden von VaultQuest veranstaltet und gesponsert.",
        },
        {
          text: "Creator können einzelne Turniere als Creator Cups hosten und zusätzliche Turnierregeln festlegen. Die Durchführung des Wettbewerbs sowie die Verantwortung für ausgeschriebene Preise gegenüber den Teilnehmern verbleiben bei VaultQuest.",
        },
      ],
    },
    {
      title: "2. Keine Verbindung zu Apple oder Electronic Arts",
      blocks: [
        {
          text: "Apple Inc. ist weder Sponsor noch Veranstalter der über VaultQuest angebotenen Wettbewerbe und ist in keiner Weise an deren Durchführung beteiligt.",
        },
        {
          text: "Die über VaultQuest angebotenen EA SPORTS FC-Wettbewerbe stehen in keiner Verbindung zu Electronic Arts Inc. oder deren Lizenzgebern und werden von diesen weder gesponsert noch unterstützt.",
        },
        {
          text: "Bezeichnungen wie „EA SPORTS FC“ oder „Ultimate Team“ dienen ausschließlich der Beschreibung des verwendeten Spiels bzw. Spielmodus.",
        },
      ],
    },
    {
      title: "3. Teilnahme",
      blocks: [
        {
          text: "Für die Teilnahme ist ein gültiger VaultQuest-Account erforderlich. Teilnehmer sind dafür verantwortlich, dass die in ihrem Account hinterlegten spielbezogenen Angaben, insbesondere EA-ID und Konsolen-ID, korrekt sind.",
        },
        {
          text: "Für die Durchführung eines Matches müssen die Teilnehmer über das für das jeweilige Turnier erforderliche Spiel, eine unterstützte Plattform und die notwendigen technischen Voraussetzungen verfügen.",
        },
        {
          text: "Die Teilnahmegebühr eines Turniers wird vor dem Beitritt angezeigt und gegebenenfalls in VaultQuest-Coins erhoben.",
        },
      ],
    },
    {
      title: "4. Turnierregeln",
      blocks: [
        {
          text: "Für jedes Turnier werden die jeweils geltenden Spiel- und Turnierregeln in VaultQuest angezeigt.",
        },
        {
          text: "Hierzu können insbesondere Spielmodus, Spieldauer, Plattform und weitere Vorgaben gehören.",
        },
        {
          text: "Bei Creator Cups können zusätzlich vom Creator festgelegte Regeln gelten. Creator-Regeln dürfen diesen Wettbewerbsbedingungen nicht widersprechen. Im Falle eines Widerspruchs haben diese Wettbewerbsbedingungen Vorrang.",
        },
      ],
    },
    {
      title: "5. Ergebnisse und Reporting",
      blocks: [
        {
          text: "Teilnehmer sind verpflichtet, Matchergebnisse vollständig und wahrheitsgemäß über das vorgesehene Reporting-System zu melden.",
        },
        {
          text: "Bewusst falsche Ergebnismeldungen, manipulierte Nachweise oder sonstige Täuschungsversuche sind untersagt.",
        },
        {
          text: "Für die Meldung von Ergebnissen und die Durchführung erforderlicher Aktionen gelten die innerhalb des Matches angezeigten Fristen.",
        },
      ],
    },
    {
      title: "6. Gruppenphase und Rulings",
      blocks: [
        {
          text: "In Turnieren mit Gruppenphase wird die Platzierung anhand der erzielten Ergebnisse bestimmt.",
        },
        {
          text: "Bei Punktgleichheit entscheidet in dieser Reihenfolge:",
        },
        {
          type: "ordered",
          items: ["Direkter Vergleich", "Tordifferenz", "Erzielte Tore", "Weniger Gegentore", "Entscheidungsspiele"],
        },
        {
          text: "Kann ein für die weitere Turnierdurchführung relevanter Gleichstand dadurch nicht aufgelöst werden, absolvieren die betroffenen Spieler zusätzliche Ruling Games, bis die erforderlichen Platzierungen eindeutig feststehen.",
        },
        {
          text: "Ruling Games werden in separaten Ruling Rounds durchgeführt und nach denselben sportlichen Kriterien ausgewertet.",
        },
        {
          text: "Eine zufällige Auslosung zur Bestimmung der Qualifikation oder Platzierung findet nicht statt.",
        },
      ],
    },
    {
      title: "7. Konflikte und Nachweise",
      blocks: [
        {
          text: "Bei widersprüchlichen Ergebnismeldungen oder anderen Unstimmigkeiten kann ein Konflikt eröffnet werden.",
        },
        {
          text: "VaultQuest kann die von den Teilnehmern eingereichten Meldungen, Nachweise und sonstigen für das Match verfügbaren Informationen zur Klärung heranziehen.",
        },
        {
          text: "Teilnehmer sind verpflichtet, angeforderte Nachweise innerhalb der jeweils angegebenen Frist einzureichen.",
        },
        {
          text: "Die nach Abschluss der Konfliktprüfung getroffene Entscheidung ist für die weitere Turnierauswertung maßgeblich.",
        },
      ],
    },
    {
      title: "8. Nichtantritt und Fristen",
      blocks: [
        {
          text: "Teilnehmer sind dafür verantwortlich, ihre Matches innerhalb der vorgegebenen Zeit durchzuführen und die erforderlichen Meldungen fristgerecht abzugeben.",
        },
        {
          text: "Erscheint ein Teilnehmer nicht oder erfüllt die innerhalb des Matches vorgesehenen Anforderungen nicht rechtzeitig, kann das Match entsprechend den in VaultQuest vorgesehenen No-Show- und Reporting-Regeln zugunsten des Gegners gewertet werden.",
        },
      ],
    },
    {
      title: "9. Technische Voraussetzungen der Teilnehmer",
      blocks: [
        {
          text: "Jeder Teilnehmer ist selbst dafür verantwortlich, über eine funktionsfähige Internetverbindung, das erforderliche Spiel, eine geeignete Spielplattform und sonstige für die Durchführung des Matches notwendige technische Voraussetzungen zu verfügen.",
        },
        {
          text: "Individuelle technische Probleme eines Teilnehmers begründen grundsätzlich keinen Anspruch auf Wiederholung eines Matches oder Änderung eines festgestellten Ergebnisses.",
        },
      ],
    },
    {
      title: "10. Manipulation und unsportliches Verhalten",
      blocks: [
        {
          text: "Untersagt sind insbesondere:",
        },
        {
          type: "unordered",
          items: [
            "Cheating oder die Verwendung unzulässiger Hilfsmittel,",
            "Absprachen zur Manipulation von Matchergebnissen oder Turnierplatzierungen,",
            "bewusst falsche Ergebnismeldungen,",
            "manipulierte oder gefälschte Nachweise,",
            "die missbräuchliche Nutzung mehrerer Accounts,",
            "die Umgehung von Sperren oder Teilnahmebeschränkungen sowie",
            "sonstige vorsätzliche Manipulationen des Wettbewerbs.",
          ],
        },
        {
          text: "VaultQuest kann bei entsprechenden Verstößen Matches gegen einen Teilnehmer werten, Teilnehmer disqualifizieren oder weitere nach den VaultQuest-Regeln vorgesehene Maßnahmen ergreifen.",
        },
      ],
    },
    {
      title: "11. Qualifikation und Gewinnerermittlung",
      blocks: [
        {
          text: "Die Qualifikation für weitere Turnierrunden sowie die endgültige Platzierung werden anhand der nach diesen Wettbewerbsbedingungen und den jeweiligen Turnierregeln festgestellten Ergebnisse bestimmt.",
        },
        {
          text: "In der KO-Phase scheidet der unterlegene Teilnehmer eines Matches aus, soweit der jeweilige Turniermodus nichts anderes vorsieht.",
        },
        {
          text: "Gewinner eines Turniers ist der Teilnehmer, der nach Abschluss aller erforderlichen Turnierrunden als Sieger feststeht.",
        },
      ],
    },
    {
      title: "12. Preise",
      blocks: [
        {
          text: "Art und Höhe eines möglichen Preises werden vor Beginn des jeweiligen Turniers in VaultQuest angezeigt.",
        },
        {
          text: "VaultQuest ist gegenüber den Teilnehmern für die Bereitstellung bzw. Auszahlung des ausgeschriebenen Preises verantwortlich.",
        },
        {
          text: "Ein Anspruch besteht ausschließlich auf den für das jeweilige Turnier angegebenen Preis. Eine Auszahlung oder Bereitstellung erfolgt erst, nachdem das Turnier vollständig abgeschlossen und das Ergebnis endgültig festgestellt wurde.",
        },
        {
          text: "Creator Cups können von Creatorn gehostet werden. Die Abwicklung und Bereitstellung des gegenüber den Teilnehmern ausgeschriebenen Preises erfolgt jedoch über VaultQuest.",
        },
      ],
    },
    {
      title: "13. Verhältnis zu den jeweiligen Turnierregeln",
      blocks: [
        {
          text: "Diese Wettbewerbsbedingungen bilden die verbindliche Grundlage für alle über VaultQuest durchgeführten Wettbewerbe.",
        },
        {
          text: "Die bei einem konkreten Turnier angezeigten Standardregeln und gegebenenfalls zusätzlichen Creator-Regeln ergänzen diese Bedingungen.",
        },
        {
          text: "Sie können diese Wettbewerbsbedingungen nicht außer Kraft setzen oder ihnen widersprechen.",
        },
      ],
    },
  ],
},








impressum: {
  title: "Impressum",
  section5TMG: "Angaben gemäß § 5 DDG",
  contentResponsible: "Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV",
projectStatus: "Hinweis zum Projektstatus",
projectStatusText1: "VaultQuest befindet sich derzeit in einer öffentlichen Beta- und Weiterentwicklungsphase.",
projectStatusText2: "Die Plattform wird kontinuierlich weiterentwickelt, verbessert und an neue technische sowie organisatorische Anforderungen angepasst. Funktionen können ergänzt, geändert oder vorübergehend eingeschränkt werden.",
projectStatusText3: "Über die Plattform erfolgt derzeit kein Verkauf eigener Produkte durch VaultQuest.",
liabilityContentTitle: "Haftung für Inhalte",
liabilityContentText1: "Als Diensteanbieter bin ich nach den allgemeinen gesetzlichen Vorschriften für eigene Inhalte auf diesen Seiten verantwortlich.",
liabilityContentText2: "Als Diensteanbieter bin ich jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen dauerhaft zu überwachen oder aktiv nach rechtswidrigen Tätigkeiten zu forschen.",
liabilityLinksTitle: "Haftung für Links",
liabilityLinksText: "Diese Website kann Links zu externen Websites Dritter enthalten, auf deren Inhalte kein Einfluss besteht. Für diese fremden Inhalte wird daher keine Gewähr übernommen.",
copyrightTitle: "Urheberrecht",
copyrightText1: "Die durch den Seitenbetreiber erstellten Inhalte und Werke auf dieser Website und innerhalb der VaultQuest-Web-App unterliegen dem deutschen Urheberrecht. Dies gilt insbesondere auch für Quellcode, Designs, Grafiken, Logos sowie sonstige Bestandteile der VaultQuest-Web-App.",
copyrightText2: "Eine Vervielfältigung, Bearbeitung oder Verbreitung außerhalb der Grenzen des Urheberrechts bedarf der vorherigen schriftlichen Zustimmung.",
},

aiConflictConsentPrompt: {
  title: "KI-GESTÜTZTE KONFLIKTANALYSE",
  text1:
    "VaultQuest kann OpenAI einsetzen, um unsere Administratoren bei der Prüfung von Konfliktfällen zu unterstützen. Dabei können konfliktbezogene Daten, Match-Chat-Nachrichten und hochgeladene Nachweise durch OpenAI verarbeitet werden.",
  text2:
    "Die KI trifft keine endgültige Entscheidung. Die Entscheidung über den Konfliktfall trifft weiterhin ein VaultQuest-Administrator.",
  text3BeforePrivacy: "Weitere Informationen findest du in unserer",
  text3AfterPrivacy: ".",
  agree: "ZUSTIMMEN",
  notNow: "NICHT JETZT",
},

privacy: {
  title: "Datenschutzerklärung",
  section1Title: "1. Datenschutz auf einen Blick",
  section1Text1: "Der Schutz Ihrer personenbezogenen Daten ist uns ein wichtiges Anliegen. Nachfolgend informieren wir Sie darüber, welche personenbezogenen Daten bei der Nutzung von VaultQuest verarbeitet werden, zu welchen Zwecken dies geschieht und welche Rechte Ihnen nach den geltenden Datenschutzbestimmungen zustehen.",
  section1Text2: "Personenbezogene Daten sind alle Informationen, die sich auf eine identifizierte oder identifizierbare natürliche Person beziehen. Hierzu gehören insbesondere Ihre E-Mail-Adresse, Ihr Benutzername, Ihre IP-Adresse sowie weitere Angaben, die Sie im Rahmen der Registrierung oder Nutzung von VaultQuest bereitstellen.",
  section1Text3: "Die Verarbeitung Ihrer personenbezogenen Daten erfolgt, um Ihnen die Nutzung von VaultQuest als Plattform für Online-Turniere, Community-Turniere, Einzel- und Freundschaftsspiele sowie die damit verbundenen Funktionen wie Matchmaking, Ergebnis-Reporting, Konfliktbearbeitung, Kommunikation, Community-Funktionen, Support und sicherheitsrelevante Systemfunktionen bereitzustellen.",
section2Title: "2. Verantwortliche Stelle",
section2Text1: "Verantwortlicher für die Verarbeitung personenbezogener Daten im Sinne der Datenschutz-Grundverordnung (DSGVO) ist:",
controllerName: "Timon Eßer",
controllerStreet: "Lessingstraße 14",
controllerCity: "77966 Kappel-Grafenhausen",
controllerCountry: "Deutschland",
controllerEmailLabel: "E-Mail",
controllerEmail: "info@vaultquest.de",

section3Title: "3. Anwendungsbereich",
section3Text1: "Diese Datenschutzerklärung gilt für die Nutzung der Website, Web-App sowie der mobilen Anwendungen von VaultQuest und für alle damit zusammenhängenden digitalen Angebote und Kommunikationswege.",
section3Text2: "Sie gilt insbesondere für:",
section3List1: "den Besuch der Website,",
section3List2: "die Registrierung und Nutzung eines Benutzerkontos,",
section3List3: "die Teilnahme an Turnieren, Community-Turnieren, Einzel- und Freundschaftsspielen,",
section3List4: "die Nutzung von Matchmaking-, Reporting-, Konflikt-, Chat- und Community-Funktionen,",
section3List5: "den Erhalt von Push-Benachrichtigungen, Systemnachrichten und E-Mails,",
section3List6: "die Kontaktaufnahme mit uns sowie die Nutzung unserer Support-Funktionen.",

section4Title: "4. Welche personenbezogenen Daten wir erfassen",

section41Title: "4.1 Daten, die Sie uns selbst mitteilen",
section41Text1: "Wenn Sie VaultQuest nutzen, verarbeiten wir personenbezogene Daten, die Sie uns aktiv zur Verfügung stellen. Hierzu gehören insbesondere:",
section41List1: "E-Mail-Adresse",
section41List2: "Benutzername",
section41List3: "optionale Altersangabe",
section41List4: "Konsolenart",
section41List5: "EA-ID und Konsolen-ID (nach freiwilliger Profilvervollständigung)",
section41List6: "Anmeldedaten im Rahmen der Authentifizierung (über Firebase Authentication)",
section41List7: "Inhalte von Supportanfragen oder sonstigen Nachrichten an uns",
section41List8: "Angaben im Rahmen von Turnieren, Community-Turnieren, Einzel- und Freundschaftsspielen",
section41List9: "Meldungen von Spielergebnissen und Konfliktfällen",
section41List10: "hochgeladene Nachweise (z. B. Screenshots oder Bilder)",
section41List11: "Chatnachrichten im Zusammenhang mit Matches oder Support",

section42Title: "4.2 Daten, die bei der Nutzung automatisch verarbeitet werden",
section42Text1: "Beim Besuch der Website, der Web-App oder der mobilen Anwendungen können automatisch technische Daten verarbeitet werden. Hierzu gehören insbesondere:",
section42List1: "IP-Adresse",
section42List2: "Datum und Uhrzeit des Zugriffs",
section42List3: "Browsertyp und Browserversion",
section42List4: "verwendetes Betriebssystem",
section42List5: "Gerätetyp",
section42List6: "Referrer-URL",
section42List7: "technische Fehler-, Protokoll- und Audit-Log-Daten",
section42List8: "Push-Token und gerätebezogene Informationen für Push-Benachrichtigungen (sofern aktiviert)",
section42List9: "technische Informationen zur Stabilität, Sicherheit und Funktionsfähigkeit der Plattform",
section42Text2: "Diese Daten werden verarbeitet, um den sicheren Betrieb, die Stabilität und die technische Bereitstellung von VaultQuest sicherzustellen.",

section43Title: "4.3 Daten aus der Nutzung der Plattform",
section43Text1: "Im Rahmen der Nutzung von VaultQuest verarbeiten wir außerdem personenbezogene Daten, die bei der Verwendung der Plattform entstehen. Hierzu gehören insbesondere:",
section43List1: "Teilnahme an Turnieren, Community-Turnieren, Einzel- und Freundschaftsspielen",
section43List2: "Matchmaking und Match-Zuweisungen",
section43List3: "Ergebnisse, Platzierungen, Statistiken und Leaderboard-Daten",
section43List4: "Meldungen von Spielergebnissen",
section43List5: "Konfliktfälle und deren Bearbeitung",
section43List6: "hochgeladene Nachweise und Evidence-Dateien",
section43List7: "Freundschaften, Freundschaftsanfragen und Blockierungen",
section43List8: "Community- und Creator-Funktionen",
section43List9: "Support-, Admin-Help- und Nutzermeldungen",
section43List10: "Systemnachrichten, Push-Benachrichtigungen und E-Mails",
section43List11: "Gewinn-, Gutschein- und Belohnungsinformationen",

section5Title: "5. Zwecke der Datenverarbeitung",
section5Text1: "Wir verarbeiten personenbezogene Daten zu folgenden Zwecken:",
section5List1: "Bereitstellung, Betrieb und Weiterentwicklung der Website, Web-App und mobilen Anwendungen",
section5List2: "Einrichtung, Verwaltung und Sicherung von Benutzerkonten",
section5List3: "Durchführung von Turnieren, Community-Turnieren, Einzel- und Freundschaftsspielen",
section5List4: "Matchmaking sowie Anzeige von Gegnern, Match-Informationen, Statistiken und Leaderboards",
section5List5: "Ergebnis-Reporting sowie Bearbeitung von Konfliktfällen einschließlich der Auswertung hochgeladener Nachweise",
section5List6: "Bereitstellung von Community-Funktionen wie Freundschaften, Blockierungen, Chats und Creator-Turnieren",
section5List7: "Versand von Systemnachrichten, Push-Benachrichtigungen und E-Mails, insbesondere im Zusammenhang mit Registrierung, Passwort-Reset, Support, Turnieren, Gewinnen und sicherheitsrelevanten Ereignissen",
section5List8: "Bearbeitung von Supportanfragen, Admin-Help-Anfragen und Nutzermeldungen",
section5List9: "Administration der Plattform sowie Moderation, Missbrauchsprävention und Durchsetzung der Plattformregeln",
section5List10: "Gewährleistung der technischen Funktionsfähigkeit, Stabilität und Sicherheit der Plattform einschließlich Fehleranalyse und Auditierung administrativer Vorgänge",
section5List11: "Erkennung, Verhinderung und Nachverfolgung von Betrugsversuchen, Manipulationen, Regelverstößen und sonstigem Missbrauch",
section5List12: "Erfüllung gesetzlicher Verpflichtungen",

section6Title: "6. Rechtsgrundlagen der Verarbeitung",
section6Text1: "Die Verarbeitung Ihrer personenbezogenen Daten erfolgt auf Grundlage der Datenschutz-Grundverordnung (DSGVO), insbesondere auf Basis folgender Rechtsgrundlagen:",
section6Sub1Title: "Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung)",
section6Sub1Text: "Soweit die Verarbeitung zur Durchführung des Nutzungsverhältnisses erforderlich ist. Hierzu zählen insbesondere die Registrierung und Verwaltung des Benutzerkontos, die Teilnahme an Turnieren, Community-Turnieren, Einzel- und Freundschaftsspielen, Matchmaking, Ergebnis-Reporting, Konfliktbearbeitung, Community-Funktionen sowie die Bereitstellung von Benachrichtigungen und Support.",
section6Sub2Title: "Art. 6 Abs. 1 lit. c DSGVO (Rechtliche Verpflichtung)",
section6Sub2Text: "Soweit wir gesetzlich verpflichtet sind, personenbezogene Daten zu verarbeiten oder aufzubewahren.",
section6Sub3Title: "Art. 6 Abs. 1 lit. f DSGVO (Berechtigtes Interesse)",
section6Sub3Text: "Soweit die Verarbeitung zur Wahrung unserer berechtigten Interessen erforderlich ist. Hierzu gehören insbesondere die Gewährleistung der Sicherheit und Stabilität der Plattform, die Verhinderung und Aufklärung von Missbrauch, Betrug und Regelverstößen, die technische Fehleranalyse, die Moderation der Plattform, die Nachvollziehbarkeit administrativer Vorgänge sowie die Weiterentwicklung unserer Dienste.",
section6Sub4Title: "Art. 6 Abs. 1 lit. a DSGVO (Einwilligung)",
section6Sub4Text: "Soweit Sie uns eine Einwilligung erteilt haben, beispielsweise für optionale Funktionen oder Benachrichtigungen, deren Verarbeitung auf einer Einwilligung beruht. Eine erteilte Einwilligung kann jederzeit mit Wirkung für die Zukunft widerrufen werden.",

section7Title: "7. Registrierung und Benutzerkonto",
section7Text1: "Die Nutzung wesentlicher Funktionen von VaultQuest setzt die Erstellung eines Benutzerkontos voraus. Im Rahmen der Registrierung und der Verwaltung Ihres Benutzerkontos verarbeiten wir insbesondere folgende personenbezogene Daten:",
section7List1: "E-Mail-Adresse",
section7List2: "Benutzername",
section7List3: "Authentifizierungsdaten (über Firebase Authentication, einschließlich Sign in with Apple, sofern Sie diesen Anmeldeweg verwenden)",
section7List4: "Kontostatus",
section7List5: "optionale Profilangaben (z. B. Altersangabe, Konsolenart, EA-ID oder Konsolen-ID)",
section7List6: "mit dem Benutzerkonto verknüpfte Spiel-, Match-, Turnier-, Community- und Statistikinformationen",
section7Text2: "Die Verarbeitung dieser Daten ist erforderlich, um Ihnen ein persönliches Benutzerkonto bereitzustellen, Ihre Identität bei der Anmeldung zu überprüfen, Ihr Konto zu verwalten sowie die vertragsgemäße Nutzung der Plattform zu ermöglichen. Bei der Nutzung von Sign in with Apple kann Apple je nach Ihrer Auswahl eine Private-Relay-E-Mail-Adresse bereitstellen; VaultQuest verarbeitet dabei nur die für Anmeldung und Accountverknüpfung erforderlichen Daten.",

section8Title: "8. Turniere, Einzelspiele, Statistiken und Reporting",
section8Text1: "Wenn Sie an Turnieren, Community-Turnieren, Einzel- oder Freundschaftsspielen teilnehmen, verarbeiten wir die hierfür erforderlichen personenbezogenen Daten. Community-Turniere umfassen auch von Nutzern oder Creatorn organisierte Wettbewerbe. Hierzu gehören insbesondere:",
section8List1: "Benutzername",
section8List2: "Teilnahme an Wettbewerben",
section8List3: "Matchmaking und Gegnerzuweisungen",
section8List4: "Spiel-, Match- und Turnierstatus",
section8List5: "gemeldete Spielergebnisse",
section8List6: "Platzierungen",
section8List7: "Statistiken (z. B. Siege, Niederlagen, Turnierteilnahmen, Turniersiege, gewonnene Coins und weitere leistungsbezogene Daten innerhalb der Plattform)",
section8List8: "Leaderboard-Informationen",
section8Text2: "Diese Daten sind erforderlich, um den Spiel- und Wettbewerbsbetrieb technisch und organisatorisch durchführen zu können.",
section8Text3: "Benutzernamen, Platzierungen, Ergebnisse, Leaderboards und statistische Werte können innerhalb der Plattform für andere Nutzer sichtbar angezeigt werden, soweit dies für den Betrieb der Plattform erforderlich ist.",

section9Title: "9. Konfliktfälle und Nachweis-Uploads",
section9Text1: "Wird ein Spielergebnis angefochten oder entsteht ein Konfliktfall, können im Rahmen der Konfliktbearbeitung zusätzliche personenbezogene Daten verarbeitet werden. Hierzu gehören insbesondere:",
section9List1: "Angaben aus dem Konfliktfall",
section9List2: "gemeldete Spielergebnisse",
section9List3: "hochgeladene Screenshots oder Bilder als Nachweise",
section9List4: "Zeitpunkte der Meldungen und Uploads",
section9List5: "Zuordnung der Nachweise zu den beteiligten Nutzern",
section9List6: "Bearbeitungs- und Entscheidungsinformationen im Rahmen des Konfliktverfahrens",
section9Text2: "Diese Daten dienen ausschließlich der Prüfung, Bearbeitung und Entscheidung des jeweiligen Konfliktfalls sowie der Sicherstellung eines fairen Wettbewerbsbetriebs.",
section9Text3: "Bitte laden Sie ausschließlich Nachweise hoch, die für die Bearbeitung des jeweiligen Konfliktfalls erforderlich sind.",
section9Text4: "Nachweise können auf einer cloudbasierten Speicherinfrastruktur verarbeitet und gespeichert werden. Konfliktbezogene Daten dürfen ausschließlich von berechtigten Administratoren eingesehen und verarbeitet werden, soweit dies für die Bearbeitung des jeweiligen Konfliktfalls erforderlich ist.",
section91Title: "9.1 KI-gestützte Konfliktanalyse",
section91Text1: "Zur Unterstützung der manuellen Bearbeitung von Konfliktfällen kann VaultQuest automatisierte bzw. KI-gestützte Analysesysteme einsetzen, wenn hierfür die ausdrückliche Zustimmung der beteiligten Nutzer vorliegt. Der derzeit aktiv eingesetzte externe KI-Dienstleister hierfür ist OpenAI Ireland Limited („OpenAI“). Im Rahmen dieser Analyse können insbesondere folgende Daten an OpenAI übermittelt und dort verarbeitet werden:",
section91List1: "VaultQuest-Benutzernamen der beteiligten Nutzer",
section91List2: "Match- und Turnierinformationen einschließlich Match-, Turnier- und Konfliktkennungen sowie technischer Zuordnungsinformationen",
section91List3: "gemeldete Ergebnisse, Konfliktdaten, Reportgründe und Zeitstempel",
section91List4: "Konsolenart",
section91List5: "konfliktbezogene Match-Chat-Nachrichten",
section91List6: "hochgeladene Nachweisbilder oder Screenshots",
section91List7: "technische Metadaten zu Nachweisen, soweit sie für die Zuordnung und Prüfung des konkreten Konfliktfalls erforderlich sind",
section91Text2: "Nicht gezielt für die KI-Analyse übermittelt werden insbesondere E-Mail-Adresse, Firebase UID, konkrete EA-ID, konkrete Konsolen-ID, IP-Adresse, Coins, Gutscheininformationen und Trust-Level.",
section91Text3: "Nutzer können jedoch selbst personenbezogene Daten in Chats, Screenshots oder sonstigen Nachweisen sichtbar machen; solche Inhalte können dann Bestandteil der KI-gestützten Analyse sein.",
section91Text4: "Nachweisbilder können serverseitig aus Firebase Storage geladen und zur Analyse an OpenAI übermittelt werden, soweit dies für die Prüfung des konkreten Konfliktfalls erforderlich ist.",
section91Text5: "Die innerhalb von VaultQuest erzeugten Ergebnisse der KI-Analyse werden dem jeweiligen Konfliktfall zugeordnet, ausschließlich berechtigten Administratoren zugänglich gemacht und entsprechend den für Konfliktfälle geltenden Speicher- und Löschfristen gelöscht.",
section91Text6: "Die KI-Analyse dient ausschließlich der Unterstützung und Empfehlung für berechtigte VaultQuest-Administratoren. Die endgültige Entscheidung über einen Konfliktfall und daraus resultierende Maßnahmen wird durch berechtigte Administratoren von VaultQuest getroffen.",
section91TextConsent: "VaultQuest bleibt ab 13 Jahren nutzbar. Die OpenAI-gestützte Konfliktanalyse wird nur volljährigen Nutzern angeboten. Minderjährige Nutzer können keine Zustimmung zur OpenAI-gestützten Konfliktanalyse erteilen; ihre Konfliktfälle werden ohne externe KI-Analyse manuell durch berechtigte Administratoren bearbeitet. Die Zustimmung zur OpenAI-gestützten Konfliktanalyse ist freiwillig, kann jederzeit mit Wirkung für die Zukunft widerrufen werden und ist keine Voraussetzung für die normale Nutzung von VaultQuest. Liegt für einen Konfliktfall nicht von allen beteiligten Nutzern eine gültige Zustimmung vor, erfolgt keine externe KI-Analyse dieses Konflikts; der Konfliktfall wird dann manuell durch berechtigte Administratoren bearbeitet.",
section91Text7: "Rechtsgrundlage für die Übermittlung und Verarbeitung personenbezogener Daten im Rahmen der optionalen OpenAI-gestützten Konfliktanalyse ist die von den betroffenen Nutzern ausdrücklich erteilte Einwilligung gemäß Art. 6 Abs. 1 lit. a DSGVO. Die Einwilligung ist freiwillig und kann jederzeit mit Wirkung für die Zukunft widerrufen werden. Die hiervon unabhängige manuelle Konfliktbearbeitung erfolgt auf Grundlage der jeweils einschlägigen Rechtsgrundlagen, insbesondere Art. 6 Abs. 1 lit. b und lit. f DSGVO.",
section91Text8: "Nach aktuellen Informationen von OpenAI werden API-Eingaben und -Ausgaben grundsätzlich nicht zum Training oder zur Verbesserung der Modelle verwendet, sofern keine entsprechende Datenfreigabe aktiviert wurde. API-Daten können durch OpenAI grundsätzlich bis zu 30 Tage zur Bereitstellung des Dienstes und zur Missbrauchsüberwachung aufbewahrt werden.",
section91Text9: "Bei Nutzern im Europäischen Wirtschaftsraum ist OpenAI Ireland Limited der relevante Anbieter. Eine Verarbeitung oder Übermittlung außerhalb der EU bzw. des EWR kann dabei nicht ausgeschlossen werden; sie erfolgt, soweit erforderlich, auf Grundlage geeigneter Garantien wie Angemessenheitsbeschlüssen oder Standardvertragsklauseln.",

section10Title: "10. Gewinne, Gutscheine und Benachrichtigungen",
section10Text1: "Im Rahmen von Turnieren, Community-Turnieren oder sonstigen Aktionen können Gewinne, Belohnungen, Gutscheine oder Preisgelder vergeben werden.",
section10Text2: "Wenn Sie einen Gewinn erhalten, verarbeiten wir die hierfür erforderlichen personenbezogenen Daten, insbesondere:",
section10List1: "Benutzername",
section10List2: "E-Mail-Adresse",
section10List3: "turnier- oder aktionsbezogene Gewinninformationen",
section10List4: "Gutscheininformationen",
section10List5: "Versand- und Benachrichtigungsdaten",
section10Text3: "Die Übermittlung von Gutscheincodes, Gewinninformationen und sonstigen turnierbezogenen Benachrichtigungen erfolgt über das Benachrichtigungssystem von VaultQuest sowie – sofern erforderlich – zusätzlich an die bei uns hinterlegte E-Mail-Adresse.",

section11Title: "11. Kommunikation und Support",
section11Text1: "Wenn Sie mit uns Kontakt aufnehmen oder Support-Funktionen innerhalb von VaultQuest nutzen, verarbeiten wir die personenbezogenen Daten, die Sie uns im Rahmen Ihrer Anfrage oder Nachricht zur Verfügung stellen. Hierzu gehören insbesondere:",
section11List1: "E-Mail-Adresse",
section11List2: "Name oder Benutzername (soweit angegeben)",
section11List3: "Inhalt Ihrer Nachricht",
section11List4: "technische Angaben zur Fehlerbeschreibung",
section11List5: "Support-, Admin-Help- oder Nutzermeldungen",
section11Text2: "Die Verarbeitung erfolgt ausschließlich zur Bearbeitung Ihres Anliegens, zur Kommunikation mit Ihnen sowie zur Verbesserung der Sicherheit und Funktionsfähigkeit der Plattform.",

section12Title: "12. Hosting, technische Infrastruktur und eingesetzte Dienste",
section12Text1: "Zur Bereitstellung und zum Betrieb von VaultQuest nutzen wir technische Dienstleister und Cloud-Infrastruktur.",
section12Text2: "Hierzu gehören insbesondere:",
section12List1: "Google Firebase (Google Ireland Limited) für Authentifizierung, Datenbank, Cloud Storage, Cloud Functions und Firebase Cloud Messaging sowie Apple Push Notification Service (APNs) für Push-Benachrichtigungen in der iOS-App",
section12List2: "Google Cloud (Google Ireland Limited) für Hosting und technische Infrastruktur",
section12List3: "Resend für den Versand bestimmter E-Mails (z. B. Registrierungs-, Passwort-Reset-, Support- oder Gewinnbenachrichtigungen)",
section12List4: "OpenAI (OpenAI Ireland Limited) für die KI-gestützte Analyse von Konfliktfällen und Nachweisen zur Unterstützung der administrativen Konfliktbearbeitung",
section12Text3: "Diese Dienste werden insbesondere für folgende Zwecke eingesetzt:",
section12PurposeList1: "Hosting",
section12PurposeList2: "Authentifizierung",
section12PurposeList3: "Datenbankbetrieb",
section12PurposeList4: "Cloud-Speicherung",
section12PurposeList5: "serverseitige Funktionen",
section12PurposeList6: "optionale Push-Benachrichtigungen, die über die Geräteeinstellungen verwaltet oder widerrufen werden können",
section12PurposeList7: "E-Mail-Versand",
section12Text4: "Soweit externe Dienstleister personenbezogene Daten in unserem Auftrag verarbeiten, erfolgt dies ausschließlich im Rahmen einer Auftragsverarbeitung gemäß Art. 28 DSGVO oder auf Grundlage einer anderen datenschutzrechtlich zulässigen Rechtsgrundlage.",


section13Title: "13. Empfänger von Daten",
section13Text1: "Eine Weitergabe Ihrer personenbezogenen Daten erfolgt ausschließlich, soweit dies gesetzlich zulässig und für den Betrieb von VaultQuest erforderlich ist. Empfänger können insbesondere sein:",
section13List1: "Hosting- und Cloud-Dienstleister",
section13List2: "Authentifizierungs- und Backend-Dienstleister",
section13List3: "Speicher- und Datenbankdienstleister",
section13List4: "E-Mail- und Benachrichtigungsdienstleister",
section13List5: "sonstige Auftragsverarbeiter, die uns beim technischen Betrieb der Plattform unterstützen",
section13List6: "KI-Dienstleister, soweit sie zur unterstützenden Analyse von Konfliktfällen und Nachweisen eingesetzt werden",
section13Text2: "Eine Weitergabe personenbezogener Daten zu Werbezwecken an unbeteiligte Dritte erfolgt nicht.",

section14Title: "14. Drittlandübermittlungen",
section14Text1: "Bei der Nutzung einzelner technischer Dienste kann eine Verarbeitung personenbezogener Daten auch außerhalb der Europäischen Union (EU) oder des Europäischen Wirtschaftsraums (EWR) erfolgen.",
section14Text2: "Dies betrifft insbesondere cloudbasierte Dienste von Google, den E-Mail-Dienstleister Resend sowie OpenAI im Zusammenhang mit der KI-gestützten Konfliktanalyse.",
section14Text3: "Soweit hierbei personenbezogene Daten in Drittländer übermittelt werden, erfolgt dies ausschließlich unter Einhaltung der datenschutzrechtlichen Vorgaben der DSGVO, insbesondere auf Grundlage eines Angemessenheitsbeschlusses der Europäischen Kommission, von Standardvertragsklauseln (Standard Contractual Clauses – SCCs) oder einer anderen gesetzlich zulässigen Grundlage.",

section15Title: "15. Cookies, Local Storage und ähnliche Technologien",
section15Text1: "VaultQuest verwendet technisch erforderliche Cookies sowie vergleichbare Speichertechnologien wie Local Storage oder Session Storage, soweit dies für den sicheren und ordnungsgemäßen Betrieb der Website, Web-App und mobiler Anwendungen erforderlich ist. Sofern auf unterstützten iOS-Geräten biometrische Authentifizierungsfunktionen wie Face ID oder Touch ID verwendet werden, erfolgt die biometrische Prüfung über die Sicherheitsfunktionen des Betriebssystems. VaultQuest erhält und speichert keine biometrischen Merkmale oder biometrischen Templates.",
section15Text2: "Diese Technologien dienen insbesondere dazu,",
section15List1: "Sitzungen technisch bereitzustellen,",
section15List2: "Login-Zustände zu verwalten,",
section15List3: "sicherheitsrelevante Funktionen umzusetzen,",
section15List4: "Benutzereinstellungen zu speichern,",
section15List5: "die Darstellung und Funktionsfähigkeit der Plattform sicherzustellen.",
section15Text3: "Soweit ausschließlich technisch erforderliche Cookies oder vergleichbare Technologien eingesetzt werden, erfolgt deren Nutzung auf Grundlage von § 25 Abs. 2 TDDDG sowie Art. 6 Abs. 1 lit. b und lit. f DSGVO.",
section15Text4: "Sollten künftig Analyse-, Marketing- oder Tracking-Technologien eingesetzt werden, erfolgt deren Nutzung ausschließlich nach entsprechender Information und – soweit gesetzlich erforderlich – nach Ihrer vorherigen Einwilligung.",

section16Title: "16. Analyse, Fehlerberichte und Sicherheit",
section16Text1: "Zur Gewährleistung eines sicheren, stabilen und zuverlässigen Betriebs von VaultQuest verarbeiten wir technische Fehler-, Protokoll-, Audit-Log- und Sicherheitsdaten. Diese Verarbeitung dient insbesondere:",
section16List1: "der Fehleranalyse und Fehlerbehebung,",
section16List2: "der Sicherstellung der Stabilität und Verfügbarkeit der Plattform,",
section16List3: "der Erkennung technischer Probleme",
section16List4: "der Erkennung und Verhinderung von Missbrauch, Betrugsversuchen und Regelverstößen,",
section16List5: "der Nachvollziehbarkeit administrativer Vorgänge,",
section16List6: "dem Schutz der Plattform sowie ihrer Nutzer.",
section16Text2: "Zur Gewährleistung der Systemsicherheit und der Integrität des Wettbewerbsbetriebs können hierfür teilweise automatisierte technische Prüfungen eingesetzt werden.",
section16Text3: "Eine Verarbeitung dieser Daten zu Werbe- oder Marketingzwecken erfolgt nicht.",

section17Title: "17. Speicherdauer",
section17Text1: "Wir speichern personenbezogene Daten nur so lange, wie dies für die jeweiligen Verarbeitungszwecke erforderlich ist oder gesetzliche Aufbewahrungspflichten bestehen.",
section17Text2: "Grundsätzlich gelten folgende Speicherfristen:",
section17List1: "Kontodaten werden grundsätzlich gespeichert, solange das Benutzerkonto besteht.",
section17List2: "Support- und Kommunikationsdaten werden gespeichert, solange dies zur Bearbeitung, Dokumentation oder Erfüllung gesetzlicher Verpflichtungen erforderlich ist.",
section17List3: "Technische Log-, Audit- und Sicherheitsdaten werden nur so lange gespeichert, wie dies zur Gewährleistung der Sicherheit, Stabilität und Nachvollziehbarkeit des Plattformbetriebs erforderlich ist.",
section17List4: "Konfliktbezogene Daten und hochgeladene Nachweise werden nur so lange gespeichert, wie dies zur Bearbeitung des Konfliktfalls, zur Missbrauchsprävention oder zur Wahrung berechtigter Interessen erforderlich ist.",
section17List5: "Interne KI-gestützte Konfliktanalysen von VaultQuest folgen grundsätzlich der für Konfliktfälle vorgesehenen Aufbewahrungs- und Löschlogik.",
section17Text3: "Für bestimmte Datenkategorien bestehen zusätzlich automatische Löschfristen. Nach dem derzeitigen technischen Stand betrifft dies insbesondere Konfliktfälle und zugehörige Nachweise, Supportanfragen, Turniere, Einzelmatches, Challenges und zugewiesene Gutscheine, die regelmäßig nach Ablauf der jeweils vorgesehenen Zweck- und Nachweisfristen gelöscht oder bereinigt werden. Bestimmte sicherheits- und administrativ relevante Nachweise wie Nutzermeldungen, Trust-Movings und Admin-Audit-Logs können zur Missbrauchsprävention und Nachvollziehbarkeit länger gespeichert werden. Push-Token werden nur so lange gespeichert, wie sie für Push-Benachrichtigungen erforderlich sind, und bei Inaktivität automatisch bereinigt. Export-Downloadlinks für Datenexporte sind zeitlich begrenzt.",
section17Text4: "Sobald der jeweilige Zweck entfällt und keine gesetzlichen Aufbewahrungspflichten oder berechtigten Interessen einer Löschung entgegenstehen, werden personenbezogene Daten gelöscht oder anonymisiert.",
section17Text5: "Sie können jederzeit die Löschung Ihres Benutzerkontos verlangen. Soweit keine gesetzlichen Aufbewahrungspflichten oder überwiegenden berechtigten Interessen entgegenstehen, werden die mit Ihrem Benutzerkonto verbundenen personenbezogenen Daten gelöscht oder anonymisiert.",
section17Text6: "Unabhängig davon können an OpenAI übermittelte API-Eingaben und -Ausgaben nach aktuellen Informationen des Anbieters grundsätzlich bis zu 30 Tage zur Bereitstellung des Dienstes und zur Missbrauchsüberwachung aufbewahrt werden.",

section18Title: "18. Ihre Rechte",
section18Text1: "Sie haben im Rahmen der gesetzlichen Vorschriften insbesondere folgende Rechte:",
section18List1: "Recht auf Auskunft gemäß Art. 15 DSGVO",
section18List2: "Recht auf Berichtigung gemäß Art. 16 DSGVO",
section18List3: "Recht auf Löschung gemäß Art. 17 DSGVO",
section18List4: "Recht auf Einschränkung der Verarbeitung gemäß Art. 18 DSGVO",
section18List5: "Recht auf Datenübertragbarkeit gemäß Art. 20 DSGVO",
section18List6: "Recht auf Widerspruch gemäß Art. 21 DSGVO",
section18List7: "Recht auf Widerruf einer erteilten Einwilligung mit Wirkung für die Zukunft",
section18List8: "Recht auf Beschwerde bei einer Datenschutzaufsichtsbehörde gemäß Art. 77 DSGVO",
section18Text2: "Zur Ausübung Ihrer Rechte oder bei Fragen zum Datenschutz können Sie sich jederzeit an uns unter",

section19Title: "19. Minderjährige Nutzer",
section19Text1: "VaultQuest kann ab einem Mindestalter von 13 Jahren genutzt werden. Bei der Registrierung wird eine Altersgruppe angegeben. Dabei beachten wir die geltenden gesetzlichen Vorgaben des Datenschutz- und Jugendschutzrechts.",
section19Text2: "Die optionale OpenAI-gestützte Konfliktanalyse steht ausschließlich volljährigen Nutzern zur Verfügung. Minderjährige Nutzer können hierfür keine Zustimmung erteilen. Konfliktfälle minderjähriger Nutzer werden ohne externe KI-Analyse manuell durch berechtigte VaultQuest-Administratoren bearbeitet. Im Übrigen werden personenbezogene Daten minderjähriger Nutzer nur im Rahmen der geltenden gesetzlichen Datenschutz- und Jugendschutzvorschriften verarbeitet.",

section20Title: "20. Datensicherheit",
section20Text1: "Wir treffen angemessene technische und organisatorische Maßnahmen, um Ihre personenbezogenen Daten vor Verlust, unbefugtem Zugriff, Manipulation, Offenlegung oder sonstigem Missbrauch zu schützen.",
section20Text2: "Hierzu gehören insbesondere:",
section20List1: "verschlüsselte Datenübertragungen,",
section20List2: "Zugriffsbeschränkungen,",
section20List3: "Schutz der Server-, Datenbank- und Kontoinfrastruktur,",
section20List4: "regelmäßige technische Sicherheitsüberprüfungen,",
section20List5: "Maßnahmen zur Sicherstellung der Verfügbarkeit und Integrität unserer Systeme.",
section20Text3: "Trotz aller getroffenen Sicherheitsmaßnahmen kann eine vollständige Sicherheit der Datenübertragung im Internet nicht garantiert werden.",

section21Title: "21. Änderungen dieser Datenschutzerklärung",
section21Text1: "Wir behalten uns vor, diese Datenschutzerklärung anzupassen, sofern dies aufgrund rechtlicher, technischer oder organisatorischer Änderungen erforderlich wird.",
section21Text2: "Die jeweils aktuelle Fassung dieser Datenschutzerklärung ist jederzeit auf der Website sowie innerhalb von VaultQuest abrufbar.",
section21Text3: "Sollten wesentliche Änderungen vorgenommen werden, werden wir Sie hierüber in angemessener Weise informieren, soweit dies gesetzlich erforderlich ist.",
},

agb: {
  title: "Allgemeine Geschäftsbedingungen (AGB)",
  section1Title: "§ 1 – Geltungsbereich",
  section1Text1: "Diese allgemeinen Geschäftsbedingungen (AGB) gelten für die Nutzung der digitalen Plattform VaultQuest über Webbrowser und sonstige unterstützende Endgeräte.",
  section1Text2: "VaultQuest stellt Nutzern insbesondere folgende Funktionen zur Verfügung:",
  section1List1: "Registrierung und Verwaltung eines Nutzerkontos",
  section1List2: "Teilnahme an Gaming-Turnieren und Community-Turnieren",
  section1List3: "Teilnahme an Einzelspielen",
  section1List4: "Match-Zuweisung",
  section1List5: "Ergebnis-Reporting",
  section1List6: "Konfliktfälle mit Nachweis-Upload",
  section1List7: "Benachrichtigungen über Turnierstatus und Gewinne",
  section1Text3: "Die Nutzung der Plattform ist aktuell vollständig kostenfrei.",

section2Title: "§ 2 – Anbieter",
providerName: "Timon Eßer",
providerStreet: "Lessingstraße 14",
providerCity: "77966 Kappel-Grafenhausen",
providerCountry: "Deutschland",
providerEmailLabel: "E-Mail",
providerEmail: "info@vaultquest.de",

section3Title: "§ 3 - Vertragsgegenstand und Plattformcharakter",
section3Text1: "Gegenstand des Vertrages ist die Bereitstellung einer technischen Plattform, über die Nutzer an Gaming-Turnieren, Community-Turnieren und Einzelspielen teilnehmen können. Bei Community-Turnieren können Creator Turnierdaten wie Name, Zeitpunkt, Teilnehmerzahl, Sichtbarkeit, Preise und ergänzende Regeln vorschlagen bzw. gestalten; eine Veröffentlichung erfolgt erst nach Prüfung und Freigabe durch VaultQuest.",
section3Text2: "VaultQuest selbst bietet keine Videospiele an. Die eigentlichen Spiele werden ausschließlich über externe Spieleplattformen oder Konsolen durchgeführt. Voraussetzung für die Teilnahme ist, dass der Nutzer über die jeweils erforderlichen Spiele, Zugänge und technischen Voraussetzungen verfügt.",
section3Text3: "Ein Anspruch auf bestimmte Turniere, Funktionen, Gewinne oder eine dauerhafte Verfügbarkeit einzelner Inhalte besteht nicht.",
section3Text4: "VaultQuest befindet sich teilweise in einer fortlaufenden Test- und Weiterentwicklungsphase. Funktionen können daher vorübergehend eingeschränkt, verändert oder entfernt werden. Bei Community-Turnieren betreibt VaultQuest die technischen Plattformfunktionen, insbesondere Veröffentlichung nach Freigabe, Beitritt, Turnierlogik, Reporting und Konfliktbearbeitung; Creator bleiben für eigene organisatorische Angaben und Zusagen außerhalb der Plattform verantwortlich.",

section4Title: "§ 4 - Registrierung und Nutzerkonto",
section4Text1: "Die Nutzung setzt ein persönliches, personenbezogenes Nutzerkonto voraus. Das Konto darf ausschließlich vom registrierten Nutzer verwendet werden.",
section4Text2: "Es gilt:",
section4List1: "Registrierung nur für natürliche Personen",
section4List2: "pro Person nur ein Nutzerkonto",
section4List3: "alle Angaben müssen vollständig und wahrheitsgemäß sein",
section4List4: "Zugangsdaten sind geheim zu halten; eine Weitergabe oder gemeinsame Nutzung des Kontos ist unzulässig",
section4Text3: "Mehrfachregistrierungen, Fake-Accounts oder Umgehungen bestehender Sperren sind unzulässig.",
section4Text4: "VaultQuest behält sich vor, Registrierungen bei berechtigtem Interesse abzulehnen. Benutzernamen dürfen nicht gegen gesetzliche Vorschriften oder Plattformregeln verstoßen; VaultQuest kann entsprechende Benutzernamen ablehnen oder eine Änderung verlangen.",
section4Text5: "Minderjährige Nutzer dürfen VaultQuest nur im Rahmen der gesetzlichen Vorschriften nutzen.",

section5Title: "§ 5 - Pflichten der Nutzer",
section5Text1: "Nutzer verpflichten sich zu:",
section5List1: "fairer Nutzung der Plattform",
section5List2: "wahrheitsgemäßen Angaben",
section5List3: "fristgerechtem Reporting",
section5List4: "respektvollem Umgang mit anderen Spielern",
section5List5: "Einhaltung der Regeln des jeweils genutzten Spiels",
section5Text2: "Insbesondere untersagt sind:",
section5List6: "Cheats",
section5List7: "Exploits, absichtliches Ausnutzen technischer Fehler oder Umgehung technischer Schutzmechanismen",
section5List8: "absichtliche Disconnects",
section5List9: "Rage-Quits",
section5List10: "Ergebnismanipulation oder Missbrauch des Reporting- oder Konfliktsystems",
section5List11: "Mehrfachaccounts",
section5List12: "Upload falscher Nachweise oder sonstige Manipulationsversuche des Plattformbetriebs",
section5Text3: "Verstöße können zu Sanktionen bis hin zum dauerhaften Ausschluss führen.",

section6Title: "§ 6 - Turniere und Einzelspiele",
section6Text1: "VaultQuest organisiert und verwaltet offizielle Turniere sowie Einzelspiele. Bei Community-Turnieren können Creator Turnierdaten wie Turniername, Zeitpunkt, Teilnehmerzahl, Sichtbarkeit, Preisangaben und zusätzliche Regeln vorschlagen. Eine Veröffentlichung erfolgt erst nach Prüfung und Freigabe durch VaultQuest. Nach Freigabe stellt VaultQuest die technische Durchführung über die Plattform bereit, insbesondere Turnieranzeige, Beitritt, Match-Zuweisung, Bracket- und Turnierlogik, Reporting, Statusmeldungen und Konfliktbearbeitung. VaultQuest ist nicht Partei der eigentlichen Spielhandlung zwischen den Nutzern.",
section6Text2: "Ein Anspruch auf:",
section6List1: "erfolgreiche Match-Zuweisung",
section6List2: "Fortsetzung eines Spiels",
section6List3: "eine bestimmte Turniergröße",
section6List4: "eine bestimmte Belohnung",
section6Text3: "besteht nicht. Turniere können insbesondere aufgrund technischer Probleme, organisatorischer Gründe oder einer zu geringen Teilnehmerzahl abgesagt, verschoben oder angepasst werden.",
section6Text4: "Benutzernamen, Platzierungen, Ergebnisse, Statistiken, Trust-Level und Leaderboards können innerhalb der Plattform verarbeitet und sichtbar dargestellt werden, soweit dies für den Plattform- und Wettbewerbsbetrieb erforderlich ist.",

section7Title: "§ 7 - Ergebnis-Reporting",
section7Text1: "Spielergebnisse müssen innerhalb der jeweils vorgegebenen Fristen in der Plattform gemeldet werden. VaultQuest stellt hierfür verschiedene Reportoptionen zur Verfügung, unter anderem:",
section7List1: "reguläres Ergebnis",
section7List2: "Zeitverlängerung",
section7List3: "Gegner nicht erschienen",
section7List4: "Rage Quit",
section7List5: "Verbindungsprobleme",
section7Text2: "Alle Angaben müssen vollständig und wahrheitsgemäß erfolgen.",
section7Text3: "Falsche Reports oder missbräuchliche Nutzung des Systems gelten als schwerwiegender Verstoß gegen diese AGB. Meldungen müssen innerhalb der vorgegebenen Fristen erfolgen; bei Fristablauf können automatische Entscheidungen oder Konfliktverfahren ausgelöst werden. Die von VaultQuest vorgesehenen Reporting-Abläufe sind verbindlich.",

section8Title: "§ 8 - Konfliktfälle und Nachweise",
section8Text1: "Wird ein gemeldetes Ergebnis von einem Spieler abgelehnt, entsteht ein Konfliktfall.",
section8Text2: "In Konfliktfällen können beide Parteien Nachweise hochladen, insbesondere:",
section8List1: "Screenshots",
section8List2: "Bilder des Endergebnisses",
section8List3: "sonstige Beweismittel",
section8Text3: "Für eine sachgerechte Prüfung sollten auf Nachweisen insbesondere sichtbar sein:",
section8List4: "Spielstand",
section8List5: "Teamname",
section8List6: "Konsolen-ID / Gegnerkennung",
section8Text4: "VaultQuest entscheidet auf Grundlage der vorliegenden Informationen nach billigem Ermessen. Werden innerhalb der vorgesehenen Fristen keine oder unzureichende Nachweise eingereicht, kann die Entscheidung auf Grundlage der vorhandenen Informationen getroffen werden.",
section8Text5: "Die Entscheidung über:",
section8List7: "Weiterkommen",
section8List8: "Ausscheiden",
section8List9: "Wiederholung",
section8List10: "Spielwertung",
section8List11: "Sanktionen",
section8Text6: "ist für die weitere Durchführung und Auswertung des jeweiligen Wettbewerbs maßgeblich. Konfliktentscheidungen können durch berechtigte Administratoren von VaultQuest getroffen werden.",
section8Text7: "VaultQuest kann zur Unterstützung der Konfliktbearbeitung automatisierte oder KI-gestützte Analysesysteme einsetzen, sofern die hierfür erforderlichen datenschutzrechtlichen Voraussetzungen und Zustimmungen der beteiligten Nutzer vorliegen und die beteiligten Nutzer die hierfür geltenden Voraussetzungen erfüllen. Liegt die erforderliche Zustimmung nicht vollständig vor, erfolgt die Konfliktbearbeitung manuell. Diese Systeme können konfliktbezogene Informationen, Match- und Turnierinformationen, Chat-Inhalte im Zusammenhang mit dem Konflikt sowie hochgeladene Nachweise auswerten und den berechtigten Administratoren eine Einschätzung oder Empfehlung bereitstellen. Die KI-gestützte Analyse dient ausschließlich der Unterstützung der Konfliktbearbeitung. Die endgültige Entscheidung über einen Konfliktfall und daraus resultierende Maßnahmen wird durch berechtigte Administratoren von VaultQuest getroffen. Weitere Informationen zur Verarbeitung personenbezogener Daten im Rahmen der KI-gestützten Konfliktanalyse enthält die Datenschutzerklärung.",

section9Title: "§ 9 - Fair Play und Sanktionen",
section9Text1: "Die Plattform basiert auf Fairness und Wettbewerb.",
section9Text2: "Verstöße gegen Fair Play, insbesondere:",
section9List1: "Falschangaben",
section9List2: "absichtliche Täuschung",
section9List3: "Belästigung anderer Nutzer",
section9List4: "Manipulation von Matches oder des Plattformbetriebs",
section9List5: "wiederholtes unsportliches Verhalten",
section9Text3: "können zu folgenden Maßnahmen führen:",
section9List6: "Korrektur des Ergebnisses",
section9List7: "Turnierausschluss",
section9List8: "temporäre Sperre",
section9List9: "dauerhafte Kontosperre",
section9List10: "Ausschluss von künftigen Belohnungen",
section9Text4: "Moderations- und Sanktionsentscheidungen können auf Grundlage des zum Entscheidungszeitpunkt geltenden VaultQuest-Regelwerks und der zu diesem Zeitpunkt verfügbaren Informationen getroffen werden. Nach Ablauf der für die zugrunde liegenden Daten und Nachweise geltenden Aufbewahrungsfristen kann eine erneute vollständige Prüfung des ursprünglichen Sachverhalts möglicherweise nicht mehr möglich sein.",

section10Title: "§ 10 - Gewinne, Gutscheine und Coins",
section10Text1: "Im Rahmen von Turnieren können Gewinne oder Belohnungen, insbesondere Gutscheine oder Preisgelder, vergeben werden.",
section10Text2: "Die Bereitstellung erfolgt über:",
section10List1: "das VaultQuest-Benachrichtigungssystem",
section10List2: "die hinterlegte E-Mail-Adresse",
section10Text3: "Es besteht kein Rechtsanspruch auf:",
section10List3: "Gewinne",
section10List4: "eine bestimmte Gutscheinart",
section10List5: "einen bestimmten Gutscheinwert",
section10Text4: "Art und Form eines Gewinns ergeben sich aus der jeweiligen Turnierausschreibung. Ist ausdrücklich ein Preisgeld ausgeschrieben, wird dieses entsprechend der Turnierausschreibung ausgezahlt. Eine Barauszahlung von Gutscheinen oder sonstigen Sach- oder Digitalpreisen erfolgt nur, wenn dies ausdrücklich angegeben ist. Coins sind ausschließlich eine virtuelle Plattformwährung, stellen kein gesetzliches Zahlungsmittel dar, können nicht ausgezahlt oder in Echtgeld umgetauscht werden und begründen keinen Eigentums- oder Auszahlungsanspruch. Bei Missbrauch oder Regelverstößen kann VaultQuest Coins ganz oder teilweise entziehen.",
section10Text5: "VaultQuest haftet nicht für Einschränkungen oder Bedingungen des jeweiligen Gutscheinanbieters. Gutscheine können zusätzlichen Bedingungen oder Ablaufdaten des jeweiligen Gutscheinanbieters unterliegen, die vom Nutzer zu beachten sind.",

section11Title: "§ 11 - Verfügbarkeit und Änderungen",
section11Text1: "VaultQuest bemüht sich um eine möglichst hohe Verfügbarkeit.",
section11Text2: "Es kann jedoch insbesondere durch:",
section11List1: "Wartungen",
section11List2: "Updates",
section11List3: "Drittanbieterprobleme",
section11List4: "externe Spielserver",
section11List5: "technische Störungen",
section11Text3: "zu Einschränkungen kommen.",
section11Text4: "VaultQuest kann Funktionen aus sachlichen Gründen, insbesondere aufgrund technischer, sicherheitsbezogener, rechtlicher oder organisatorischer Anforderungen, anpassen, erweitern oder einstellen, soweit dies für die Nutzer zumutbar ist.",

section12Title: "§ 12 – Haftung",
section12Text1: "VaultQuest haftet unbeschränkt bei Vorsatz, grober Fahrlässigkeit, schuldhafter Verletzung von Leben, Körper oder Gesundheit sowie in sonstigen Fällen, in denen eine Haftung gesetzlich zwingend vorgeschrieben ist.",
section12Text2: "Bei leicht fahrlässiger Verletzung wesentlicher Vertragspflichten ist die Haftung, soweit gesetzlich zulässig, auf den vorhersehbaren, vertragstypischen Schaden begrenzt. Wesentliche Vertragspflichten sind Pflichten, deren Erfüllung die ordnungsgemäße Durchführung des Vertrags überhaupt erst ermöglicht und auf deren Einhaltung Nutzer regelmäßig vertrauen dürfen.",
section12Text3: "Für Störungen durch externe Dienste oder Umstände außerhalb des Einflussbereichs von VaultQuest haftet VaultQuest nur, soweit VaultQuest die jeweilige Störung nach den gesetzlichen Vorschriften zu vertreten hat. Dies betrifft insbesondere:",
section12List1: "technische Ausfälle externer Spiele",
section12List2: "Serverprobleme von Drittanbietern",
section12List3: "Internet- oder Verbindungsprobleme",
section12List4: "nicht gemeldete oder verspätet gemeldete Ergebnisse aufgrund des Verhaltens eines Nutzers",
section12List5: "Fehlverhalten anderer Nutzer",

section13Title: "§ 13 - Sperrung und Beendigung",
section13Text1: "VaultQuest kann Nutzerkonten vorübergehend oder dauerhaft sperren, insbesondere bei:",
section13List1: "Verstößen gegen diese AGB",
section13List2: "Mehrfachaccounts",
section13List3: "Manipulation",
section13List4: "schweren Konfliktfällen",
section13List5: "Missbrauch der Plattform",
section13Text2: "Bei einer berechtigten dauerhaften Sperrung besteht grundsätzlich kein Anspruch auf Wiederherstellung des Nutzerkontos. Nach einer berechtigten dauerhaften Sperre besteht kein Anspruch auf Erstellung eines neuen Nutzerkontos; VaultQuest kann Maßnahmen treffen, um eine Umgehung von Sperren zu verhindern.",

section14Title: "§ 14 - Community-Turniere durch Creator",
section14Text1: "Creator können über VaultQuest Community-Turniere beantragen und hierfür insbesondere Turniername, Zeitpunkt, Teilnehmerzahl, Sichtbarkeit, Preisangaben und zusätzliche Turnierregeln vorschlagen.",
section14Text2: "Community-Turniere werden erst nach Prüfung und Freigabe durch VaultQuest veröffentlicht. Nach Freigabe stellt VaultQuest die technische Durchführung über die Plattform bereit, insbesondere Turnieranzeige, Beitritt, Match- und Bracketlogik, Reporting, Statusmeldungen und Konfliktbearbeitung.",
section14Text3: "Creator-Regeln dürfen den allgemeinen Wettbewerbsbedingungen und den in VaultQuest angezeigten Turnierregeln nicht widersprechen.",
section14Text4: "Für die gegenüber Teilnehmern auf VaultQuest offiziell angezeigten Preise ist VaultQuest verantwortlich, soweit in der konkreten Turnieranzeige nicht ausdrücklich ein anderer Preissteller genannt ist. Eigenständige Zusagen von Creatorn außerhalb der Plattform sind nicht Teil des von VaultQuest bereitgestellten Turnierbetriebs.",
section14Text5: "VaultQuest kann Creator-Turnieranfragen ablehnen, Änderungen anfordern, veröffentlichte Community-Turniere absagen, verschieben oder anpassen und bei Verstößen insbesondere:",
section14List1: "die Creator-Funktion entziehen",
section14List2: "zukünftige Community-Turniere ablehnen",
section14List3: "das Nutzerkonto gemäß den Nutzungsbedingungen einschränken oder sperren",

section15Title: "§ 15 – Datenschutz",
section15Text1: "Die Verarbeitung personenbezogener Daten erfolgt ausschließlich nach Maßgabe der gesonderten Datenschutzerklärung.",

section16Title: "§ 16 - Änderungen der AGB",
section16Text1: "VaultQuest kann diese AGB aus sachlichen Gründen anpassen, insbesondere aufgrund von Gesetzesänderungen, Änderungen der Rechtsprechung, regulatorischen Anforderungen, Sicherheitsanforderungen, technischen Änderungen oder Änderungen und Erweiterungen der VaultQuest-Funktionen.",
section16Text2: "Änderungen dürfen Nutzer nicht unangemessen benachteiligen. Über wesentliche Änderungen informiert VaultQuest die Nutzer in angemessener Weise. Änderungen gelten grundsätzlich für die zukünftige Nutzung der Plattform; zwingende gesetzliche Rechte bleiben unberührt.",

section17Title: "§ 17 - Anwendbares Recht",
section17Text1: "Es gilt das Recht der Bundesrepublik Deutschland. Für Verbraucher gilt diese Rechtswahl nur insoweit, als dadurch nicht der Schutz entzogen wird, der ihnen durch zwingende Bestimmungen des Rechts des Staates ihres gewöhnlichen Aufenthalts gewährt wird.",






},



  },

  en: {
    common: {
      back: "Back",
      error: "ERROR",
      save: "Save",
      cancel: "Cancel",
      close: "Close",
      ok: "OK",
      yes: "YES",
      no: "NO",
      send: "Send",
      loading: "Loading...",
      loadingPlayer: "Loading player …",
      logout: "Logout",
      support: "Support",
      settings: "Settings",
      legal: "Legal",
      premium: "Premium",
      about: "About VaultQuest",
      languageSettings: "Language settings",
      accountSettings: "Account settings",
      changePassword: "Change password",
      deleteAccount: "Delete account",
      german: "German",
      english: "English",
      delete: "Delete",
    },
    surveys: {
      single: "Single choice",
      multiple: "Multiple choice",
      entryTitle: "Help us improve VaultQuest.",
      notNow: "Not now",
      next: "Next",
      submit: "Send feedback",
      thanks: "Thank you for your feedback!",
      required: "Please answer every question.",
      questionProgress: "Question {{current}} of {{total}}",
      selectOneHint: "Select one answer",
      selectMultipleHint: "Multiple answers possible",
      other: "Other",
      otherPlaceholder: "Please briefly explain …",
      noPersonalData: "Please do not enter personal information.",
      otherRequired: "Please briefly explain your selection.",
      otherTooLong: "Your answer may contain no more than 300 characters.",
      otherPlainText: "Please use plain text without HTML.",
      loadError: "The survey could not be loaded.",
      submitError: "Your feedback could not be submitted.",
      unavailable: "This survey is no longer available.",
      blockedByPriorityAction: "Complete the current match action first. You can open the survey afterwards.",
      notificationAction: "OPEN SURVEY",
      admin: {
        createTitle: "New survey",
        titleDE: "German title",
        titleEN: "English title",
        startsAt: "Starts at",
        endsAt: "Ends at",
        question: "Question {{number}}",
        questionText: "Question text",
        option: "Answer",
        addOption: "Add answer",
        addQuestion: "Add question",
        allowOther: "Allow Other with free text",
        otherResponses: "Show anonymous answers",
        hideOtherResponses: "Hide anonymous answers",
        create: "Create survey",
        planned: "Planned surveys",
        running: "Running surveys",
        ended: "Ended surveys",
        participations: "Participations",
        shown: "Shown",
        deferred: "Deferred",
        endNow: "End early",
        showResults: "View results",
        none: "No surveys available.",
        invalidDates: "Please select valid start and end times.",
        created: "Survey created.",
        endedMessage: "Survey ended.",
        loadError: "Surveys could not be loaded.",
        createError: "Survey could not be created.",
        endError: "Survey could not be ended.",
        resultsError: "Results could not be loaded.",
      },
    },
    authState: {
      loading: "Loading VaultQuest...",
      loadError: "Your profile could not be loaded.",
    },
    rulesDisclaimer: {
      title: "Competition notice",
      text:
        "Apple Inc. is neither a sponsor nor an organizer of this competition and is in no way involved in its operation.\n\nThis EA SPORTS FC competition is not affiliated with Electronic Arts Inc. or its licensors and is neither sponsored nor endorsed by them.",
    },
    competitionRules: {
      tournamentRulesTitle: "Tournament rules",
      creatorRulesTitle: "Additional creator rules",
      tournamentAdditionalRulesTitle: "Additional tournament rules",
      additionalTournamentRule: "Additional tournament rule",
      competitionTermsTitle: "Competition Terms",
      competitionTermsText:
        "Participation is also subject to the general VaultQuest Competition Terms.",
      openCompetitionTerms: "View Competition Terms",
      labels: {
        gameMode: "Game mode",
        matchDuration: "Match duration",
        format: "Format",
        tieDecision: "Tie decision",
        teamSelection: "Team selection",
        platform: "Platform",
      },
      values: {
        gameMode: {
          ultimate_team: "Ultimate Team",
          kick_off: "Kick-Off",
        },
        matchDuration: "6 minutes",
        format: {
          knockout: "Knockout phase (Best-of-One)",
          groupStage: "Group stage / knockout phase (Best-of-One)",
        },
        tieDecision: "Extra time + penalty shootout",
        teamSelection: {
          free: "Free choice",
        },
        platform: {
          all: "PlayStation / XBOX / PC (NewGen only)",
          playstation_new_gen: "PlayStation (New Gen)",
          xbox_new_gen: "Xbox (New Gen)",
          pc: "PC",
        },
      },
    },
    header: {
      home: "HOME",
      tournaments: "TOURNAMENTS",
      singles: "SINGLE MATCHES",
      profile: "PROFILE",
      community: "COMMUNITY",
      fairplay: "FAIRPLAY",
      agb: "TERMS",
      privacy: "PRIVACY POLICY",
      impressum: "LEGAL NOTICE",
      competitionTerms: "COMPETITION TERMS",
      game: "GAME",
      vouchers: "Vouchers",
      shop: "Shop",
      premium: "Premium",
      faqs: "FAQs",
    },
    faq: {
      title: "FAQs",
      subtitle: "Key answers about VaultQuest, tournaments, matches, and rewards.",
      items: [
        {
          question: "What is VaultQuest?",
          answer: "VaultQuest is a cross-platform tournament platform for competitive gaming. You can join tournaments and single matches, report results, and earn rewards.",
        },
        {
          question: "Which games are currently supported?",
          answer: "VaultQuest currently supports EA SPORTS FC. More games will be added step by step.",
        },
        {
          question: "Which platforms can I use?",
          answer: "VaultQuest supports PlayStation 5, Xbox Series X|S, and PC. Old-generation consoles such as PlayStation 4 and Xbox One are not supported.",
        },
        {
          question: "How do tournaments work?",
          answer: "You join an available tournament, wait in the tournament lobby for it to start, and then play against your assigned opponent. VaultQuest guides you through the match, result reporting, and advancement.",
        },
        {
          question: "How does result reporting work?",
          answer: "After a match, players report their result. If the reports match, the result is processed automatically. If they differ, a conflict case can be created.",
        },
        {
          question: "What happens in a conflict?",
          answer: "In a conflict, the involved players can upload evidence. An admin reviews the case and makes a decision based on the available information.",
        },
        {
          question: "How do I receive my reward?",
          answer: "If you win a reward-eligible tournament, your voucher code will be sent through the VaultQuest notification system and additionally to your registered email address.",
        },
        {
          question: "Where can I get help?",
          answer: "If you need support, you can use the in-app support form or contact VaultQuest through the listed contact channels.",
        },
      ],
    },
matchChat: {
  systemWelcome: "Welcome to the match chat. Use this area to coordinate if needed. Please stay fair and respectful. If you need assistance or encounter an urgent issue, you can use the support button at any time. An administrator will then join this chat and assist you.",
  systemAdminJoined: "An admin has joined the chat.",
  systemAdminLeft: "The admin has left the chat.",
  adminLabel: "🛡 Admin",
  inputPlaceholder: "Write a message...",
  send: "Send",
  adminHelp: {
    button: "Request support",
    informed: "An admin has been notified.",
    limitReached: "You have reached your admin help limit for this match.",
    confirmTitle: "Invite admin",
    confirmBody:
      "Do you really want to invite an admin to this chat?\n\nThe chat history will then also become visible to the admin.",
    cancel: "Cancel",
    confirm: "Invite admin",
    error: "Admin help could not be requested.",
  },
  states: {
    joinToRead: "Join the chat to read messages.",
    waitingForPlayers: "Chat becomes available once both players are set.",
  },
  errors: {
    loadFailed: "Chat could not be loaded.",
    sendFailed: "Message could not be sent.",
    inappropriateLanguage:
      "This message cannot be sent because it contains inappropriate language.",
  },
},

    home: {
  greeting: "Welcome back, {{name}}!",
  greetingSubtitle: "Ready for your next tournament?",
  community: "COMMUNITY",
  communityText: "Discover friends, leaderboards, quests and more",
  joinTournament: "TOURNAMENTS",
  joinTournamentText: "Play cups and win prizes",
  singles: "MATCHES",
  singlesText: "Play quick matches",
  profile: "MY PROFILE",
  profileText: "Your results and progress at a glance",
  profileSection: "PROFILE",
  prizesSection: "PRIZES",
  myPrizes: "MY PRIZES",
  myPrizesText: "Request payouts and physical prizes",
  fairplay: "FAIRPLAY",
  fairplayText: "Trust level and rules for fair matches",
  creatorTournaments: "CREATOR CUP",
  creatorTournamentsText: "Plan your own tournament",
  adminPanelText: "Conflicts, support, admin help",
  upcomingTitle: "UP NEXT",
  activeMatchesTitle: "ACTIVE MATCHES",
  socialSection: "SOCIALS",
  creatorSection: "CREATOR",
  adminSection: "ADMIN",
  showAll: "Show all",
  open: "Open",
  toTournament: "To tournament",
  toMatch: "To match",
  players: "Players",
  today: "Today",
  tomorrow: "Tomorrow",
  tournamentFallback: "Tournament",
  tournamentMatchMeta: "Tournament match ready",
  singleMatchFallback: "Single match",
  singleMatchMeta: "Result pending",
  vs: "vs.",
  playerOne: "Player 1",
  loadingPlayers: "Loading player data…",
  playerTwo: "Player 2",
  status: {
    open: "OPEN",
    running: "RUNNING",
    finished: "FINISHED",
    full: "FULL",
    cancelled: "CANCELLED",
    active: "ACTIVE",
  },
},

topBar: {
  coins: "Coins",
  trust: "Trust",
  messages: "Messages",
},

community: {
  title: "Community",
  subtitle: "Connect, compare yourself, and experience more VaultQuest.",
  leaderboards: "Leaderboards",
  leaderboardsText: "View rankings and placements",
  friends: "Friends list",
  friendsText: "Manage friends and open profiles",
  quests: "Quests",
  questsText: "View rewards and progress",
  surveys: {
    title: "Surveys",
    openOne: "1 open survey",
    openMany: "{{count}} open surveys",
  },
  myPrizes: {
    title: "My prizes",
    text: "Request payouts and physical prizes",
  },
  questProgressTitle: "Your quest progress",
  questProgressCount: "{{completed}} / {{total}} completed",
  questProgressFallback: "Open your quests to view progress and rewards.",
  questReadyToClaim: "{{count}} ready to claim",
  allQuests: "All quests",
  followVaultQuest: "Follow VaultQuest",
  instagramText: "Updates & insights",
  tiktokText: "Clips & highlights",
  reportBlock: {
    title: "Report / block user",
    text: "Report violations or block friend requests.",
  },
  privateTournaments: {
    title: "Private tournaments",
    text: "Enter the code here to find the tournament.",
    modalTitle: "Private tournament",
    modalText: "Enter the 6-digit code you received from the creator.",
    placeholder: "Code",
    delete: "Delete",
    unlock: "Confirm",
    cancel: "Cancel",
    checking: "Checking...",
    error: "The code could not be checked.",
    outsideCalendar:
      "The private tournament was unlocked, but it is outside the 8 days currently visible in the tournament calendar.",
  },
},

myPrizes: {
  title: "My prizes",
  subtitle: "Here you can find your requestable payouts and physical prizes from Special and Creator Cups.",
  loading: "Loading prizes...",
  empty: "You currently have no requestable prizes.",
  unknownTournament: "VaultQuest tournament",
  types: {
    tournament: "Tournament",
    special: "Special Cup",
    creator: "Creator Cup",
    evening: "Evening Cup",
    nightly: "Nightly Cup",
  },
  prizeTypes: {
    payout: "Payout",
    physical: "Physical prize",
  },
  status: {
    payout: {
      claimable: "Available for payout",
      requested: "Payout is being processed",
      pending: "Payout is being processed",
      processing: "Payout is being processed",
      needs_action: "Correction required",
      completed: "Payout completed",
      cancelled: "No longer available",
      forfeited: "No longer available",
    },
    physical: {
      claimable: "Requestable",
      requested: "Physical prize is being processed",
      pending: "Physical prize is being processed",
      processing: "Physical prize is being processed",
      needs_action: "Correction required",
      completed: "Shipped",
      cancelled: "No longer available",
      forfeited: "No longer available",
    },
  },
  actions: {
    requestPayout: "Request payout",
    requestPhysical: "Request physical prize",
    correctDetails: "Correct details",
    submitting: "Submitting...",
    reload: "Reload",
  },
  modal: {
    payoutTitle: "Request payout",
    physicalTitle: "Request physical prize",
    method: "Payout method",
    methodLocked: "Method: {{method}}",
    summary: "Summary",
  },
  privacy: {
    paypal: "Your PayPal email address is stored only to process your payout and will be irrevocably deleted once the payout is complete.",
    bank: "Your bank details are stored only to process your payout and will be irrevocably deleted once the payout is complete.",
    shipping: "Your shipping address is stored only to ship your physical prize and will be irrevocably deleted once shipping is complete.",
  },
  help: {
    iban: "Your IBAN is formatted automatically.",
  },
  placeholders: {
    iban: "DE12 3456 7890 1234 5678 90",
  },
  methods: {
    paypal: "PayPal",
    bank: "Bank transfer",
    voucher: "Voucher",
    shipping: "Shipping",
  },
  providers: {
    psn: "PSN",
    xbox: "Xbox",
    amazon: "Amazon",
    zalando: "Zalando",
    steam: "Steam",
  },
  fields: {
    paypalEmail: "PayPal email address",
    accountHolder: "Recipient name",
    iban: "IBAN",
    voucherProvider: "Voucher provider",
    recipientName: "Recipient",
    street: "Street",
    houseNumber: "House number",
    postalCode: "Postal code",
    city: "City",
    country: "Country",
  },
  errors: {
    load: "Your prizes could not be loaded.",
    generic: "The request could not be processed.",
    paypal: "Please check your PayPal email address.",
    iban: "Please check your IBAN.",
    accountHolder: "Please enter the recipient name.",
    voucherProvider: "Please select a voucher provider.",
    shipping: "Please fill in all shipping fields.",
    notClaimable: "This prize can no longer be requested.",
    exists: "A request already exists for this prize. The status was refreshed.",
  },
  needsActionReasons: {
    invalid_payment_details: "Please check your payment details.",
    invalid_paypal_email: "Please check your PayPal email address.",
    invalid_bank_details: "Please check your bank details.",
    invalid_iban: "Please check your IBAN.",
    invalid_shipping_address: "Please check your shipping address.",
    incomplete_shipping_address: "Please check your shipping address.",
    missing_information: "Please add the missing information.",
    additional_details_required: "Please add the missing information.",
    other_details_required: "Please check your details.",
    other: "Please check your details.",
    unknown: "Please check your details.",
  },
  tournamentCard: {
    wonPayout: "You won {{prize}}.",
    wonPhysical: "You won {{prize}}.",
  },
},

adminPrizeFulfillments: {
  kicker: "ADMIN",
  title: "Prize fulfillment",
  subtitle: "Review and complete payouts, vouchers, and physical prizes.",
  filtersLabel: "Filter prize fulfillments",
  listLabel: "Prize fulfillments",
  detailLabel: "Prize fulfillment details",
  loading: "Loading prize fulfillments...",
  loadingDetail: "Loading details...",
  empty: "No matching prize fulfillments found.",
  selectHint: "Select a prize fulfillment on the left.",
  filters: {
    all: "All",
    open: "Open",
    payout: "Payouts",
    physical: "Physical prizes",
    needs_action: "Correction required",
    processing: "Processing",
    completed: "Completed",
  },
  prizeTypes: {
    payout: "Payout",
    physical: "Physical prize",
  },
  methods: {
    paypal: "PayPal",
    bank: "Bank transfer",
    voucher: "Voucher",
    shipping: "Shipping",
  },
  providers: {
    psn: "PSN",
    xbox: "Xbox",
    amazon: "Amazon",
    zalando: "Zalando",
    steam: "Steam",
  },
  status: {
    pending: "Open",
    processing: "Processing",
    needsAction: "Correction required",
    completedPayout: "Payout completed",
    completedPhysical: "Shipped",
    cancelled: "Cancelled",
    unknown: "Unknown",
  },
  fields: {
    requestId: "Request ID",
    awardId: "Award ID",
    username: "User",
    tournament: "Tournament",
    type: "Type",
    placement: "Placement",
    prizeType: "Prize type",
    prize: "Prize",
    method: "Method",
    requestedAt: "Requested",
    needsActionReason: "Correction reason",
    statusReason: "Note",
    paypalEmail: "PayPal email",
    recipientName: "Recipient",
    iban: "IBAN",
    street: "Street",
    city: "City",
    country: "Country",
    voucherProvider: "Voucher provider",
  },
  privateDetails: {
    title: "Private fulfillment details",
    paymentDeleted: "Payment details deleted after completion",
    shippingDeleted: "Shipping address deleted after completion",
  },
  reasons: {
    invalid_payment_details: "Invalid payment details",
    invalid_iban: "Invalid IBAN",
    invalid_paypal_email: "Invalid PayPal email",
    incomplete_shipping_address: "Incomplete shipping address",
    additional_details_required: "Additional details required",
    other_details_required: "Additional details required",
    unknown: "Correction required",
  },
  needsAction: {
    title: "Request correction",
    reason: "Reason",
    note: "Internal note without sensitive data",
  },
  complete: {
    title: "Complete prize fulfillment",
    text: "Only confirm once the payout has been sent, the voucher has been assigned, or the physical prize has shipped.",
  },
  actions: {
    refresh: "Refresh",
    loading: "Loading...",
    close: "Close",
    cancel: "Cancel",
    working: "Processing...",
    markProcessing: "Processing",
    requestCorrection: "Request correction",
    sendCorrection: "Send correction",
    completePayout: "Payout completed",
    completeShipping: "Shipping completed",
    completeVoucher: "Assign voucher",
    confirmComplete: "Complete",
  },
  messages: {
    processing: "Prize fulfillment was marked as processing.",
    needsAction: "Correction was requested.",
    completed: "Prize fulfillment was completed.",
  },
  errors: {
    load: "Prize fulfillments could not be loaded.",
    detail: "The prize fulfillment could not be opened.",
    generic: "The action could not be processed.",
    noVoucher: "No matching voucher is available.",
    needsActionOpen: "This prize fulfillment is still waiting for corrected details.",
    alreadyCompleted: "This prize fulfillment has already been completed.",
    cannotComplete: "This prize fulfillment cannot be completed.",
  },
},

reportBlock: {
  title: "Report / block user",
  intro: "Report rule violations or block new friend requests.",
  usernameLabel: "Enter username",
  usernamePlaceholder: "Enter username...",
  check: "Check",
  userFound: "Found: {{username}}",
  actions: {
    report: "Report user",
    block: "Block user",
  },
  categories: {
    harassment: "Harassment",
    insult: "Insult",
    cheating: "Cheating",
    spam: "Spam",
    inappropriateUsername: "Inappropriate username",
    other: "Other",
  },
  report: {
    title: "Report user",
    description: "Having a problem with a user? Send us a report.",
    reasonLabel: "Reason for report",
    additionalInformation: "Additional information (optional)",
    additionalPlaceholder: "Add more details to your report...",
    submit: "Send report",
    sending: "Sending...",
    success: "Thank you. Your report was submitted successfully.",
  },
  block: {
    title: "Block user",
    text: "Blocked users cannot send you new friend requests.",
    button: "Block user",
    blocking: "Blocking...",
    confirmTitle: "Block user",
    confirmText: "Do you really want to block this user?",
    confirmButton: "Block",
    success: "The user was blocked successfully.",
    listTitle: "Blocked users",
    emptyTitle: "No blocked users",
    empty: "You currently have no blocked users.",
    loading: "Loading blocked users...",
    blockedSince: "Blocked since",
    total: "{{count}} blocked users",
    searchPlaceholder: "Search blocked users",
    noSearchResults: "No blocked users found.",
    unblock: "Unblock",
    unblocking: "Unblocking...",
    unblockConfirmTitle: "Unblock user",
    unblockConfirmText: "Do you really want to remove the block for {{username}}?",
    unblockConfirmButton: "Unblock",
    cancel: "Cancel",
    unblockSuccess: "The block was removed.",
    alreadyBlocked: "{{username}} is already blocked.",
  },
  errors: {
    emptyUsername: "Please enter a username.",
    notFound: "No user with this username was found.",
    self: "You cannot report or block yourself.",
    otherRequired: "Please add a short description for Other.",
    invalid: "Please check your input.",
    unauthenticated: "Please sign in again.",
    permissionDenied: "You do not have permission for this action.",
    network: "Network error. Please try again shortly.",
    reportSaveFailed: "Report could not be saved.",
    blockSaveFailed: "Block could not be saved.",
    unblockSaveFailed: "Block could not be removed.",
    generic: "The action could not be completed.",
  },
},

game: {
  selectorLabel: "Game selection",
  statusActive: "Active",
  moreGamesSoon: "More games are coming soon.",
  disclaimer:
    "EA Sports FC is a trademark of Electronic Arts. VaultQuest is not affiliated with Electronic Arts.",
},


dashboard: {
  leaveTournament: {
    lockedTitle: "TOURNAMENT CANNOT BE LEFT",
    lockedText: "You can no longer leave this tournament.",
    startedTitle: "TOURNAMENT ALREADY STARTED",
    startedText: "This tournament is already running and can no longer be left.",
    notLoggedInTitle: "NOT LOGGED IN",
    notLoggedInText: "Please log in to leave a tournament.",
    genericError: "An error occurred while leaving. Please try again.",
  },
  admin: {
    title: "Send admin message",
    enterRecipient: "Please enter at least one recipient username.",
    enterTitle: "Please enter a title.",
    enterMessage: "Please enter a message.",
    sentSuccess: "Admin message sent successfully.",
    sentPushWarning: "The admin message was created in the app, but push delivery was unsuccessful or only partially successful.",
    sentNoPushTarget: "The admin message was created in the app. At least one recipient currently has no push target.",
    sentError: "Error sending admin message.",
    recipientPlaceholder: "Recipient usernames, separated by commas",
    titlePlaceholder: "Title",
    messagePlaceholder: "Free admin message",
    sending: "Sending...",
  },
  support: {
    missingMessageTitle: "MISSING MESSAGE",
    missingMessageText: "Please describe your problem or request.",
    sentTitle: "REQUEST SENT",
    sentText: "Your support request was sent successfully.",
    errorText: "An error occurred while sending your support request.",
    modalTitle: "SUPPORT",
    titlePlaceholder: "Title (optional)",
    messagePlaceholder: "Describe your problem or request",
    sending: "SENDING...",
  },
  passwordReset: {
    noEmailTitle: "NO EMAIL FOUND",
    noEmailText: "No email address was found for this account.",
    sentTitle: "EMAIL SENT",
    sentText: "We sent you an email to reset your password.",
    errorText: "The password reset email could not be sent.",
    modalTitle: "CHANGE PASSWORD",
    modalText: "WE WILL SEND A RESET LINK TO YOUR SAVED EMAIL ADDRESS.",
    sending: "SENDING...",
  },
  challenge: {
    acceptedTitle: "CHALLENGE ACCEPTED",
    acceptedText: "The challenge was accepted. The match has been created.",
    declinedTitle: "CHALLENGE DECLINED",
    declinedText: "The challenge was declined.",
    bannedTitle: "ACCOUNT SUSPENDED",
    bannedUntilText: "Your account has been temporarily suspended. Participation is not possible until {{date}}.",
    bannedText: "Your account has been temporarily suspended. Participation in singles is currently not possible.",
    unavailableTitle: "NO LONGER AVAILABLE",
    unavailableText: "This challenge is no longer open.",
    notEnoughCoinsTitle: "NOT ENOUGH COINS",
    notEnoughCoinsText: "You do not have enough coins to accept this challenge.",
    invalidTitle: "CHALLENGE NO LONGER VALID",
    invalidText: "The inviter no longer has enough coins. The challenge cannot be accepted.",
    notPossibleTitle: "NOT POSSIBLE",
    notPossibleText: "You cannot respond to this challenge.",
    notFoundTitle: "NOT FOUND",
    notFoundText: "The challenge was not found.",
    errorText: "An error occurred while responding to the challenge.",
  },
  errors: {
    logoutFailed: "Logout failed:",
  },
  friendRequest: {
    notPossibleTitle: "NOT POSSIBLE",
    cannotAddSelf: "You cannot send yourself a friend request.",
    alreadyFriendsTitle: "ALREADY FRIENDS",
    alreadyFriendsText: "You are already friends.",
    alreadyPendingTitle: "REQUEST ALREADY SENT",
    alreadyPendingText: "There is already a pending friend request.",
    sentTitle: "FRIEND REQUEST SENT",
    sentText: "The friend request was sent successfully.",
    alreadyExistsTitle: "ALREADY EXISTS",
    alreadyExistsText: "A friendship or pending request already exists.",
    invalidText: "This friend request could not be sent.",
    notAllowedTitle: "NOT ALLOWED",
    notAllowedText: "You are currently not allowed to send this user a request.",
    errorText: "An error occurred while sending the friend request.",
  },
  joinMessage: {
    alreadyStarted: "⛔ Tournament has already started",
    notFound: "❌ Tournament not found",
    notJoinable: "⛔ Tournament cannot be joined",
    saved: "✅ Join saved",
    error: "❌ Error while joining",
  },
  match: {
    notLoggedIn: "Not logged in.",
    missingData: "Missing data (matchId/reportType).",
    enterValidNumbers: "Please enter valid numbers.",
    noNegativeScores: "Scores cannot be negative.",
    noDrawAllowed: "Please enter a result with a clear winner.",
    saveError: "Error while saving: {{code}}\n{{message}}",
    notParticipant: "You are not a participant in this match.",
    cannotConfirmOwnResult: "You cannot confirm your own reported result.",
    notReported: "This match is not in 'reported' status.",
    alreadyDisputed: "This match has already been disputed.",
    confirmError: "Error confirming the result.",
    cannotDisputeOwnResult: "You cannot dispute your own reported result. Only your opponent can dispute it.",
    noLongerReported: "This match is no longer in 'reported' status.",
    disputeError: "Error disputing the result",
  },
  result: {
    eliminatedText: "Too bad. You have been eliminated from the tournament.",
    wonTitle: "TOURNAMENT WON",
    wonText: "Congratulations! You won the tournament. Your voucher code will be sent to you via the VaultQuest notification system.",
    secondPlaceText: "Congratulations! You reached 2nd place.",
thirdPlaceText: "Congratulations! You reached 3rd place.",
  },
  resultModal: {
    eliminated: {
      title: "ELIMINATED",
      text: "Too bad. You have been eliminated from the tournament.",
      thanks: "Thanks for playing!",
    },
    third: {
      title: "3RD PLACE",
      text: "Congratulations! You reached 3rd place.",
    },
    second: {
      title: "2ND PLACE",
      text: "Congratulations! You reached 2nd place.",
    },
    winner: {
      title: "TOURNAMENT WON",
      text: "Congratulations! You won the tournament.",
    },
  },
 
  profile: {
    loading: "Loading profile...",
    notFound: "Profile not found.",
  },
  premium: {
    title: "PREMIUM COMING SOON 🚀",
    text: "We are currently working on a premium subscription with exclusive features, better rewards, and additional benefits.\n\nStay tuned – it will be worth it 👀",
  },
  about: {
    version: "VERSION 1.0",
    text: "VaultQuest is a skill-gaming platform where you compete against other players in tournaments and matches and can win rewards.\n\nWe are continuously improving VaultQuest and are already working on new features for upcoming updates.",
  },
  lobby: {
    title: "{{time}} - TOURNAMENT LOBBY",
    rulesLine1: "TOURNAMENT",
    rulesLine2: "RULES",
    tournamentLobby: "TOURNAMENT LOBBY",
    startIn: "START IN",
    hoursShort: "HRS",
    minutesShort: "MIN",
    secondsShort: "SEC",
    viewRules: "VIEW RULES",
    participants: "PARTICIPANTS",
    you: "YOU",
    viewProfile: "View profile",
    addFriend: "Add friend",
    reportUser: "Report user",
    blockUser: "Block user",
    leaveTournament: "LEAVE TOURNAMENT",
  },
  notifications: {
    messages: "Messages",
    none: "You currently have no notifications.",
    notification: "Notification",
    noPreview: "No preview available.",
    content: "Content",
    selectOne: "Select a notification on the left to view it in full here.",
    dateUnavailable: "Date not available",
    challengeInviteText: "{{name}} invited you.",
    aUser: "A user",
    noContent: "No content available.",
    stake: "Stake: {{amount}} coins",
    expiresIn: "Expires in: {{time}}",
    statusAccepted: "Status: Invite accepted",
    statusDeclined: "Status: Invite declined",
    statusExpired: "Status: Invite expired",
    statusCancelled: "Status: Invite cancelled",
    statusMissing: "Status: Invite no longer available",
    statusError: "Status: Invite could not be loaded",
    processing: "PROCESSING...",
    friendRequestAccepted: "FRIEND REQUEST ACCEPTED",
friendRequestDeclined: "FRIEND REQUEST DECLINED",
modalConfirm: "UNDERSTOOD",
  },
  leaveModal: {
    title: "DO YOU REALLY WANT TO LEAVE THIS TOURNAMENT?",
    time: "{{time}}",
    players: "{{count}} PARTICIPANTS",
    hint: "⚠️ NOTE: IF YOU LEAVE THIS TOURNAMENT, YOU WILL NO LONGER BE A PARTICIPANT AND MAY NEED TO JOIN AGAIN.",
  },
  rulesModal: {
    title: "TOURNAMENT RULES",
    ruleFallback: "Rule {{number}}",
    emptyValue: "—",
    noRules: "There are currently no rules stored for this tournament.",
  },
  deleteAccount: {
    title: "DELETE ACCOUNT",
    text: "This action cannot be undone.",
    irreversibleHighlight: "cannot be undone",
    warningTitle: "WHAT HAPPENS WHEN YOU DELETE YOUR ACCOUNT:",
    warningProfile: "Your profile, statistics, tournament history and coins will be lost.",
    warningFriends: "Your friends, messages and settings will be deleted.",
    warningProgress: "You will lose all progress and leaderboard placements.",
    warningEvidence: "Uploaded evidence and saved files will be removed.",
    warningIrreversible: "This action cannot be undone.",
    passwordLabel: "CONFIRM PASSWORD",
    passwordPlaceholder: "Please enter your password",
    showPassword: "Show password",
    hidePassword: "Hide password",
    confirmation: "I understand that my account and all data will be permanently deleted.",
    confirmationHighlight: "permanently deleted",
    cancel: "CANCEL",
    confirmDelete: "DELETE ACCOUNT",
    confirmWithApple: "Confirm with Apple",
    appleConfirmationHint: "Securely confirm permanent account deletion with Apple and Face ID. The Apple connection will then be revoked.",
    iosRequired: "Account deletion for Apple-linked accounts currently requires the VaultQuest iOS app.",
    passwordRequired: "Please confirm your password first.",
    reauthFailed: "Secure confirmation failed. No data was deleted.",
    appleRevokeFailed: "The Apple connection could not be revoked. No data was deleted. Please try again later.",
    error: "Error deleting account.",
    deleting: "DELETING...",
  },
  dailyBonus: {
    title: "Your daily bonus",
    coins: "Coins",
    streakLabel: "Days in a row",
    collect: "Collect",
    disclaimer: "Come back every day to collect your bonus.",
    dayLabel: "Day {{day}}",
    collecting: "Collecting...",
    alreadyClaimed: "Today's bonus has already been claimed.",
    claimUnavailable: "The bonus could not be claimed. Please reload the current status.",
    claimError: "The bonus could not be claimed. Please try again.",
  },
},


tournaments: {
  days: {
    today: "TODAY",
    tomorrow: "TOMORROW",
  },
  startInfo: {
    today: "TODAY",
    tomorrow: "TOMORROW",
    startsIn: "Starts in {{time}}",
    hoursShort: "hr",
    minutesShort: "min",
  },
  noPrize: "No Prize",
  prizePoolLabel: "PRIZE POOL",
  common: {
    clock: "O'CLOCK",
    participants: "PARTICIPANTS",
  },
  overviewTabs: {
    active: "ACTIVE",
    mine: "JOINED",
    favorites: "FAVORITES",
    planned: "PLANNED",
    finished: "FINISHED",
  },
  emptyStates: {
    active: "No active tournaments.",
    mine: "No upcoming tournaments you joined.",
    favorites: "You have not saved any tournaments as favorites yet.",
    planned: "No tournaments for this day.",
    finished: "No recently finished tournaments.",
  },
  status: {
    open: "OPEN",
    finished: "FINISHED",
    started: "STARTED",
    didNotStart: "DID NOT START",
    closed: "CLOSED",
    invalid: "INVALID",
  },
  card: {
    players: "PLAYERS",
    clock: "TIME",
    coins: "COINS",
    private: "PRIVATE",
    viewRules: "VIEW RULES",
    viewAllPrizes: "VIEW ALL PRIZES",
    joined: "YOU HAVE JOINED",
    joinNotPossible: "JOIN NOT POSSIBLE",
    joinTournament: "JOIN TOURNAMENT",
    followTournament: "FOLLOW TOURNAMENT",
    noWinner: "NO WINNER",
  },
  prizesModal: {
    title: "Prizes",
    first: "1st place",
    second: "2nd place",
    third: "3rd place",
    empty: "–",
  },
  success: {
    title: "YOU HAVE SUCCESSFULLY REGISTERED FOR THE FOLLOWING TOURNAMENT:",
    info: "SHORTLY BEFORE THE TOURNAMENT STARTS, YOU WILL RECEIVE YOUR OPPONENT'S NAME VIA THE VAULTQUEST NOTIFICATION SYSTEM. ADD YOUR OPPONENT ON YOUR CONSOLE TO START YOUR MATCH.",
    backToOverview: "BACK TO OVERVIEW",
    showMyTournament: "SHOW MY TOURNAMENT",
    leaveTournament: "LEAVE TOURNAMENT",
  },
  joinModal: {
    warning: "PLEASE NOTE THAT THE COIN STAKE FOR TOURNAMENT PARTICIPATION IS AUTOMATICALLY DEDUCTED AND CAN NO LONGER BE REFUNDED!",
  },
  privateJoin: {
    title: "PRIVATE TOURNAMENT",
    text: "Enter the 6-digit tournament code to join.",
    confirm: "Confirm",
    requiredText: "You need to enter the tournament code before joining this private tournament.",
    invalidCode: "The code is invalid or does not belong to this tournament.",
  },
  modals: {
    notLoggedInTitle: "NOT LOGGED IN",
    notLoggedInText: "Please log in to join a tournament.",
    joinNotPossibleTitle: "JOIN NOT POSSIBLE",
    alreadyStartedText: "This tournament has already started.",
    notJoinableText: "This tournament can no longer be joined.",
    accountBannedTitle: "ACCOUNT SUSPENDED",
    accountBannedPermanentText: "Your account has been permanently suspended. Participation in tournaments is not possible.",
    accountBannedTemporaryText: "Your account has been temporarily suspended. Participation in tournaments is currently not possible.",
    alreadyStartedJoinBlockedText: "The tournament has already started, joining is no longer possible.",
    tournamentFullTitle: "TOURNAMENT FULL",
    tournamentFullText: "This tournament is already full.",
    notEnoughCoinsTitle: "NOT ENOUGH COINS",
    notEnoughCoinsText: "You do not have enough coins to join.",
    errorTitle: "ERROR",
    joinErrorText: "An error occurred while joining. Please try again.",
  },
},

tournamentRunning: {
  oClock: "O'CLOCK",
  round1: "Round 1",
  round2: "Round 2",
  round3: "Round 3",
round4: "Round 4",
round5: "Round 5",
  roundOf16: "Round of 16",
  quarterFinal: "Quarterfinal",
  semiFinal: "Semifinal",
  final: "Final",
  thirdPlace: "3rd Place",

  tabs: {
    myMatch: "MATCH",
    myTournament: "TOURNAMENT",
    groupStage: "GROUP STAGE",
    bracket: "BRACKET",
    statistics: "STATS",
    chat: "CHAT",
    conflict: "CONFLICT",
    rules: "RULES",
  },
  playerMatchStates: {
    groupNextMatch: { title: "YOUR NEXT GROUP MATCH IS BEING PREPARED", text: "Your next group match will open as soon as it is ready to play." },
    groupWaiting: { title: "YOUR GROUP MATCHES ARE COMPLETE", text: "The remaining matches in your group are still in progress. Your final position will be known afterwards." },
    groupRuling: { title: "YOUR POSITION IS BEING DECIDED", text: "Deciding matches will determine your final position. Your next deciding match will appear here as soon as it is ready." },
    groupEliminated: { title: "YOUR GROUP STAGE IS COMPLETE", text: "You did not qualify for the knockout stage this time." },
    qualifiedFirstKoWaiting: { title: "YOU HAVE QUALIFIED FOR THE KNOCKOUT STAGE", text: "Your opponent is still being determined. Your first knockout match will be prepared as soon as the pairing is complete." },
    nextMatchKnown: { title: "YOUR NEXT MATCH IS SET", text: "Your opponent is confirmed. Check-in will open shortly." },
    nextRoundWaiting: { title: "YOU ARE THROUGH TO THE NEXT ROUND!", text: "Your opponent is still being determined. Your match will be prepared as soon as the pairing is complete." },
    koRoundWaiting: { title: "YOU ARE THROUGH TO THE NEXT ROUND!", text: "Your opponent is still being determined. Your match will be prepared as soon as the pairing is complete." },
    quarterfinalWaiting: { title: "YOU ARE IN THE QUARTER-FINAL!", text: "Your opponent is still being determined. Your match will be prepared as soon as the pairing is complete." },
    semifinalWaiting: { title: "YOU ARE IN THE SEMI-FINAL!", text: "Your opponent is still being determined. Your match will be prepared as soon as the pairing is complete." },
    finalWaiting: { title: "YOU ARE IN THE FINAL!", text: "Your final opponent is still being determined. Your match will be prepared as soon as the pairing is complete." },
    bronzeWaiting: { title: "YOU WILL PLAY FOR THIRD PLACE.", text: "Your opponent is still being determined. Your match will be prepared as soon as the pairing is complete." },
    activeSeries: { title: "YOUR TIE IS STILL IN PROGRESS", text: "Another match in this tie is still pending. The next-round participant will only be decided afterwards." },
    disqualified: { title: "DISQUALIFIED", text: "You have been eliminated from this tie under the check-in rules." },
    knockoutEliminated: { title: "YOUR TOURNAMENT IS OVER", text: "You have been eliminated from the knockout stage." },
    tournamentWinner: { title: "YOU WON THE TOURNAMENT!", text: "The final is complete. Congratulations on winning the tournament!" },
    tournamentRunnerUp: { title: "YOU FINISHED SECOND!", text: "The final is complete. You finished in second place." },
    thirdPlace: { title: "YOU FINISHED THIRD!", text: "Your third-place match is complete." },
    tournamentCompleted: { title: "YOUR TOURNAMENT IS OVER", text: "You have no further match to play." },
    tournamentNotContinued: { title: "THE TOURNAMENT COULD NOT CONTINUE", text: "The terminal bracket could no longer produce a valid tournament winner." },
    noCurrentMatch: { title: "YOU CURRENTLY HAVE NO MATCH", text: "Your next match will appear here as soon as it is available." },
  },
  groupStage: {
    group: "Group",
    matchDay: "Matchday",
    noGroups: "The group stage is being prepared.",
    nextMatchWaiting: "Your next group match is being prepared. The opponent is not ready yet.",
    knockoutOpponentWaiting: "Congratulations on reaching the knockout stage. Your opponent will be assigned shortly.",
    waitingStates: {
      nextMatchPending: {
        title: "YOUR NEXT GROUP MATCH IS BEING PREPARED",
        text: "Your next group match will open as soon as it is ready to play.",
      },
      ownMatchesComplete: {
        title: "YOUR GROUP MATCHES ARE COMPLETE",
        text: "The remaining matches in your group are still in progress. Once the group is complete, you will know whether you have reached the knockout stage.",
      },
      qualifiedKoPending: {
        title: "YOU HAVE QUALIFIED FOR THE KNOCKOUT STAGE",
        text: "Your group is complete. Your first knockout match will open once the pairing has been fully determined.",
      },
      groupCompleteEliminated: {
        title: "YOUR GROUP STAGE IS COMPLETE",
        text: "Unfortunately, you did not reach the knockout stage.",
      },
      ownTiebreakerPending: {
        title: "DECIDING MATCH PENDING",
        text: "Your position has not been decided yet. Your next deciding match will open as soon as it is ready to play.",
      },
      qualificationDecisionPending: {
        title: "A DECISION IN YOUR GROUP IS PENDING",
        text: "The regular group matches are complete. Additional deciding matches are still needed to determine the final standings.",
      },
      openGroupConflict: {
        title: "GROUP MATCH DECISION PENDING",
        text: "One of your group match results is still under review. Your group stage will only be complete after a decision has been made.",
      },
    },
    thirdPlaceWaiting: "Your third-place match is being prepared.",
    tournamentComplete: "There are no more matches scheduled for you.",
    eliminated: "You have been eliminated from the tournament.",
    doubleNoShowEliminated: "You have been eliminated. You and your opponent missed the check-in.",
    matches: "Group matches",
    noMatches: "No matches are available for this group yet.",
    tableView: "Table",
    detailedTable: "Detailed table",
    qualified: "Qualified",
    decisionTitle: "Rulings",
    decisionDescription: "When players are tied, the affected players play additional Ruling Games until the ranking is resolved.",
    decisionRound: "Ruling Round",
    decisionMatches: "Ruling Games",
    status: {
      notStarted: "Not started",
      scheduled: "Scheduled",
      checkIn: "Check-in",
      running: "Running",
      completed: "Completed",
      invalid: "Void",
      bye: "Bye",
    },
    table: {
      rank: "Rank",
      player: "Player",
      played: "Played",
      wins: "Wins",
      losses: "Losses",
      goalsFor: "Goals",
      goalsAgainst: "Conceded",
      goalDifference: "Diff.",
      points: "Points",
    },
  },
  statistics: {
    playedMatches: "Matches played",
    totalGoals: "Total goals",
    topScorer: "Most goals by one user",
    biggestWin: "Biggest win",
    conflicts: "Conflicts",
    refunds: "Refunds",
    noData: "—",
  },
  bracket: {
    jumpToMyMatch: "📍 GO TO MY MATCH",
    noMatch: "Match is being prepared",
    checkInHints: {
      missingSuffix: "did not check in",
      neither: "Neither player checked in",
    },
    status: {
      waiting: "Waiting",
      running: "Live",
      reported: "Reported",
      disputed: "Conflict",
      finished: "Finished",
      cancelled: "Cancelled",
      checkIn: "Check-in",
      decisionRequired: "TIE-BREAKER PENDING",
      decisionCheckIn: "TIE-BREAKER · CHECK-IN",
      decisionActive: "TIE-BREAKER",
      noShow: "No-show",
      rageQuit: "Rage quit",
      disqualified: "Disqualified",
      void: "Void",
      doubleNoShow: "Double no-show",
      bye: "Bye",
    },
    legend: {
      finished: "Finished",
      running: "Live",
      waiting: "Waiting",
      bye: "Bye",
    },
  },

  matchStart: "MATCH START",
  opponent: "Opponent",
  you: "YOU",
  tournamentContinues: "TOURNAMENT CONTINUES...",
  opponentBeingDetermined: "OPPONENT IS BEING DETERMINED...",
  eliminatedHint: "YOU CAN STILL FOLLOW THE TOURNAMENT PROGRESS UNDER “TOURNAMENT”.",
  liveNow: "LIVE NOW...",
  latestReportTime: "LATEST REPORT TIME:",
  earliestReportTime: "EARLIEST REPORT TIME",
  reportingAllowedFrom: "Result reporting available from",
  reportedResult: "REPORTED RESULT",

  status: {
    eliminated: "STATUS: YOU HAVE BEEN ELIMINATED",
    opponentSoon: "STATUS: YOUR OPPONENT IS BEING DETERMINED",
    yourMatchAgainst: "STATUS: YOUR MATCH AGAINST",
    invalid: "STATUS: TOURNAMENT INVALID",
    firstPlace: "CONGRATULATIONS! YOU WON THE TOURNAMENT",
secondPlace: "CONGRATULATIONS! YOU REACHED 2ND PLACE",
thirdPlace: "CONGRATULATIONS! YOU REACHED 3RD PLACE",
  },

  viewProfile: "VIEW PROFILE",
  addFriend: "ADD FRIEND",
  opponentIdHint:
  "Here you can view your opponent's EA ID/Console ID.",

  conflictReasonNoReport: "CONFLICT REASON: NO RESULT REPORTED",
  reporterMissedDeadline: "REPORTER DID NOT SUBMIT A RESULT BEFORE THE DEADLINE",
  rageQuitReported: "RAGE QUIT REPORTED:",
  leftTheMatch: "LEFT THE MATCH",
  connectionIssuesReported: "CONNECTION ISSUES REPORTED:",
  disconnectedAt: "DISCONNECTED AT:",
  minute: "MINUTE",
  opponentDidNotAppear: "OPPONENT DID NOT SHOW UP",
  reportedAgainAfterPresence: "REPORTED AGAIN AFTER CONFIRMED PRESENCE",
  noShowReported: "NO-SHOW REPORTED",
  reportType: "REPORT TYPE",
  reporter: "REPORTER",
  reportedBy: "REPORTED BY",
  dual: {
    you: "YOU",
    opponent: "OPPONENT",
    reportedBy: "REPORTED BY",
    yourReport: "YOUR REPORT",
    opponentReportedResultDecision:
      "YOUR OPPONENT HAS ALREADY REPORTED A RESULT.",
    opponentReportedRageQuitDecision:
      "YOUR OPPONENT HAS ALREADY REPORTED A RAGE QUIT.",
    opponentReportedConnectionDecision:
      "YOUR OPPONENT HAS ALREADY REPORTED CONNECTION ISSUES.",
    confirmResult: "CONFIRM RESULT",
    confirmRageQuit: "CONFIRM RAGE QUIT",
    confirmConnectionIssue: "CONFIRM CONNECTION ISSUES",
    submitDifferentReport: "SUBMIT DIFFERENT REPORT",
    connectionEvidenceHint:
      "IMPORTANT: TAKE PHOTOS OF THE FINAL RESULT INCLUDING TEAM NAMES AND EA/CONSOLE ID NOW. IF THE RESUME MATCH HAS ANOTHER ISSUE OR DIFFERING DETAILS, YOU WILL NEED THESE EVIDENCE IMAGES.",
    responseCountdownLabel:
      "TIME TO CONFIRM THE RESULT OR SUBMIT A DIFFERENT RESULT:",
    reporterResponseCountdownLabel:
      "YOUR OPPONENT STILL HAS TIME TO RESPOND TO YOUR REPORT:",
    waitForOpponent:
      "YOU REPORTED YOUR RESULT. WAIT UNTIL YOUR OPPONENT HAS ALSO REPORTED A RESULT.",
    opponentReported: "YOUR OPPONENT REPORTED THE FOLLOWING RESULT:",
    resultReported: "RESULT REPORTED",
    rageQuit: "RAGE QUIT",
    rageQuitBy: "RAGE QUIT BY {{username}}",
    leftMatch: "{{username}} LEFT THE MATCH",
    rageQuitReportedBy: "{{username}} reported a rage quit.",
    reportedRageQuitPlayer: "Rage quit by",
    connectionIssue: "CONNECTION ISSUES",
    connectionIssueMinute: "CONNECTION ISSUE IN MINUTE {{minute}}",
    minute: "{{minute}}. MINUTE",
    waiting: "NO RESULT REPORTED",
    autoConfirmed: "RESULT AUTOMATICALLY CONFIRMED",
    conflictOpened: "CONFLICT CASE OPENED",
    resumeCreated: "RESUME MATCH CREATED OR MATCH WAS CONTINUED",
    processing: "BOTH RESULTS WERE REPORTED. EVALUATION IS RUNNING.",
  },

  conflictCaseOpened: "CONFLICT CASE OPENED",
  conflictStatusOpen: "OPEN",
  conflictStatusInReview: "IN REVIEW",
  conflictStatusDone: "DONE",
  conflictStatusReason: "Reason",
  conflictInfoText:
    "A conflict case has been created and will be reviewed manually. Please take photos of the result screen (team name + ID) and upload them.",
  playerReports: "Player reports",
  conflictCreatedHint: "A CONFLICT CASE HAS BEEN CREATED AND WILL BE REVIEWED MANUALLY. PLEASE TAKE PHOTOS OF THE RESULT SCREEN (TEAM NAME + ID) AND UPLOAD THEM.",
  conflictReasons: {
    scoreWinnerMismatch: "The reported results do not match.",
    scoreRageQuitMismatch:
      "The reported score does not match the rage quit report.",
    scoreConnectionIssueMismatch:
      "One player reported a final result, while the other reported a disconnect.",
    rageQuitLoserMismatch: "Both players reported different players as the loser.",
    rageQuitConnectionIssueMismatch:
      "One report describes a rage quit, while the other reports connection issues.",
    invalidConnectionIssueReport:
      "The disconnect details are incomplete or invalid.",
    connectionIssueScoreMismatch:
      "The reported scores at the disconnect do not match.",
    connectionIssueMinuteMismatch:
      "The reported disconnect minutes do not match.",
    unsupportedCombination:
      "The two reports cannot be combined automatically.",
    dualReportConflict:
      "The two reports contradict each other and need review.",
    repeatConnectionIssue:
      "Connection issues were reported again. The match is being reviewed.",
    repeatNoShow:
      "A player was reported as absent again.",
    reportTimeout:
      "No result was submitted before the reporting deadline.",
  },
  conflictUi: {
    title: "CONFLICT CASE",
    emptyState: "No conflict case has currently been created for this match.",
    collectingTitle: "EVIDENCE IS BEING COLLECTED",
    reviewReadyTitle: "SUBMITTED FOR REVIEW",
    inReviewTitle: "IN REVIEW",
    reviewReadyText: "The conflict case has been forwarded to an admin for review. Please wait until the admin has reviewed the case.",
    inReviewText: "An admin is currently reviewing your conflict case. Please wait for the decision.",
    doneText: "This conflict case has been decided.",
    evidenceDeadline: "EVIDENCE DEADLINE",
    bothSubmittedText: "Both players have finished their evidence submission.\nThe conflict case has been forwarded to an admin for review.\nPlease wait until the admin has reviewed the case.",
    deadlineExpiredText: "The evidence deadline has expired.\nThe conflict case has been forwarded to an admin for review.\nPlease wait until the admin has reviewed the case.",
    yourEvidence: "YOUR EVIDENCE",
    yourSubmissionCompleted: "YOUR EVIDENCE SUBMISSION HAS BEEN FINISHED ✓",
    opponentEvidence: "OPPONENT EVIDENCE SUBMISSION",
    yourReport: "YOUR REPORT",
    opponentReport: "OPPONENT REPORT",
    postReadyTimeline: {
      absence_report: { title: "REPORT BY {{username}}", text: "{{username}} reported as absent" },
      presence_confirmation: { title: "RESPONSE BY {{username}}", text: "Presence confirmed" },
      repeat_absence_report: { title: "REPEAT REPORT BY {{username}}", text: "{{username}} reported as absent again" },
      presence_timeout: { title: "PRESENCE DEADLINE EXPIRED", text: "{{username}} did not confirm presence in time" },
    },
    noReport: "No report submitted",
    scoreReport: "Result: {{score}}",
    rageQuitByTitle: "RAGE QUIT BY",
    rageQuitConflictSummary: "Rage quit by {{username}}",
    connectionIssueTitle: "CONNECTION ISSUE",
    connectionIssueMinuteLine: "In minute {{minute}}",
    connectionIssueScoreIntro: "at a score of:",
    rageQuitOpponent: "Rage quit – opponent left the match",
    rageQuitSelf: "Rage quit – you left the match",
    rageQuitBy: "Rage quit by: {{username}}",
    connectionIssueReport: "Connection issue in minute {{minute}} at {{score}}",
    connectionIssueReportNoMinute: "Connection issue at {{score}}",
    open: "OPEN",
    submitted: "SUBMITTED ✓",
    image: "Image",
    evidenceDeadlineHint: "You have until the evidence deadline to upload your evidence.",
    noImageHint: "You should upload image evidence if possible. Comments are only an additional explanation and do not replace image evidence.",
    photoUploadFailed: "Photo could not be uploaded. Please try again.",
    waitForPhotoUpload: "Please wait until your photos have finished uploading.",
    commentTitle: "ADDITIONAL COMMENT",
    commentHelp: "You can add extra information about the conflict. Comments are only explanatory and do not replace image evidence.",
    saveComment: "SAVE COMMENT",
    autosaving: "Saving comment...",
    autosaved: "Comment saved.",
    saving: "SAVING...",
    commentSaved: "Comment saved.",
    commentSavedQuiet: "SAVED ✓",
    commentSaveError: "Comment could not be saved.",
    finishButton: "FINISH EVIDENCE SUBMISSION",
    finishing: "FINISHING...",
    finishConfirm: "Do you want to finish your evidence submission?\n\nAfterwards you cannot add or change images or comments.",
    finishWithoutImageConfirm: "You have not uploaded any image evidence.\n\nComments are only an additional explanation and do not replace image evidence.\n\nDo you really want to finish without image evidence?",
    finishModalTitle: "FINISH EVIDENCE SUBMISSION",
    finishModalText: "Do you want to finish your evidence submission?\n\nAfterwards you cannot add or change images or comments.",
    finishModalCancel: "CANCEL",
    finishModalConfirm: "FINISH EVIDENCE SUBMISSION",
    finishWithoutImageTitle: "FINISH WITHOUT IMAGE EVIDENCE?",
    finishWithoutImageText: "You have not uploaded any image evidence.\n\nComments are only an additional explanation and do not replace image evidence.\n\nDo you really want to finish without image evidence?",
    finishWithoutImageBack: "BACK",
    finishWithoutImageConfirmButton: "FINISH ANYWAY",
    submissionFinished: "Evidence submission finished.",
    finishError: "Evidence submission could not be finished.",
    yourStatus: "Your evidence submission",
    matchTabHint: "A conflict case has been created for this match. You can find conflict details and submit evidence in the Conflict tab.",
    goToConflict: "GO TO CONFLICT",
    reasons: {
      resultDispute: "Contradicting result reports",
      reportTimeout: "No result report before the deadline",
      connectionIssue: "Connection issue",
      repeatConnectionIssue: "Repeated connection issue",
      repeatNoShow: "Opponent absent again after presence confirmation",
      rageQuit: "Rage quit",
      generic: "Conflict case",
    },
    explanations: {
      resultDispute: "The result reports do not match. Submit evidence that shows the actual match result.",
      reportTimeout: "No result was confirmed before the reporting deadline. Both players can now submit evidence about the match.",
      connectionIssue: "A connection issue was reported. Submit evidence that makes the score and match flow understandable.",
      repeatConnectionIssue: "Connection issues were reported again. Submit evidence that makes the match flow understandable.",
      repeatNoShow: "A player was reported as absent again after confirming presence. Submit evidence about the match flow.",
      rageQuit: "A rage quit was reported. Submit evidence that shows the match flow and result.",
      generic: "This conflict case is being reviewed. Submit evidence that makes the match flow understandable.",
    },
  },
  uploadTimeRemaining: "Upload time remaining",
  uploadTimeExpired: "UPLOAD TIME EXPIRED",
  selectImages: "SELECT IMAGES",
  addPhotos: "ADD PHOTOS",
  uploadingPhotos: "UPLOADING PHOTOS...",
  maxAmountReached: "MAXIMUM AMOUNT REACHED",
  uploadPhotos: "UPLOAD PHOTOS",
  photoUpload: "UPLOAD PHOTO",
  supportedEvidenceFormats: "Supported formats: JPG, PNG - Max. 10 MB",
  imagesUploaded: "IMAGES UPLOADED",
  selected: "SELECTED",
  remove: "Remove",

  waitForPresenceConfirmation: "WAIT UNTIL YOUR OPPONENT CONFIRMS THEIR PRESENCE",
  reportResult: "REPORT RESULT",
  waitForOpponentReport: "WAIT FOR YOUR OPPONENT'S REPORT",
  waitForOpponentAgreement: "PLEASE WAIT UNTIL YOUR OPPONENT AGREES TO THE RESULT",
  automaticDecisionIn: "AUTOMATIC DECISION IN",
  lastChance: "LAST CHANCE",
  responseTime: "RESPONSE TIME",
  confirmResult: "CONFIRM RESULT",
  rejectResult: "REJECT RESULT",
  noCurrentMatch: "YOU CURRENTLY HAVE NO MATCH",

  noMatchesInThisRound: "NO MATCHES IN THIS ROUND YET",
  bye: "Bye",
  myMatchTitle: "Your match",
  vs: "vs",
  invalid: "INVALID",

  matchReportTitle: "MATCH REPORT",
  scoreEntrySubtitle: "Enter final score",
  matchReportSubtitle: "What happened in this match?",
  matchReportCards: {
    a: { title: "Report result", description: "Enter the correct final score" },
    b: { title: "We are still playing", description: "Gives you 10 more minutes" },
    c: { title: "Opponent did not show", description: "My opponent did not show up for the match" },
    d: { title: "Rage Quit", description: "My opponent left the match early" },
    e: { title: "Connection issues", description: "The match could not be completed normally due to connection issues" },
  },
  selectMatchingOption: "PLEASE SELECT THE APPLICABLE OPTION...",
  player1: "Player 1",
  player2: "Player 2",
  unknownPlayer: "Unknown player",
  sendResult: "SEND RESULT",
  option: "OPTION",

  options: {
    a: "ENTER RESULT",
    b: "WE ARE STILL PLAYING - RESULT WILL FOLLOW",
    c: "MY OPPONENT DID NOT SHOW UP",
    d: "RAGE QUIT",
    e: "CONNECTION ISSUES",
  },

  whoLeftTheMatch: "WHO LEFT THE MATCH?",
  rageQuitSelectionSubtitle: "Select the player who left the match.",
  rageQuitOpponentLabel: "YOUR OPPONENT",
  me: "ME",
  myOpponent: "MY OPPONENT",
  cancel: "CANCEL",

  connectionIssues: "CONNECTION ISSUES",
  gameMinute: "MATCH MINUTE",
  whichMinuteDisconnected: "IN WHICH MATCH MINUTE DID THE CONNECTION DROP?",
  whatWasTheScore: "WHAT WAS THE SCORE?",
  send: "SEND",

  readyToPlay: "READY TO PLAY?",
opponentSaysNoShow: "YOUR OPPONENT REPORTS THAT YOU DID NOT SHOW UP.",
iAmReadyToPlay: "I AM READY TO PLAY",
presenceConfirmedTitle: "PRESENCE CONFIRMED",
opponentConfirmed: "YOUR OPPONENT HAS CONFIRMED THEIR PRESENCE. PLEASE TRY STARTING YOUR MATCH AGAIN.",



  connectionResumeTitle: "Resume Match",
resumeContinueUntil: "Play until minute",
resumeMinute: "",
resumeIfDraw: "If the score is tied afterwards:",
resumePlayFullExtraTime: "finish the match including extra time and penalties.",
resumePlay: "Play another",
resumeMoreMinutes: "minutes",
currentScore: "Current Score",
continue: "Continue",
firstMatch: "First Match",
finalResult: "Final Result",
game1: "GAME 1",
game2: "GAME 2",
total: "TOTAL",
resumeMatchHint:
  "IMPORTANT: ONLY ENTER THE RESULT OF THIS MATCH. THE PREVIOUS RESULT WILL BE ADDED AUTOMATICALLY.",

resumeEvidence: {
  title: "IMPORTANT NOTICE",
  text:
    "Please take screenshots or photos of the result of the first match (connection issue match). If a dispute occurs later, these images may be required as evidence. Without evidence, making a clear decision may become difficult.",
  confirm: "UNDERSTOOD",
},

resumeInstructions: {
  leading:
    "The match was interrupted in the {{minute}}th minute with a score of {{scoreP1}}:{{scoreP2}} for {{leader}}. Play a new match until the {{targetMinute}}th minute. If {{trailingPlayer}} equalizes, continue the match including extra time and penalties until the end.",

  draw:
    "The match was interrupted in the {{minute}}th minute with a score of {{scoreP1}}:{{scoreP2}}. Play a new match until the {{targetMinute}}th minute. If the score is still tied, continue the match including extra time and penalties until the end.",
},

  alerts: {
    maxEvidenceImages: "You can upload a maximum of 3 evidence images.",
    enterBothScores: "Please enter both scores (0 is allowed).",
    extensionNotPossible: "Extension is not possible.",
    validMinute: "Please enter a valid match minute from 1 to 120.",
    validScores: "Please enter valid scores.",
    saveError: "Error while saving. Please try again.",
    confirmError: "Error while confirming.",
    confirmDeadlineExpired: "The confirmation deadline has expired.",
    confirmAlreadyProcessed: "This result has already been processed.",
    confirmLifecycleChanged: "The match state has changed. Please reload the match.",
    confirmConflict: "A conflict case already exists for this match.",
    selectAtLeastOneImage: "Please select at least one image.",
    photosUploaded: "Photos uploaded successfully.",
    uploadDeadlineExpired: "The upload deadline has expired.",
    alreadyUploadedThree: "You have already uploaded three images.",
    photoUploadError: "Error uploading photos.",
  },
},


singleGames: {
  stake: {
    title: "CHOOSE COINS FOR THE MATCH",
    subtitle: "Choose how many coins you want to stake for this match.",
    levels: {
      0: { title: "LOW STAKE", description: "Play It Safe." },
      1: { title: "MEDIUM STAKE", description: "Raise The Stakes." },
      2: { title: "HIGH STAKE", description: "High Risk. High Reward." },
    },
  },
  mode: {
  title: "PLEASE CHOOSE WHETHER YOU WANT TO CHALLENGE A FRIEND OR SEARCH FOR A FREE MATCH",
  challengeFriend: "CHALLENGE A FRIEND",
  searchFreeGame: "SEARCH FOR A FREE MATCH",
  random: "RANDOM OPPONENT",
  friend: "FRIEND",
},
confirm: "CONFIRM",
friendLimitTitle: "LIMIT REACHED",
friendLimitText: "You can only play 3 friend matches per day.",
friendLimitCounter: "Friend matches today",
limitReached: "LIMIT REACHED",
  queue: {
    searchingOpponent: "SEARCHING FOR OPPONENT",
    cancelSearch: "CANCEL SEARCH",
  },
  challenge: {
    title: "ENTER THE USERNAME YOU WANT TO CHALLENGE",
    usernamePlaceholder: "Enter username",
    stakeLabel: "Stake: {{stake}} coins",
    checkingUser: "CHECKING USER...",
    challengeFriend: "CHALLENGE FRIEND",
  },
  modals: {
    ok: "OK",
    alreadyFriendsTitle: "ALREADY FRIENDS",
    alreadyFriendsText: "You are already friends.",
    friendRequestPendingTitle: "REQUEST ALREADY SENT",
    friendRequestPendingText: "There is already a pending friend request.",
    friendRequestSentTitle: "FRIEND REQUEST SENT",
    friendRequestSentText: "The friend request was sent successfully.",
    alreadyExistsTitle: "ALREADY EXISTS",
    alreadyExistsText: "A friendship or pending request already exists.",
    notPossibleTitle: "NOT POSSIBLE",
    friendRequestNotPossibleText: "This friend request could not be sent.",
    notAllowedTitle: "NOT ALLOWED",
    friendRequestNotAllowedText: "You are currently not allowed to send a request to this user.",
    errorTitle: "ERROR",
    friendRequestErrorText: "An error occurred while sending the friend request.",
    usernameMissingTitle: "USERNAME MISSING",
    usernameMissingText: "Please enter a username.",
    accountLoadErrorText: "Your account could not be loaded. Please try again.",
    userNotFoundTitle: "USER NOT FOUND",
    userNotFoundText: "No user with this username was found.",
    usernameResolveErrorText: "The username could not be resolved correctly. Please try again.",
    notFriendTitle: "NOT A FRIEND",
    notFriendText: "This user is not in your friends list.",
    cannotChallengeSelfText: "You cannot challenge yourself.",
    challengeSentTitle: "CHALLENGE SENT",
    challengeSentText: "The challenge to {{username}} was sent successfully.",
    accountBannedTitle: "ACCOUNT BANNED",
    accountTemporarilyBannedUntilText: "Your account has been temporarily suspended. Participation is not possible until {{date}}.",
    accountTemporarilyBannedText: "Your account has been temporarily suspended. Participation in single matches is currently not possible.",
    challengeAlreadyOpenTitle: "CHALLENGE ALREADY OPEN",
    challengeAlreadyOpenText: "A pending challenge has already been sent to this friend.",
    notEnoughCoinsTitle: "NOT ENOUGH COINS",
    notEnoughCoinsChallengeText: "You do not have enough coins to send this challenge.",
    selectedUserNotFoundText: "The selected user could not be found.",
    challengeSendErrorText: "An error occurred while sending the challenge. Please try again.",
    accountPermanentlyBannedText: "Your account has been permanently suspended. Participation in single matches is not possible.",
    notEnoughCoinsSingleGameText: "You do not have enough coins to start a single match.",
    startGameErrorText: "An error occurred while starting the match. Please try again.",
    cancelSearchErrorText: "The match search could not be cancelled correctly. Please try again.",
    queueJoinErrorText:
  "Failed to start matchmaking. Please check your internet connection and try again.",
  },
},



singleMatch: {
  you: "YOU",
  console: {
    rulesLoadError: "Error loading single match rules:",
  },
  alerts: {
    validNumbers: "Please enter valid numbers.",
    scoresNotNegative: "Scores must not be negative.",
    noDraws: "Please enter a result with a clear winner.",
    saveError: "Error while saving. Please try again.",
    confirmError: "Error while confirming.",
    rejectError: "Error while rejecting.",
    enterBothScores: "Please enter both scores (0 is allowed).",
    validMinute: "Please enter a valid match minute from 1 to 120.",
    validScores: "Please enter valid scores.",
    reportingTooEarly:
  "Results can only be reported starting at {{time}}.",
  },
  labels: {
    opponent: "Opponent",
    player1: "PLAYER 1",
    player2: "PLAYER 2",
    latestReportTimeValue: "{{time}}",
    earliestReportTimeValue: "{{time}}",
  },
  states: {
    loading: "Loading match...",
    loadError: "Error while loading: {{error}}",
    notFound: "Match not found.",
  },
  tabs: {
    yourMatch: "YOUR MATCH",
    chat: "CHAT",
    stake: "STAKE",
    matchRules: "MATCH RULES",
  },
  match: {
    showdown: "SHOWDOWN",
    statusYourMatchAgainst: "STATUS: YOUR MATCH AGAINST",
    opponentEaInfo: "HERE YOU CAN VIEW YOUR OPPONENT'S EA ID/CONSOLE ID.",
    viewProfile: "VIEW PROFILE",
    addFriend: "ADD FRIEND",
    liveNow: "LIVE NOW...",
    latestReportTime: "LATEST REPORT TIME:",
    earliestReportTime: "EARLIEST REPORT TIME:",
    waitForOpponentPresence: "WAIT UNTIL YOUR OPPONENT CONFIRMS THEIR PRESENCE",
    reportResult: "REPORT RESULT",
    waitForOpponentReport: "WAIT FOR YOUR OPPONENT'S REPORT",

  },
  report: {
    resultReported: "RESULT REPORTED",
    rageQuitSubtitle: "RAGE QUIT – {{username}} LEFT THE MATCH",
    connectionSubtitle: "CONNECTION ISSUES – DISCONNECTED IN: {{minute}}. MINUTE",
    reportedResult: "REPORTED RESULT",
    reportedBy: "REPORTED BY: {{username}}",
    waitForOpponentResponse: "WAIT FOR YOUR OPPONENT'S RESPONSE",
    autoDecisionIn: "AUTO DECISION IN: {{seconds}}s",
    lastChance: "LAST CHANCE: {{seconds}}s",
    responseTime: "RESPONSE TIME: {{seconds}}s",
    confirmResult: "CONFIRM RESULT",
    rejectResult: "REJECT RESULT",
    game1: "Game 1",
game2: "Game 2",
total: "Total",
  },
  dual: {
    you: "YOU",
    opponent: "OPPONENT",
    reportedBy: "REPORTED BY",
    yourReport: "YOUR REPORT",
    opponentReportedResultDecision:
      "YOUR OPPONENT HAS ALREADY REPORTED A RESULT.",
    opponentReportedRageQuitDecision:
      "YOUR OPPONENT HAS ALREADY REPORTED A RAGE QUIT.",
    opponentReportedConnectionDecision:
      "YOUR OPPONENT HAS ALREADY REPORTED CONNECTION ISSUES.",
    confirmResult: "CONFIRM RESULT",
    confirmRageQuit: "CONFIRM RAGE QUIT",
    confirmConnectionIssue: "CONFIRM CONNECTION ISSUES",
    submitDifferentReport: "SUBMIT DIFFERENT REPORT",
    connectionEvidenceHint:
      "IMPORTANT: TAKE PHOTOS OF THE FINAL RESULT INCLUDING TEAM NAMES AND EA/CONSOLE ID NOW. IF THE RESUME MATCH HAS ANOTHER ISSUE OR DIFFERING DETAILS, YOU WILL NEED THESE EVIDENCE IMAGES.",
    responseCountdownLabel:
      "TIME TO CONFIRM THE RESULT OR SUBMIT A DIFFERENT RESULT:",
    reporterResponseCountdownLabel:
      "YOUR OPPONENT STILL HAS TIME TO RESPOND TO YOUR REPORT:",
    waitForOpponent:
      "YOU REPORTED YOUR RESULT. WAIT UNTIL YOUR OPPONENT HAS ALSO REPORTED A RESULT.",
    opponentReported: "YOUR OPPONENT REPORTED THE FOLLOWING RESULT:",
    resultReported: "RESULT REPORTED",
    rageQuit: "RAGE QUIT",
    rageQuitBy: "RAGE QUIT BY {{username}}",
    leftMatch: "{{username}} LEFT THE MATCH",
    rageQuitReportedBy: "{{username}} reported a rage quit.",
    reportedRageQuitPlayer: "Rage quit by",
    connectionIssue: "CONNECTION ISSUES",
    connectionIssueMinute: "CONNECTION ISSUE IN MINUTE {{minute}}",
    minute: "{{minute}}. MINUTE",
    waiting: "NO RESULT REPORTED",
    autoConfirmed: "RESULT AUTOMATICALLY CONFIRMED",
    conflictOpened: "CONFLICT CASE OPENED",
    resumeCreated: "RESUME MATCH CREATED OR MATCH WAS CONTINUED",
    processing: "BOTH RESULTS WERE REPORTED. EVALUATION IS RUNNING.",
  },
  evidence: {
    selectAtLeastOneImage: "Please select at least one image.",
    photosUploaded: "Photos uploaded successfully.",
    uploadExpired: "The upload deadline has expired.",
    threeImagesAlreadyUploaded: "You have already uploaded three images.",
    uploadError: "Error uploading photos.",
  },
  conflict: {
    conflictCreated: "A CONFLICT CASE HAS BEEN CREATED AND WILL BE REVIEWED MANUALLY. PLEASE TAKE PHOTOS OF THE RESULT (TEAM NAME + ID) AND UPLOAD THEM.",
    uploadTimeRemaining: "Upload time remaining",
    maxThreeEvidenceImages: "You can upload a maximum of 3 evidence images.",
    uploadExpired: "UPLOAD TIME EXPIRED",
    selectImages: "SELECT IMAGES",
    photosUploading: "UPLOADING PHOTOS...",
    maxReached: "MAXIMUM AMOUNT REACHED",
    uploadPhotos: "UPLOAD PHOTOS",
    imagesUploaded: "{{count}}/3 IMAGES UPLOADED",
    imagesSelected: "{{count}} SELECTED",
    remove: "REMOVE",
    repeatConnectionIssue: "REPEATED CONNECTION ISSUES HAVE BEEN REPORTED. THE MATCH IS BEING REVIEWED. NO FURTHER ACTION IS REQUIRED.",
    repeatNoShow: "REPEATED ATTENDANCE ISSUES HAVE BEEN REPORTED. THE MATCH IS BEING REVIEWED. NO FURTHER ACTION IS REQUIRED.",
  },
  conflictReasons: {
    scoreWinnerMismatch: "The reported results do not match.",
    scoreRageQuitMismatch:
      "The reported score does not match the rage quit report.",
    scoreConnectionIssueMismatch:
      "One player reported a final result, while the other reported a disconnect.",
    rageQuitLoserMismatch: "Both players reported different players as the loser.",
    rageQuitConnectionIssueMismatch:
      "One report describes a rage quit, while the other reports connection issues.",
    invalidConnectionIssueReport:
      "The disconnect details are incomplete or invalid.",
    connectionIssueScoreMismatch:
      "The reported scores at the disconnect do not match.",
    connectionIssueMinuteMismatch:
      "The reported disconnect minutes do not match.",
    unsupportedCombination:
      "The two reports cannot be combined automatically.",
    dualReportConflict:
      "The two reports contradict each other and need review.",
    repeatConnectionIssue:
      "Connection issues were reported again. The match is being reviewed.",
    repeatNoShow:
      "A player was reported as absent again.",
    reportTimeout:
      "No result was submitted before the reporting deadline.",
  },
  stake: {
    stake: "STAKE: {{stake}} COINS",
    pot: "POT: {{pot}} COINS",
    fee: "FEE: 5% ({{feeCoins}} COINS)",
    payout: "PAYOUT: {{payout}} COINS",
    netWin: "NET WIN: +{{netWin}} COINS",
  },
  reportModal: {
    title: "MATCH REPORT",
    scoreSubtitle: "Enter final score",
    subtitle: "What happened in this match?",
    cards: {
      a: { title: "Report result", description: "Enter the correct final score" },
      b: { title: "We are still playing", description: "Gives you 10 more minutes" },
      c: { title: "Opponent did not show", description: "My opponent did not show up for the match" },
      d: { title: "Rage Quit", description: "My opponent left the match early" },
      e: { title: "Connection issues", description: "The match could not be completed normally due to connection issues" },
    },
    chooseOption: "PLEASE SELECT THE CORRECT OPTION...",
    optionLabel: "OPTION {{key}}",
    optionA: "ENTER RESULT",
    optionB: "WE ARE STILL PLAYING - RESULT FOLLOWS",
    optionC: "MY OPPONENT DID NOT SHOW UP",
    optionD: "RAGE QUIT",
    optionE: "CONNECTION ISSUES",
    sendResult: "SEND RESULT",
  },
  resume: {
  infoText:
    "Important:\nOnly enter the result of this match.\nThe previous result will be added automatically.",

  fullExplanation:
    "THE MATCH WAS INTERRUPTED.\n\n" +
    "PLAY A NEW MATCH UNTIL THE SPECIFIED MINUTE.\n\n" +
    "IF YOUR OPPONENT EQUALIZES, FINISH THE MATCH TO ITS CONCLUSION, INCLUDING EXTRA TIME AND PENALTY SHOOTOUT.\n\n" +
    "ONLY ENTER THE RESULT OF THIS MATCH.",

  modalTitle: "RESUME MATCH",
  confirm: "UNDERSTOOD",
  finalResultLabel: "Final result:",
  overallResultLabel: "Overall result",
  game2InputLabel: "Match 2",

  previousResultLabel: "Previous result",
  onlyThisMatchLabel: "Now only enter the result of the second match.",
},

resumeEvidence: {
  title: "Important Notice",
  text:
    "Please take screenshots or photos of the result of the first match (connection issue match). If a dispute occurs later, these images may be required as evidence. Without evidence, making a clear decision may become difficult.",
  confirm: "Understood",
},

resumeInstructions: {
  finished:
    "The match ended in the {{minute}}th minute. Play a completely new match.",

  leading:
    "The match was interrupted in the {{minute}}th minute with a score of {{scoreP1}}:{{scoreP2}} for {{leader}}. Play a new match until the {{targetMinute}}th minute. If {{trailingPlayer}} equalizes, continue the match including extra time and penalties until the end.",

  draw:
    "The match was interrupted in the {{minute}}th minute while the score was tied at {{scoreP1}}:{{scoreP2}}. Play a new match until the {{targetMinute}}th minute. If the score is still tied, continue the match until penalties.",
},

  finished: {
    winTitle: "VICTORY!",
    lossTitle: "DEFEAT",
    winText: "You won the match. {{payoutAmount}} coins have been credited to you.",
    lossText: "You lost the match. Your stake of {{stakeCoins}} coins is gone.",
    ok: "OK",
  },
  rageQuit: {
    title: "WHO LEFT THE MATCH?",
    question: "Select the player who left the match.",
    opponentLabel: "YOUR OPPONENT",
    me: "ME",
    myOpponent: "MY OPPONENT",
    cancel: "CANCEL",
  },
  connection: {
    title: "CONNECTION ISSUES",
    minuteLabel: "MATCH MINUTE",
    minuteQuestion: "IN WHICH MATCH MINUTE DID THE CONNECTION DROP?",
    minutePlaceholder: "1-120",
    scoreQuestion: "WHAT WAS THE SCORE?",
    send: "SEND",
    cancel: "CANCEL",
  },
  noShow: {
  title: "READY TO PLAY?",
  text: "YOUR OPPONENT REPORTED THAT YOU DID NOT SHOW UP.",
  confirmReady: "I AM READY TO PLAY",
  presenceConfirmedTitle: "PRESENCE CONFIRMED",
  opponentConfirmed: "Your opponent has confirmed their presence. Please try starting your match again.",
},
  
  rulesLabels: {
  gameMode: "GAME MODE",
  matchDuration: "MATCH DURATION",
  format: "FORMAT",
  tieDecision: "TIE DECISION",
  teamSelection: "TEAM SELECTION",
  platform: "PLATFORM",
},
rulesValues: {
  gameMode: "ONLINE MODE WITH INDIVIDUALLY BUILT TEAMS",
  matchDuration: "6 MINUTES",
  format: "BEST-OF-ONE",
  groupStageFormat: "Group Stage / Knockout Phase (Best-of-One)",
  tieDecision: "EXTRA TIME + PENALTY SHOOTOUT",
  teamSelection: "FREE CHOICE",
  platform: "PLAYSTATION / X-BOX / PC (ONLY NEW GEN)",
},
},

profile: {
  loading: "LOADING PROFILE...",
  loadError: "PROFILE COULD NOT BE LOADED",

  tabs: {
    profile: "PROFILE",
    stats: "STATS",
    history: "HISTORY",
  },

  labels: {
    joinDate: "JOIN DATE",
    memberSince: "MEMBER SINCE",
    trustLevel: "TRUST LEVEL",
    username: "VAULTQUEST USERNAME",
    console: "CONSOLE",
    platform: "PLATFORM",
    consoleId: "CONSOLE ID",
    epicId: "EPIC ID",
    eaId: "EA ID",
    utName: "ULTIMATE TEAM",
  },

  sections: {
    gaming: "GAMING",
  },

  stats: {
    overall: "OVERALL STATS",
    overview: "OVERVIEW",
    total: "TOTAL",
    tournaments: "TOURNAMENTS",
    singles: "SINGLE MATCHES",
    matches: "MATCHES",
    played: "GAMES PLAYED",
    wins: "WINS",
    losses: "LOSSES",
    winRate: "WIN RATE",
    fairPlayStreak: "FAIR PLAY STREAK",
    gamesLabel: "GAMES",
    tournamentGames: "TOURNAMENT GAMES",
    singleGames: "SINGLE MATCHES",
    coins: "COINS EARNED",
    bestTournamentLeaderboardRank: "BEST LEADERBOARD RANK",
    bestSingleLeaderboardRank: "BEST LEADERBOARD RANK",
  },

  history: {
    title: "LAST 10 GAMES",
    loading: "LOADING...",
    empty: "NO MATCHES YET",
    tournamentMatch: "TOURNAMENT MATCH",
    singleMatch: "MATCH",
    opponent: "OPPONENT",
    result: "RESULT:",
    win: "VICTORY",
    loss: "DEFEAT",
  },
},





fairPlayCommunity: {
  trustLevel: "TRUST LEVEL",
  rules: "RULES",
  friends: "FRIENDS LIST",
  leaderboards: "LEADERBOARDS",
  quests: "Quests",
},

fairPlayPage: {
  title: "FairPlay",
  intro: "Fairness and trust are the foundation of VaultQuest. Here you can see your trust level and the most important rules.",
  yourTrustLevel: "Your Trust Level",
  currentLevel: "Current Trust Level",
  allTrustLevels: "All Trust Levels",
  rulesTitle: "Rules",
  trustText: "Your trust level reflects your reliability, participation in matches, and correctly submitted results. Verified unfair behavior can lower your level.",
},



trustLevel: {
  page1: {
    title: "YOUR TRUST LEVEL",
    info: "YOUR TRUST LEVEL REFLECTS YOUR RELIABILITY, PARTICIPATION IN MATCHES, AND CORRECTLY SUBMITTED RESULTS. FOR EVERY VERIFIED UNFAIR ACTION, IT DROPS BY ONE LEVEL.",
    currentLevel: "TRUST: LEVEL {{level}}",
  },
  page2: {
    title: "TRUST LEVEL OVERVIEW",
  },
  table: {
    level: "LEVEL",
    name: "NAME",
    meaning: "MEANING",
  },
  levels: {
    7: { name: "EXEMPLARY", meaning: "CONSISTENTLY FAIR" },
    6: { name: "RELIABLE", meaning: "TRUSTWORTHY" },
    5: { name: "SOLID", meaning: "MOSTLY FAIR" },
    4: { name: "CAUTIOUS", meaning: "OCCASIONALLY UNFAIR" },
    3: { name: "WARNING", meaning: "UNFAIR" },
    2: { name: "RISK PLAYER", meaning: "REPEATEDLY UNFAIR" },
    1: { name: "PERMA BAN", meaning: "PERMANENTLY UNFAIR" },
  },
},


rules: {
  page1: {
    title: "BASIC PRINCIPLES",
    bullets: [
      "HONEST AND CORRECT RESULT REPORTING",
      "RESPECTFUL INTERACTION WITH OTHERS",
      "FAIRNESS TOWARD ALL PLAYERS",
      "NO MATCH ABANDONMENT WITHOUT REASON",
    ],
  },
  page2: {
    title: "PROHIBITED BEHAVIOR",
    bullets: [
      "FALSIFYING/MANIPULATING MATCH RESULTS",
      "CHEATING",
      "INSULTS",
      "USING MULTIPLE ACCOUNTS TO GAIN AN ADVANTAGE",
      "SHARING YOUR ACCOUNT WITH THIRD PARTIES",
    ],
  },
  page3: {
    title: "CONFLICT CASES",
    bullets: [
      "DISCREPANCIES IN RESULT REPORTING ARE AUTOMATICALLY REPORTED AS A CONFLICT CASE",
      "EVIDENCE (SCREENSHOTS) HELPS WITH CLARIFICATION",
      "THE CONFLICT CASE IS REVIEWED AND ASSESSED NEUTRALLY",
    ],
  },
  page4: {
    title: "CONSEQUENCES OF VIOLATIONS",
    bullets: [
      "REDUCTION OF TRUST LEVEL",
      "TEMPORARY SUSPENSION FROM MATCHES AND TOURNAMENTS",
      "PERMANENT BAN IN CASE OF REPEATED OR SERIOUS VIOLATIONS",
    ],
  },
},




friends: {
  tabs: {
    myFriends: "MY FRIENDS",
    searchFriends: "SEARCH FRIENDS",
    requests: "REQUESTS",
  },
  actions: {
    openMenu: "Open menu",
    viewProfile: "VIEW PROFILE",
    removeFriend: "REMOVE FRIEND",
    sendRequest: "SEND FRIEND REQUEST",
    sending: "SENDING...",
    addFriend: "ADD FRIEND",
    accept: "ACCEPT",
    decline: "DECLINE",
    removing: "REMOVING...",
    yesRemove: "YES, REMOVE",
  },
  search: {
    placeholder: "ENTER USERNAME",
    searching: "SEARCHING…",
    title: "FIND FRIENDS",
    subtitle: "Search for a VaultQuest player",
  },
  labels: {
    trustLevel: "Trust level",
  },
  empty: {
    noFriends: "You don’t have any friends yet. Use “Search Friends” or check “Requests.”",
    noIncomingRequests: "NO OPEN REQUESTS",
    requestsHint: "New friend requests will appear here.",
  },
  requests: {
    from: "Request from: {{name}}",
    noLongerPending: "This request is no longer pending.",
    wantsToBeFriend: "wants to be your friend",
  },
  modal: {
    removeFriendConfirm: "Do you really want to remove {{name}}?",
  },
  status: {
    profileNotConnected: "View profile ({{name}}) is not connected yet.",
    friendRemoved: "Friend removed: {{name}}",
    alreadyFriends: "You are already friends.",
    alreadyPending: "There is already a pending friend request.",
    requestSent: "Friend request sent.",
    requestNotAllowed: "You cannot send this user a friend request right now.",
    enterUsername: "Please enter a username.",
    userNotFound: "❌ User not found.",
    cannotAddSelf: "You cannot send a request to yourself.",
    requestAccepted: "✅ Request accepted.",
    requestDeclined: "✅ Request declined.",
    requestError: "An error occurred while sending the friend request.",
    errorWithDetails: "❌ Error: {{code}} {{message}}",
  },
},


leaderboards: {
  unknownUser: "Unknown",
  filterTitle: "LEADERBOARD FILTER",
  tabs: {
    tournaments: "TOURNAMENTS",
    singles: "MATCHES",
  },
  monthlyOverall: "MONTHLY OVERALL",
  archive: {
    month: "Select month",
    year: "Select year",
    apply: "Apply",
  },
  reward: {
    title: "Monthly rewards",
    place: "Place",
  },
  table: {
    rank: "RANK",
    name: "NAME",
    player: "PLAYER",
    points: "POINTS",
  },
  empty: "No players in the leaderboard yet (minimum requirement).",
  emptyTitle: "NO PLAYERS YET",
  emptyDescription: "No one currently meets the minimum requirements for this leaderboard.",
  emptyAction: "Play more matches to earn your place.",
},


rewards: {
  title: "QUESTS",
  claim: "CLAIM",
  claiming: "CLAIMING...",
  coins: "Coins",
  rewardLabel: "Reward",
  progress: "Progress",
  categories: {
    matches: "Matches", tournaments: "Tournaments", tournamentTypes: "Tournament types",
    wins: "Wins", community: "Community", achievements: "Achievements",
    loyalty: "Loyalty", leaderboard: "Leaderboard", performance: "Match achievements",
  },
  status: {
    locked: "Not reached", available: "Ready", claimed: "Completed",
    lockedLong: "Not reached yet", availableLong: "Reached – reward available", claimedLong: "Reward claimed",
  },
  items: {
    firstMatchPlayed: { name: "First Match", description: "Play your first match" },
    matches5: { name: "Getting Started", description: "Play 5 matches" },
    matches10: { name: "Warmed Up", description: "Play 10 matches" },
    matches20: { name: "Matchday Regular", description: "Play 20 matches" },
    matches50: { name: "Staying Power", description: "Play 50 matches" },
    matches100: { name: "Centurion", description: "Play 100 matches" },
    firstTournamentPlayed: { name: "Part of it.", description: "Take part in your first tournament." },
    tournaments10Played: { name: "Patron", description: "Take part in 10 tournaments" },
    firstTournamentWon: { name: "Tournament Victory", description: "Win your first tournament" },
    tournaments5Won: { name: "Trophy Collector", description: "Win 5 tournaments" },
    tournaments10Won: { name: "Title Hunter", description: "Win 10 tournaments" },
    tournaments25Won: { name: "Champion", description: "Win 25 tournaments" },
    eveningCups5: { name: "Evening Eve", description: "Take part in 5 Evening Cups" },
    nightlyCups5: { name: "Night owl", description: "Take part in 5 Nightly Cups" },
    specialCups1: { name: "Special Guest", description: "Take part in one Special Cup" },
    specialCups5: { name: "Special Patron", description: "Take part in 5 Special Cups" },
    creatorCups3: { name: "Creator", description: "Take part in 3 Creator Cups" },
    wins1: { name: "First Win", description: "Win one match" },
    wins10: { name: "Winning Ways", description: "Win 10 matches" },
    wins20: { name: "Winner Type", description: "Win 20 matches" },
    wins50: { name: "Winning Machine", description: "Win 50 matches" },
    wins100: { name: "Veteran", description: "Win 100 matches" },
    winStreak3: { name: "Winning Streak", description: "Win 3 matches in a row" },
    winStreak5: { name: "Unstoppable", description: "Win 5 matches in a row" },
    friend1: { name: "Friend", description: "Add your first friend" },
    friends5: { name: "Getting Social", description: "Be friends with 5 users" },
    friends10: { name: "Friend Group", description: "Be friends with 10 users" },
    friends20: { name: "Well Connected", description: "Be friends with 20 users" },
    coins1000Single: { name: "Earnings", description: "Earn 1000 coins through matches" },
    coins5000Single: { name: "Incoming", description: "Earn 5000 coins through matches" },
    coins10000Single: { name: "Revenue", description: "Earn 10000 coins through matches" },
    login3Days: { name: "Keeping At It", description: "Log in 3 days in a row" },
    login10Days: { name: "Regular", description: "Log in 10 days in a row" },
    login25Days: { name: "Loyal Bunny", description: "Log in 25 days in a row" },
    leaderboardTop10: { name: "Top Ten", description: "Reach the Top 10 in the leaderboards" },
    leaderboardTop3: { name: "Podium", description: "Reach the Top 3 in the leaderboards" },
    leaderboardRank1: { name: "Number One", description: "Reach first place in the leaderboards" },
    leaderboardTop10Months3: { name: "Established", description: "Reach the Top 10 in 3 months" },
    leaderboardTop3Months3: { name: "Podium Patron", description: "Reach the Top 3 in 3 months" },
    leaderboardRank1Months3: { name: "Dynasty", description: "Reach first place in 3 months" },
    goals10: { name: "Goal Threat", description: "Score 10 goals in total" },
    goals25: { name: "Finisher", description: "Score 25 goals in total" },
    goals50: { name: "Clinical", description: "Score 50 goals in total" },
    goals100: { name: "Goal Hunter", description: "Score 100 goals in total" },
    dominantWin: { name: "Dominant", description: "Win a regular match by at least 3 goals" },
    cleanSheetWin: { name: "Clean Sheet", description: "Win a regular match without conceding" },
  },
},

rewardPrompt: {
  eyebrow: "Quest reward",
  titleOne: "Reward ready",
  titleMany: "{{count}} rewards ready",
  textOne: "You completed a quest. Your coins are waiting for you.",
  textMany: "You completed multiple quests. Claim your coins now.",
  more: "+{{count}} more rewards",
  cta: "Go to my quests",
  later: "Later",
},



shop: {
  title: "Shop",
  comingSoon: "The shop is coming soon.",
  moreInfo: "You will be able to purchase coins here.",
},

vouchers: {
  title: "Vouchers",
  empty: "You have not won any vouchers yet.",
  valueLabel: "Value",
  codeLabel: "Code",
  unknownProvider: "Unknown provider",
  copyCode: "Copy Code",
  copied: "Copied",
  receivedAtLabel: "Received on:",
  remove: "Remove",
  providerLabel: "Provider",
},


landing: {
  heroTitle: "Enter the Vault. Start your Quest.",
  heroClaim: "The tournament platform for competitive gaming.",
  heroSubtitle: "The tournament starts here. Compete against opponents, fight for victory, and earn real rewards.",
  startButton: "Start now",
  newGenNotice: "VaultQuest only supports current-generation consoles (PS5 & Xbox Series X|S). Old-generation consoles such as PS4 or Xbox One are not supported.",
  howItWorksTitle: "How does VaultQuest work?",
  joinTournamentTitle: "Join tournament",
  joinTournamentText: "The tournament card shows you all information about tournament status, rewards, player slots, start time and entry fees.",
  matchViewTitle: "Match view",
  matchViewText: "The match view shows you who you will play next. Tap \"View profile\" to see your opponent's console details, add them, and start the match.",
  reportTitle: "Report result",
  reportText: "Option A: Enter your result.\nOption B: Gives you 10 more minutes.\nOption C: If your opponent did not show up.\nOption D: Enter whether you or your opponent rage quit.\nOption E: If you had connection issues, enter the score and the minute when the match ended. An admin will review the case.",
  conflictTitle: "Conflict case",
  conflictText: "If your opponent reported a wrong result, you can reject it. This creates a conflict case that allows both you and your opponent to upload up to 3 images of the result. Based on these images, the decision will be made whether you advance or are eliminated. Make sure the score, console ID, and team name are visible in the images.",
  winTitle: "Tournament victory",
  winText: "If you win a tournament, you will receive your voucher code via the VaultQuest notification system and via your registered email address.",
  whyTitle: "Why VaultQuest?",
realCompetitionTitle: "Real competitions",
realCompetitionText: "Play against real opponents in structured tournaments.",
noticeText: "Please make sure to provide truthful information within the specified deadlines. Any action that does not align with VaultQuest values will be addressed in a targeted and consistent manner.",
fastMatchesTitle: "Fast matches",
fastMatchesText: "No long sessions – play, see results, and earn rewards.",
skillTitle: "Skill decides",
skillText: "Your performance in the match matters.",
rewardsTitle: "Real rewards",
rewardsText: "Win vouchers through your tournament victories.",
betaText: "Wir freuen uns über dein Feedback und entwickeln VaultQuest kontinuierlich weiter.",
mobileBannerLabel: "Note:",
mobileBanner: "VaultQuest is currently optimized for mobile devices. On desktop (PC/Mac), some interactions may be limited.",
optimizedForTitle: "Optimized for",
optimizedSmartphones: "Smartphones",
optimizedDesktop: "Desktop (PC/Mac)",
optimizedForText: "For the best player experience, we recommend using VaultQuest on mobile devices. The desktop version is continuously being improved.",
supportedPlatformsTitle: "Supported platforms",
visionTitle: "Our Vision",
visionPoint1Title: "Establishment",
visionPoint1Text: "We aim to establish VaultQuest as a leading tournament platform in Germany – fair, accessible, and open to everyone.",
visionPoint2Title: "More than just playing",
visionPoint2Text: "We continuously improve the platform and work on increasing the value of rewards – with better prizes and more opportunities for players.",
visionPoint3Title: "Real competition",
visionPoint3Text: "Our goal is to create tournaments that feel like real events – exciting, fair, and with real rewards.",
feedbackTitle: "Feedback",
feedbackText: "Have suggestions or ideas for improvement? Feel free to share your feedback via the in-app support form, email, or our social media channels.",
impressum: "Legal notice",
privacy: "Privacy policy",
terms: "Terms",
contact: "Contact",
faqs: "FAQs",

},



login: {
  emailOrUsernamePlaceholder: "Email/Username",
  passwordPlaceholder: "Password",
  forgotPassword: "Forgot password?",
  submit: "Enter the Vault",
  noAccountRegister: "No account yet? Register now",
  apple: {
    button: "Sign in with Apple",
    loading: "Signing in with Apple…",
    or: "or",
    errors: {
      accountCollision: "A VaultQuest account already exists for this email. Sign in with your previous method first.",
      incompleteResponse: "Apple could not complete sign-in. Please try again.",
      invalidNonce: "The secure Apple sign-in could not be verified. Please try again.",
      network: "Network error. Please check your connection.",
      generic: "Apple sign-in failed. Please try again.",
    },
  },
  errors: {
    invalidCredentials: "Email/username or password is incorrect.",
    tooManyRequests: "Too many login attempts. Please wait a moment.",
    network: "Network error. Please check your connection.",
    generic: "Login failed. Please try again."
  }
},

appleOnboarding: {
  eyebrow: "Apple Sign-In",
  title: "Do you already have a VaultQuest account?",
  description: "If you previously used VaultQuest with email and password, you can securely connect your existing account to Apple.",
  linkExisting: "Connect existing account",
  createNew: "Create new account",
  confirmLink: "Connect account securely",
  linking: "Connecting accounts…",
  linkHint: "Your existing profile, coins, and stats remain unchanged. Apple will open once more for confirmation.",
  errors: {
    missingCredentials: "Enter your email/username and password.",
    invalidCredentials: "Email/username or password is incorrect.",
    appleAlreadyLinked: "This account is already connected to another Apple sign-in.",
    generic: "The accounts could not be connected. No profile data was changed.",
  },
},

reset: {
  title: "Reset password",
  description:
    "Enter your email address here. You will receive an email with a link to reset your password.",
  emailPlaceholder: "Email",
  sendButton: "Send reset email",
  backToLogin: "← Back to login",
  messages: {
    neutralSuccess:
      "If an account exists for this email address, we have just sent you a message to reset your password."
  },
  errors: {
    enterEmailFirst: "Please enter your email address first.",
    invalidEmail: "Please enter a valid email address.",
    tooManyRequests: "Too many attempts. Please wait a moment and try again later.",
    generic: "That didn’t work. Please try again."
  }
},

resetPasswordPage: {
  loading: "Loading...",
  title: "Reset password",
  newPasswordPlaceholder: "New password",
  repeatPasswordPlaceholder: "Repeat password",
  submit: "Change password",
  toLogin: "Back to login",
  success: "Your password has been changed successfully.",
  errors: {
    invalidOrExpired: "This link is invalid or has expired.",
    passwordTooShort: "Password must contain at least 6 characters.",
    passwordMismatch: "Passwords do not match.",
    generic: "Password could not be changed.",
  },
},

emailVerification: {
  title: "Verify email address",
  description:
    "We sent you an email to verify your email address. Please open your inbox and click the verification link.",
  buttons: {
    check: "I verified my email",
    checking: "Checking...",
    resend: "Resend email",
    sending: "Sending...",
    resendCooldown: "Resend in {{seconds}}s",
    logout: "Log out",
  },
  messages: {
    verified: "Thank you, your email address has been verified.",
    notVerified: "Your email has not been verified yet.",
    sent: "We sent you a new verification email.",
    tooManyRequests: "Please wait before requesting another email.",
    sendFailed: "The verification email could not be sent.",
    checkFailed: "Verification could not be checked right now.",
  },
},

register: {
  title: "Register",
  accountStepTitle: "Account data",
  gamingStepTitle: "Gaming data",
  usernamePlaceholder: "Username",
  emailPlaceholder: "Email",
  passwordPlaceholder: "Password",
  passwordRepeatPlaceholder: "Confirm password",
  agePlaceholder: "Select age",
  agePlaceholderOptional: "Age optional",
  minimumAgeConfirmation: "I am at least 13 years old.",
  requiredFieldHint: "* Required field",
  next: "Next",
  consoleIdPlaceholder: "Console ID",
  eaIdPlaceholder: "EA ID",
  consoleTypePlaceholder: "Console type",
  consoleOptions: {
    playstation: "PlayStation (NewGen only)",
xbox: "Xbox (NewGen only)",
pc: "PC",
  },
  back: "← Back",
  submit: "Register",
  backToLogin: "← Back to login",
  terms: "Terms",
  privacy: "Privacy Policy",
  acceptPrefix: "I have read the",
  acceptMiddle: "and the",
  acceptSuffix: "and I agree to them.",
  aiConflictConsentTitle: "Consent to AI-assisted conflict analysis (optional)",
  aiConflictConsentTextBeforePrivacy:
    "I agree that, in the event of a conflict, conflict-related data, match chat messages and uploaded evidence may be processed by OpenAI to assist VaultQuest administrators with conflict review. The final decision continues to be made by a VaultQuest administrator. Further information can be found in the",
  aiConflictConsentTextAfterPrivacy: ".",
  aiConflictConsentAdultOnly: "AI-assisted conflict analysis is only available to users aged 18 or older.",
  errors: {
    usernameRequired: "Please enter a username.",
    ageRequired: "Please select your age.",
    ageMinimum: "You must be at least 13 years old.",
    minimumAgeConfirmationRequired: "Please confirm that you are at least 13 years old.",
    acceptLegalRequired: "Please accept the terms and privacy policy.",
    emailRequired: "Please enter your email.",
    passwordRequired: "Please enter a password.",
    passwordTooShort: "Password must be at least 6 characters long.",
    passwordMismatch: "Passwords do not match.",
    consoleIdRequired: "Please enter your console ID.",
    consoleTypeRequired: "Please select a console.",
    eaIdRequired: "Please enter your EA ID.",
    emailOrUsernameTaken: "Email or username is already taken.",
    invalidEmail: "Please enter a valid email address.",
    generic: "Registration failed.",
    usernameInvalid: "Username must be 3–15 characters long and may only contain letters, numbers, and underscores.",
    usernameReserved: "This username is reserved.",
    usernameTooShort: "Username must contain at least 3 characters.",
    usernameTooLong: "Username may contain a maximum of 15 characters.",
    usernameNotAllowed: "This username is not allowed.",
  }
},

authProfileCompletion: {
  title: "Complete profile",
  subtitle: "Choose your VaultQuest username and gaming platform.",
  submit: "Create profile",
  saving: "Creating profile...",
  errors: {
    usernameTaken: "This username is already taken.",
    providerRequired: "This sign-in cannot complete a profile yet.",
    generic: "Your profile could not be created. Please try again.",
  },
},

bottomBar: {
  tournaments: "Tournaments",
  singleGames: "Matches",
  home: "Home",
  vouchers: "Vouchers",
  community: "Community",
},

menu: {
  title: "Menu",
  settings: "Settings",
  support: "Support",
  rateVaultQuest: "Rate VaultQuest",
  rateVaultQuestMissingAppStoreId: "The App Store link is not configured yet.",
  rateVaultQuestOpenFailed: "The review page could not be opened. Please try again later.",
  premium: "Premium Subscription",
  legal: "Legal",
  about: "About VaultQuest",
  faqs: "FAQs",
  logout: "Logout",
  terms: "Terms",
  privacy: "Privacy",
  imprint: "Imprint",
  competitionTerms: "Competition Terms",
  accountSettings: "Account Settings",
  language: {
    german: "German",
    english: "English",
  },
  account: {
    signInMethod: "Sign-in method",
    signInMethods: "Sign-in methods",
    signInWithApple: "Apple",
    signInWithPassword: "Email & password",
    username: "Username",
    email: "Email",
    consoleType: "Console Type",
    consoleId: "Console ID",
    eaId: "EA ID",
    saveGamingIds: "Save game profile",
    saved: "Game profile saved.",
    saveError: "Game profile could not be saved.",
    gamingIdsHint: "You only need your EA ID and console ID when you want to join games or tournaments.",
    ageGroup: {
      title: "Age group",
      placeholder: "Select age group",
      save: "Save age group",
      saved: "Age group saved.",
      savedAndConsentRevoked: "Age group saved. AI consent has been withdrawn.",
      invalid: "Please select a valid age group.",
      saveError: "Age group could not be saved. Please try again.",
    },
    aiConflictConsent: {
      title: "AI-assisted conflict analysis",
      description: "Allows conflict-related data to be processed by OpenAI to support conflict review. The final decision continues to be made by a VaultQuest administrator.",
      statusOn: "Consent granted",
      statusOff: "No consent granted",
      savedOn: "Consent to AI-assisted conflict analysis saved.",
      savedOff: "Consent to AI-assisted conflict analysis withdrawn.",
      adultOnly: "AI-assisted conflict analysis is only available to users aged 18 or older.",
      saveError: "The setting could not be saved. Please try again.",
    },
    emailChange: {
      title: "Change email address",
      modalTitle: "Change email address",
      modalText: "Please confirm your current password first.\n\nWe will then send a VaultQuest confirmation to your new email address. The new address will only be applied after you open that link.",
      currentPassword: "Current password",
      newEmail: "New email address",
      confirmEmail: "Confirm new email address",
      submit: "Change email address",
      verificationSent: "We have sent a VaultQuest confirmation to your new email address. Please open the link in that email to complete the change.",
      errors: {
        noEmail: "No current email address was found for this account.",
        passwordRequired: "Please enter your current password.",
        reauthFailed: "The password is not correct.",
        invalidEmail: "Please enter a valid new email address.",
        emailMismatch: "The new email addresses do not match.",
        sameEmail: "The new email address is already your current email address.",
        alreadyInUse: "This email address is already used by another account.",
        tooManyRequests: "Too many attempts. Please wait a moment and try again later.",
        requestFailed: "The email change could not be started.",
        recentLoginRequired: "Please confirm your password again and try once more.",
      },
    },
    changePassword: "Change Password",
    disableBiometricLogin: "Disable Face ID",
    deleteAccount: "Delete Account",
    dataExport: {
      title: "Export my data",
      modalTitle: "Request data export",
      modalText: "You can request a copy of all personal data currently stored about you.\n\nCreating the export may take a few minutes.",
      description: "You can request a copy of all personal data currently stored about you. Creating the export may take a few minutes.",
      passwordPlaceholder: "Confirm password",
      requestButton: "Request export",
      confirmWithApple: "Confirm with Apple",
      appleConfirmationHint: "Securely confirm the data export with Apple and Face ID.",
      iosRequired: "Secure confirmation for this Apple account currently requires the VaultQuest iOS app.",
      requested: "Export request has been created.",
      status: "Export status",
      noEmail: "No email address was found for this account.",
      passwordRequired: "Please confirm your password first.",
      reauthFailed: "Password confirmation failed.",
      appleReauthFailed: "Secure confirmation with Apple failed. Please try again.",
      recentAuthRequired: "The secure confirmation has expired or is invalid. Please start the data export again.",
      activeExists: "A data export has already been requested for your account. For security reasons, a new export can only be created every 24 hours.",
      activeExistsWithRetry: "A data export has already been requested for your account. For security reasons, a new export can only be created every 24 hours. A new export is expected to be available again from {{time}}.",
      requestError: "Export request could not be created.",
      statuses: {
        idle: "No export yet",
        queued: "Queued",
        processing: "Processing",
        completed: "Completed",
        failed: "Failed",
      },
    },
  },
},

profileCompletion: {
  title: "Complete profile",
  text: "Before you can join games or tournaments, you need to add your EA ID and console ID.",
  path: "You can do this anytime under Settings → Account Settings.",
  button: "Complete now",
  dashboardHint: "Profile is not complete yet.",
  dashboardCta: "Complete now",
  friendTitle: "Friend game profile incomplete",
  friendText: "{{username}} has not added their EA ID and console ID yet, so they cannot be challenged to a friendly match right now.",
  otherPlayerTitle: "Other player game profile incomplete",
  otherPlayerText: "The other player has not added their EA ID and console ID yet. The friendly match cannot be started right now.",
},

creatorTournaments: {
  title: "CREATOR CUP",
  intro: "Plan your own tournament.",
  detailsSection: "TOURNAMENT DETAILS",
  prizesSection: "PRIZES",
  rulesSection: "RULES",
  optionsSection: "OPTIONS",
  requestsTitle: "YOUR CUP REQUESTS",
  requestPlayers: "players",
  tournamentNamePlaceholder: "e.g. VQ Cup by Timon",
  firstPlace: "1ST PLACE",
  secondPlace: "2ND PLACE",
  thirdPlaceOptional: "3RD PLACE (OPTIONAL)",
  optional: "OPTIONAL",
  thirdPlaceShortDescription: "Enable a match for third place.",
  groupStageShortDescription: "Enable a group stage before the knockout stage.",
  readyTitle: "Ready for your cup?",
  readyText: "Your tournament request will be reviewed by the VaultQuest team.",
  closeForm: "Close form",
  newRequest: "+ New Tournament Request",
  editRequestTitle: "Edit Tournament Request",
  newRequestTitle: "New Tournament Request",
  tournamentName: "Tournament name",
  date: "Date",
  startTime: "Start time",
  participants: "Maximum number of participants",
  entryFee: "Entry fee",
  entryFeeText: "{{coins}} coins (set by VaultQuest)",
  prize: "Prize",
  prizePlaceholder: "20 € Amazon voucher",
  prizePool: "Prize pool",
  prizePoolPlaceholder: "e.g. 200 €, PS5 or PS5 + 200 €",
  prizePoolHelp: "Enter the full prize pool exactly as it should appear on the tournament card. Example: “200 €”, “PS5” or “PS5 + 200 €”. The exact placement distribution is still defined through the individual prize fields.",
  prizePoolRequired: "Please enter a prize pool.",
  prizePoolTooLong: "The prize pool may contain at most 50 characters.",
  prizes: "Prizes",
  firstPrize: "1st place prize",
  secondPrize: "2nd place prize",
  thirdPrize: "3rd place prize",
  prizeEnabled: "Active",
  prizeTypePayout: "Payout",
  prizeTypePhysical: "Physical prize",
  prizeAmountPlaceholder: "Amount in €",
  prizePhysicalPlaceholder: "Physical prize",
  prizeDescriptionPlaceholder: "Optional description",
  firstPrizePlaceholder: "1st place: e.g. 20 € Amazon voucher",
  secondPrizePlaceholder: "2nd place: optional",
  thirdPrizePlaceholder: "3rd place: optional",
  thirdPrizeRequiresThirdPlaceHint: "To enter a prize for third place, you need to enable the third-place match.",
  confirmClearThirdPrize: "The third-place prize will be removed. Continue?",
  firstPrizeRequired: "Please enter a prize for 1st place.",
  thirdPrizeNeedsSecond: "A third-place prize is only possible with a second-place prize.",
  thirdPrizeNeedsThirdPlace: "A third-place prize is only possible when the third-place match is enabled.",
  gameMode: "Game mode",
  teamChoice: "Team selection",
  teamChoiceCustom: "Custom",
  teamChoicePlaceholder: "e.g. Bundesliga teams only",
  platform: "Platform",
  rules: "Rules",
  customRules: "Custom rules",
  rulesIntro: "These six core rules are shown for every tournament. Only the intended values can be adjusted.",
  rulesLoading: "Loading standard rules...",
  ruleFallback: "Rule",
  removedRules: "Removed rules",
  removeRule: "Remove",
  restoreRule: "Add back",
  customRulesHint: "Optional: add up to 5 custom rules.",
  customRulePlaceholder: "Custom rule",
  addCustomRule: "+ Add custom rule",
  visibility: "Access",
  standardRules: "Standard VaultQuest rules",
  customRulesOption: "Custom rules",
  public: "Public",
  private: "Private (invite code)",
  thirdPlaceEnabled: "Third-place match",
  thirdPlaceDescription:
    "After the semifinals, an additional match is played between the two semifinal losers.",
  groupStageEnabled: "Group stage",
  groupStageDescription:
    "A group stage is played before the knockout stage. Available for 8 to 128 participants.",
  groupStageUnavailable: "The group stage is only available for 8 to 128 participants.",
  knockoutMultiLegMode: "KNOCKOUT MODE",
  multiLegNone: "Single matches",
  multiLegFromR16: "From round of 16",
  multiLegFromQf: "From quarterfinals",
  multiLegSfOnly: "Semifinals only",
  finalLegs: "FINAL",
  finalLegCount: "{{count}} game(s)",
  reviewNotice:
    "This tournament request will first be reviewed by the VaultQuest team. Only after approval will it become an official community tournament.",
  saveAgain: "Resubmit tournament request",
  saveRequest: "Send tournament request",
  saving: "Saving...",
  cancel: "Cancel",
  loading: "Loading tournament requests...",
  empty: "You have not created any tournament requests yet.",
  loadError: "Tournament requests could not be loaded.",
  saveError: "Tournament request could not be saved.",
  createdMessage: "Tournament request was created and is awaiting approval.",
  updatedMessage: "Tournament request was resubmitted and is awaiting approval.",
  approved: "Approved",
  rejected: "Rejected",
  needsChanges: "Changes required",
  deleted: "Tournament deleted",
  withdrawn: "Withdrawn",
  pending: "Awaiting approval",
  status: "Status",
  approvedAt: "Approved at",
  approvedBy: "Approved by",
  createdAt: "Created",
  changeRequest: "Requested changes",
  rejectionReason: "Rejection reason",
  editRequest: "Edit request",
  editPendingRequest: "Edit request",
  withdrawRequest: "Withdraw request",
  openTournament: "Go to tournament",
  hideSwipeLabel: "Delete",
  hideConfirmTitle: "Remove tournament from overview?",
  hideConfirmText:
    "This tournament will only be removed from your personal overview.\n\nThe tournament itself will not be deleted.",
  hideDelete: "Delete",
  hideCancel: "Cancel",
  hideError: "The entry could not be removed from your overview.",
  withdrawnMessage: "Tournament request was withdrawn.",
  withdrawError: "Tournament request could not be withdrawn.",
  timeSuffix: "",
},

competitionTerms: {
  title: "Competition Terms",
  updated: "Last updated: August 2026",
  intro:
    "These Competition Terms apply to all tournaments and competitions conducted through VaultQuest. By participating in a tournament, participants accept these Competition Terms as well as the tournament rules displayed for the respective tournament.",
  sections: [
    {
      title: "1. Organizer and sponsor",
      blocks: [
        {
          text: "The competitions offered through VaultQuest are organized and sponsored by VaultQuest.",
        },
        {
          text: "Creators may host individual tournaments as Creator Cups and define additional tournament rules. The conduct of the competition and responsibility towards participants for advertised prizes remain with VaultQuest.",
        },
      ],
    },
    {
      title: "2. No affiliation with Apple or Electronic Arts",
      blocks: [
        {
          text: "Apple Inc. is neither a sponsor nor an organizer of the competitions offered through VaultQuest and is not involved in their conduct in any way.",
        },
        {
          text: "The EA SPORTS FC competitions offered through VaultQuest are not affiliated with Electronic Arts Inc. or its licensors and are neither sponsored nor supported by them.",
        },
        {
          text: "Terms such as “EA SPORTS FC” or “Ultimate Team” are used solely to describe the game or game mode being used.",
        },
      ],
    },
    {
      title: "3. Participation",
      blocks: [
        {
          text: "Participation requires a valid VaultQuest account. Participants are responsible for ensuring that the game-related information stored in their account, in particular EA ID and console ID, is correct.",
        },
        {
          text: "To play a match, participants must have the game required for the respective tournament, a supported platform, and the necessary technical requirements.",
        },
        {
          text: "The entry fee for a tournament is displayed before joining and may be charged in VaultQuest Coins.",
        },
      ],
    },
    {
      title: "4. Tournament rules",
      blocks: [
        {
          text: "The applicable game and tournament rules for each tournament are displayed in VaultQuest.",
        },
        {
          text: "These may include, in particular, game mode, match duration, platform, and further requirements.",
        },
        {
          text: "For Creator Cups, additional rules defined by the Creator may apply. Creator rules must not conflict with these Competition Terms. In the event of a conflict, these Competition Terms take precedence.",
        },
      ],
    },
    {
      title: "5. Results and reporting",
      blocks: [
        {
          text: "Participants are required to report match results completely and truthfully through the designated reporting system.",
        },
        {
          text: "Knowingly false result reports, manipulated evidence, or other attempts at deception are prohibited.",
        },
        {
          text: "The deadlines displayed within the match apply to reporting results and completing required actions.",
        },
      ],
    },
    {
      title: "6. Group stage and Rulings",
      blocks: [
        {
          text: "In tournaments with a group stage, rankings are determined based on the results achieved.",
        },
        {
          text: "When players are tied on points, the following criteria apply in order:",
        },
        {
          type: "ordered",
          items: ["Head-to-head result", "Goal difference", "Goals scored", "Fewer goals conceded", "Decision matches"],
        },
        {
          text: "If a tie relevant to the further conduct of the tournament cannot be resolved in this way, the affected players play additional Ruling Games until the required rankings are clearly determined.",
        },
        {
          text: "Ruling Games are played in separate Ruling Rounds and evaluated according to the same sporting criteria.",
        },
        {
          text: "Random drawing is not used to determine qualification or ranking.",
        },
      ],
    },
    {
      title: "7. Disputes and evidence",
      blocks: [
        {
          text: "In the event of conflicting result reports or other inconsistencies, a dispute may be opened.",
        },
        {
          text: "VaultQuest may use the reports submitted by participants, evidence, and other information available for the match to clarify the matter.",
        },
        {
          text: "Participants are required to submit requested evidence within the respectively specified deadline.",
        },
        {
          text: "The decision made after completion of the dispute review is authoritative for the further tournament evaluation.",
        },
      ],
    },
    {
      title: "8. No-show and deadlines",
      blocks: [
        {
          text: "Participants are responsible for playing their matches within the specified time and submitting the required reports on time.",
        },
        {
          text: "If a participant does not appear or does not fulfill the requirements provided within the match in time, the match may be awarded in favor of the opponent in accordance with the No-Show and reporting rules provided in VaultQuest.",
        },
      ],
    },
    {
      title: "9. Technical requirements of participants",
      blocks: [
        {
          text: "Each participant is responsible for having a functioning internet connection, the required game, a suitable gaming platform, and any other technical requirements necessary to play the match.",
        },
        {
          text: "Individual technical problems of a participant generally do not give rise to a claim for replaying a match or changing a determined result.",
        },
      ],
    },
    {
      title: "10. Manipulation and unsporting conduct",
      blocks: [
        {
          text: "The following are prohibited in particular:",
        },
        {
          type: "unordered",
          items: [
            "cheating or the use of unauthorized aids,",
            "agreements to manipulate match results or tournament rankings,",
            "knowingly false result reports,",
            "manipulated or falsified evidence,",
            "abusive use of multiple accounts,",
            "circumvention of bans or participation restrictions, and",
            "other intentional manipulation of the competition.",
          ],
        },
        {
          text: "In the event of corresponding violations, VaultQuest may award matches against a participant, disqualify participants, or take further measures provided under the VaultQuest rules.",
        },
      ],
    },
    {
      title: "11. Qualification and determination of winners",
      blocks: [
        {
          text: "Qualification for further tournament rounds and final rankings are determined based on the results established in accordance with these Competition Terms and the respective tournament rules.",
        },
        {
          text: "In the knockout stage, the losing participant of a match is eliminated unless the respective tournament mode provides otherwise.",
        },
        {
          text: "The winner of a tournament is the participant who is determined as the winner after completion of all required tournament rounds.",
        },
      ],
    },
    {
      title: "12. Prizes",
      blocks: [
        {
          text: "The type and value of any possible prize are displayed in VaultQuest before the start of the respective tournament.",
        },
        {
          text: "VaultQuest is responsible towards participants for providing or paying out the advertised prize.",
        },
        {
          text: "A claim exists exclusively to the prize specified for the respective tournament. Payment or provision takes place only after the tournament has been fully completed and the result has been finally determined.",
        },
        {
          text: "Creator Cups may be hosted by Creators. However, the handling and provision of the prize advertised to participants is carried out through VaultQuest.",
        },
      ],
    },
    {
      title: "13. Relationship to the respective tournament rules",
      blocks: [
        {
          text: "These Competition Terms form the binding basis for all competitions conducted through VaultQuest.",
        },
        {
          text: "The standard rules displayed for a specific tournament and any additional Creator rules supplement these terms.",
        },
        {
          text: "They cannot override or conflict with these Competition Terms.",
        },
      ],
    },
  ],
},

aiConflictConsentPrompt: {
  title: "AI-ASSISTED CONFLICT ANALYSIS",
  text1:
    "VaultQuest may use OpenAI to support our administrators when reviewing conflict cases. Conflict-related data, match chat messages and uploaded evidence may be processed by OpenAI for this purpose.",
  text2:
    "AI does not make the final decision. The decision on the conflict case continues to be made by a VaultQuest administrator.",
  text3BeforePrivacy: "Further information can be found in our",
  text3AfterPrivacy: ".",
  agree: "AGREE",
  notNow: "NOT NOW",
},


impressum: {
  title: "Legal Notice",
  section5TMG: "Information according to Section 5 DDG",
  contentResponsible: "Responsible for content according to Section 18 para. 2 MStV",
projectStatus: "Project status notice",
projectStatusText1: "VaultQuest is currently in a public beta and ongoing development phase.",
projectStatusText2: "The platform is continuously developed, improved, and adapted to new technical and organizational requirements. Features may be added, changed, or temporarily restricted.",
projectStatusText3: "VaultQuest currently does not sell its own products through the platform.",
liabilityContentTitle: "Liability for content",
liabilityContentText1: "As a service provider, I am responsible for my own content on these pages in accordance with general legal provisions.",
liabilityContentText2: "As a service provider, I am not obliged to permanently monitor transmitted or stored third-party information or to actively investigate circumstances indicating illegal activity.",
liabilityLinksTitle: "Liability for links",
liabilityLinksText: "This website may contain links to external third-party websites over whose content I have no control. Therefore, no liability is assumed for this external content.",
copyrightTitle: "Copyright",
copyrightText1: "The content and works created by the site operator on this website and within the VaultQuest web app are subject to German copyright law. This applies in particular to source code, designs, graphics, logos, and other components of the VaultQuest web app.",
copyrightText2: "Any reproduction, editing, or distribution outside the limits of copyright law requires prior written consent.",
},


privacy: {
  title: "Privacy Policy",
  section1Title: "1. Data protection at a glance",
  section1Text1: "The protection of your personal data is important to us. Below, we inform you which personal data is processed when using VaultQuest, for what purposes this is done, and which rights you have under the applicable data protection regulations.",
  section1Text2: "Personal data means any information relating to an identified or identifiable natural person. This includes in particular your email address, your username, your IP address, and other information you provide when registering for or using VaultQuest.",
  section1Text3: "Your personal data is processed to provide you with the use of VaultQuest as a platform for online tournaments, community tournaments, single and friend matches, and the related functions such as matchmaking, result reporting, conflict handling, communication, community features, support, and security-related system functions.",
section2Title: "2. Data Controller",
section2Text1: "The controller responsible for the processing of personal data within the meaning of the General Data Protection Regulation (GDPR) is:",
controllerName: "Timon Eßer",
controllerStreet: "Lessingstraße 14",
controllerCity: "77966 Kappel-Grafenhausen",
controllerCountry: "Germany",
controllerEmailLabel: "E-mail",
controllerEmail: "info@vaultquest.de",

section3Title: "3. Scope",
section3Text1: "This Privacy Policy applies to the use of the VaultQuest website, web application and mobile applications, as well as all related digital services and communication channels.",
section3Text2: "It applies in particular to:",
section3List1: "visiting the website,",
section3List2: "registering for and using a user account,",
section3List3: "participating in tournaments, community tournaments, single matches and friendly matches,",
section3List4: "using matchmaking, reporting, dispute resolution, chat and community features,",
section3List5: "receiving push notifications, system messages and emails,",
section3List6: "contacting us and using our support services.",

section4Title: "4. What personal data we collect",

section41Title: "4.1 Data you provide to us yourself",
section41Text1: "When you use VaultQuest, we process personal data that you actively provide to us. This includes in particular:",
section41List1: "Email address",
section41List2: "Username",
section41List3: "optional age information",
section41List4: "console type",
section41List5: "EA ID and console ID (after voluntary profile completion)",
section41List6: "login data in connection with authentication (via Firebase Authentication)",
section41List7: "contents of support requests or other messages to us",
section41List8: "information in connection with tournaments, community tournaments, single matches and friendly matches",
section41List9: "reports of match results and dispute cases",
section41List10: "uploaded evidence (e.g. screenshots or images)",
section41List11: "chat messages in connection with matches or support",

section42Title: "4.2 Data processed automatically during use",
section42Text1: "When visiting the website, using the web application or the mobile applications, technical data may be processed automatically. This includes in particular:",
section42List1: "IP address",
section42List2: "Date and time of access",
section42List3: "Browser type and browser version",
section42List4: "Operating system used",
section42List5: "Device type",
section42List6: "Referrer URL",
section42List7: "Technical error, log, and audit log data",
section42List8: "push tokens and device-related information for push notifications (if enabled)",
section42List9: "technical information regarding the stability, security and functionality of the platform",
section42Text2: "This data is processed to ensure the secure operation, stability and technical provision of VaultQuest.",

section43Title: "4.3 Data from using the platform",
section43Text1: "As part of using VaultQuest, we also process personal data that is generated when the platform is used. This includes in particular:",
section43List1: "participation in tournaments, community tournaments, single matches and friendly matches",
section43List2: "matchmaking and match assignments",
section43List3: "results, rankings, statistics and leaderboard data",
section43List4: "reports of match results",
section43List5: "dispute cases and their handling",
section43List6: "uploaded evidence and evidence files",
section43List7: "friendships, friend requests and blocks",
section43List8: "community and creator features",
section43List9: "support, admin help and user reports",
section43List10: "system messages, push notifications and emails",
section43List11: "prize, voucher and reward information",

section5Title: "5. Purposes of data processing",
section5Text1: "We process personal data for the following purposes:",
section5List1: "providing, operating and further developing the website, web application and mobile applications",
section5List2: "setting up, managing and securing user accounts",
section5List3: "conducting tournaments, community tournaments, single matches and friendly matches",
section5List4: "matchmaking and displaying opponents, match information, statistics and leaderboards",
section5List5: "result reporting and handling dispute cases, including the review of uploaded evidence",
section5List6: "providing community features such as friendships, blocks, chats and creator tournaments",
section5List7: "sending system messages, push notifications and emails, in particular in connection with registration, password resets, support, tournaments, prizes and security-related events",
section5List8: "processing support requests, admin help requests and user reports",
section5List9: "administering the platform as well as moderation, abuse prevention and enforcement of the platform rules",
section5List10: "ensuring the technical functionality, stability and security of the platform, including error analysis and auditing of administrative processes",
section5List11: "detecting, preventing and investigating attempted fraud, manipulation, rule violations and other abuse",
section5List12: "fulfilling legal obligations",

section6Title: "6. Legal bases for processing",
section6Text1: "Your personal data is processed on the basis of the General Data Protection Regulation (GDPR), in particular on the basis of the following legal grounds:",
section6Sub1Title: "Art. 6 para. 1 lit. b GDPR (performance of a contract)",
section6Sub1Text: "To the extent that processing is necessary for the performance of the user relationship. This includes in particular the registration and management of the user account, participation in tournaments, community tournaments, single matches and friendly matches, matchmaking, result reporting, dispute handling, community features, and the provision of notifications and support.",
section6Sub2Title: "Art. 6 para. 1 lit. c GDPR (legal obligation)",
section6Sub2Text: "To the extent that we are legally obliged to process or retain personal data.",
section6Sub3Title: "Art. 6 para. 1 lit. f GDPR (legitimate interests)",
section6Sub3Text: "To the extent that processing is necessary to safeguard our legitimate interests. These include in particular ensuring the security and stability of the platform, preventing and investigating abuse, fraud and rule violations, technical error analysis, moderation of the platform, traceability of administrative processes, and further development of our services.",
section6Sub4Title: "Art. 6 para. 1 lit. a GDPR (consent)",
section6Sub4Text: "To the extent that you have given us your consent, for example for optional features or notifications whose processing is based on consent. Consent that has been given may be withdrawn at any time with effect for the future.",

section7Title: "7. Registration and user account",
section7Text1: "The use of essential VaultQuest functions requires the creation of a user account. As part of registration and the management of your user account, we process in particular the following personal data:",
section7List1: "Email address",
section7List2: "Username",
section7List3: "authentication data (via Firebase Authentication, including Sign in with Apple where you use this sign-in method)",
section7List4: "Account status",
section7List5: "optional profile information (e.g. age information, console type, EA ID or console ID)",
section7List6: "game, match, tournament, community and statistics information linked to the user account",
section7Text2: "The processing of this data is necessary to provide you with a personal user account, verify your identity when logging in, manage your account and enable the contractual use of the platform. When using Sign in with Apple, Apple may provide a Private Relay email address depending on your selection; VaultQuest processes only the data required for sign-in and account linking.",

section8Title: "8. Tournaments, single matches, statistics and reporting",
section8Text1: "If you participate in tournaments, community tournaments, single matches or friendly matches, we process the personal data required for this purpose. Community tournaments also include competitions organized by users or creators. This includes in particular:",
section8List1: "Username",
section8List2: "Participation in competitions",
section8List3: "Matchmaking and opponent assignments",
section8List4: "Game, match and tournament status",
section8List5: "Reported match results",
section8List6: "Rankings",
section8List7: "Statistics (e.g. wins, losses, tournament participations, tournament wins, coins won and other performance-related data within the platform)",
section8List8: "Leaderboard information",
section8Text2: "This data is required in order to carry out game and competition operations technically and organizationally.",
section8Text3: "Usernames, rankings, results, leaderboards and statistical values may be displayed to other users within the platform where this is necessary for the operation of the platform.",

section9Title: "9. Dispute cases and evidence uploads",
section9Text1: "If a match result is challenged or a dispute case arises, additional personal data may be processed as part of dispute handling. This includes in particular:",
section9List1: "Information from the dispute case",
section9List2: "Reported match results",
section9List3: "Uploaded screenshots or images as evidence",
section9List4: "Times of reports and uploads",
section9List5: "Assignment of evidence to the users involved",
section9List6: "Processing and decision information in connection with the dispute procedure",
section9Text2: "This data is used exclusively to review, process and decide the respective dispute case and to ensure fair competition operations.",
section9Text3: "Please upload only evidence that is required for handling the respective dispute case.",
section9Text4: "Evidence may be processed and stored on cloud-based storage infrastructure. Dispute-related data may only be viewed and processed by authorized administrators to the extent necessary for handling the respective dispute case.",
section91Title: "9.1 AI-assisted dispute analysis",
section91Text1: "To support the manual handling of dispute cases, VaultQuest may use automated or AI-assisted analysis systems where the involved users have given their explicit consent. The currently active external AI service provider for this purpose is OpenAI Ireland Limited (“OpenAI”). As part of this analysis, the following data in particular may be transmitted to OpenAI and processed there:",
section91List1: "VaultQuest usernames of the users involved",
section91List2: "Match and tournament information, including match, tournament and dispute IDs as well as technical mapping information",
section91List3: "Reported results, dispute data, report reasons and timestamps",
section91List4: "Console type",
section91List5: "Dispute-related match chat messages",
section91List6: "Uploaded evidence images or screenshots",
section91List7: "Technical evidence metadata, where required for assigning and reviewing the specific dispute case",
section91Text2: "In particular, email address, Firebase UID, specific EA ID, specific console ID, IP address, Coins, voucher information and trust level are not intentionally transmitted for the AI analysis.",
section91Text3: "However, users may themselves make personal data visible in chats, screenshots or other evidence; such content may then become part of the AI-assisted analysis.",
section91Text4: "Evidence images may be loaded server-side from Firebase Storage and transmitted to OpenAI for analysis to the extent necessary for reviewing the specific dispute case.",
section91Text5: "The results of the AI analysis generated within VaultQuest are assigned to the respective dispute case, made accessible only to authorized administrators and deleted in accordance with the storage and deletion periods applicable to dispute cases.",
section91Text6: "The AI analysis serves exclusively as support and a recommendation for authorized VaultQuest administrators. The final decision on a dispute case and any resulting measures is made by authorized VaultQuest administrators.",
section91TextConsent: "VaultQuest remains available from age 13. OpenAI-assisted conflict analysis is offered only to adult users. Minors cannot consent to OpenAI-assisted conflict analysis; their conflict cases are reviewed manually by authorized administrators without external AI analysis. Consent to OpenAI-assisted conflict analysis is voluntary, may be withdrawn at any time with effect for the future and is not required for normal use of VaultQuest. If valid consent has not been provided by all involved users for a conflict case, no external AI analysis of that conflict will take place; the conflict case will then be reviewed manually by authorized administrators.",
section91Text7: "The legal basis for the transmission and processing of personal data as part of the optional OpenAI-assisted dispute analysis is the explicit consent given by the affected users pursuant to Art. 6 para. 1 lit. a GDPR. Consent is voluntary and may be withdrawn at any time with effect for the future. Manual dispute handling, which is independent of this, is carried out on the basis of the respectively applicable legal grounds, in particular Art. 6 para. 1 lit. b and lit. f GDPR.",
section91Text8: "According to current OpenAI information, API inputs and outputs are generally not used to train or improve models unless data sharing has been enabled. API data may generally be retained by OpenAI for up to 30 days for service provision and abuse monitoring.",
section91Text9: "For users in the European Economic Area, OpenAI Ireland Limited is the relevant provider. Processing or transfer outside the EU or EEA cannot be excluded; where required, it is carried out on the basis of appropriate safeguards such as adequacy decisions or standard contractual clauses.",

section10Title: "10. Prizes, vouchers and notifications",
section10Text1: "As part of tournaments, community tournaments or other campaigns, prizes, rewards, vouchers or prize money may be awarded.",
section10Text2: "If you receive a prize, we process the personal data required for this purpose, in particular:",
section10List1: "Username",
section10List2: "Email address",
section10List3: "Tournament- or campaign-related prize information",
section10List4: "Voucher information",
section10List5: "Shipping and notification data",
section10Text3: "Voucher codes, prize information and other tournament-related notifications are transmitted via the VaultQuest notification system and, where necessary, additionally to the email address stored with us.",

section11Title: "11. Communication and support",
section11Text1: "If you contact us or use support features within VaultQuest, we process the personal data that you provide to us as part of your request or message. This includes in particular:",
section11List1: "Email address",
section11List2: "Name or username (if provided)",
section11List3: "Content of your message",
section11List4: "Technical information regarding the error description",
section11List5: "Support, admin help or user reports",
section11Text2: "Processing is carried out exclusively to handle your request, communicate with you and improve the security and functionality of the platform.",

section12Title: "12. Hosting, technical infrastructure and services used",
section12Text1: "To provide and operate VaultQuest, we use technical service providers and cloud infrastructure.",
section12Text2: "This includes in particular:",
section12List1: "Google Firebase (Google Ireland Limited) for authentication, database, Cloud Storage, Cloud Functions and Firebase Cloud Messaging, as well as Apple Push Notification service (APNs) for push notifications in the iOS app",
section12List2: "Google Cloud (Google Ireland Limited) for hosting and technical infrastructure",
section12List3: "Resend for sending certain emails (e.g. registration, password reset, support or prize notifications)",
section12List4: "OpenAI (OpenAI Ireland Limited) for AI-assisted analysis of dispute cases and evidence to support administrative dispute handling",
section12Text3: "These services are used in particular for the following purposes:",
section12PurposeList1: "Hosting",
section12PurposeList2: "Authentication",
section12PurposeList3: "Database operation",
section12PurposeList4: "Cloud storage",
section12PurposeList5: "Server-side functions",
section12PurposeList6: "optional push notifications, which can be managed or withdrawn through the device settings",
section12PurposeList7: "Email delivery",
section12Text4: "Where external service providers process personal data on our behalf, this is done exclusively within the framework of processing under Art. 28 GDPR or on the basis of another legally permissible data protection ground.",

section13Title: "13. Recipients of data",
section13Text1: "Your personal data is disclosed only to the extent legally permissible and necessary for operating VaultQuest. Recipients may include in particular:",
section13List1: "Hosting and cloud service providers",
section13List2: "Authentication and backend service providers",
section13List3: "Storage and database service providers",
section13List4: "Email and notification service providers",
section13List5: "Other processors supporting us in the technical operation of the platform",
section13List6: "AI service providers, where used for supporting analysis of dispute cases and evidence",
section13Text2: "Personal data is not disclosed to uninvolved third parties for advertising purposes.",

section14Title: "14. Transfers to third countries",
section14Text1: "When using individual technical services, personal data may also be processed outside the European Union (EU) or the European Economic Area (EEA).",
section14Text2: "This applies in particular to cloud-based services from Google, the email service provider Resend and OpenAI in connection with AI-assisted dispute analysis.",
section14Text3: "Where personal data is transferred to third countries in this context, this is done exclusively in compliance with the data protection requirements of the GDPR, in particular on the basis of an adequacy decision by the European Commission, standard contractual clauses (Standard Contractual Clauses – SCCs) or another legally permissible basis.",

section15Title: "15. Cookies, local storage and similar technologies",
section15Text1: "VaultQuest uses technically necessary cookies and comparable storage technologies such as local storage or session storage where this is required for the secure and proper operation of the website, web application and mobile applications. Where biometric authentication functions such as Face ID or Touch ID are used on supported iOS devices, biometric verification is performed through the operating system's security functions. VaultQuest does not receive or store biometric characteristics or biometric templates.",
section15Text2: "These technologies are used in particular to,",
section15List1: "technically provide sessions,",
section15List2: "manage login states,",
section15List3: "implement security-related functions,",
section15List4: "store user settings,",
section15List5: "ensure the display and functionality of the platform.",
section15Text3: "Where only technically necessary cookies or comparable technologies are used, their use is based on Section 25 para. 2 TDDDG as well as Art. 6 para. 1 lit. b and lit. f GDPR.",
section15Text4: "If analytics, marketing or tracking technologies are used in the future, their use will take place only after appropriate information has been provided and – where legally required – after your prior consent.",

section16Title: "16. Analytics, error reports and security",
section16Text1: "To ensure secure, stable and reliable operation of VaultQuest, we process technical error, protocol, audit log and security data. This processing serves in particular:",
section16List1: "error analysis and error correction,",
section16List2: "ensuring the stability and availability of the platform,",
section16List3: "detecting technical problems,",
section16List4: "detecting and preventing abuse, attempted fraud and rule violations,",
section16List5: "ensuring the traceability of administrative processes,",
section16List6: "protecting the platform and its users.",
section16Text2: "Partially automated technical checks may be used for this purpose to ensure system security and the integrity of competitive operations.",
section16Text3: "This data is not processed for advertising or marketing purposes.",

section17Title: "17. Storage period",
section17Text1: "We store personal data only for as long as this is necessary for the respective processing purposes or as long as legal retention obligations exist.",
section17Text2: "In general, the following storage periods apply:",
section17List1: "Account data is generally stored for as long as the user account exists.",
section17List2: "Support and communication data is stored for as long as this is necessary for processing, documentation or fulfilling legal obligations.",
section17List3: "Technical log, audit and security data is stored only for as long as this is necessary to ensure the security, stability and traceability of platform operations.",
section17List4: "Dispute-related data and uploaded evidence is stored only for as long as this is necessary to handle the dispute case, prevent abuse or safeguard legitimate interests.",
section17List5: "Internal AI-assisted dispute analyses by VaultQuest generally follow the retention and deletion logic provided for dispute cases.",
section17Text3: "Additional automatic deletion periods apply to certain categories of data. According to the current technical implementation, this applies in particular to dispute cases and related evidence, support requests, tournaments, single matches, challenges and assigned vouchers, which are regularly deleted or cleaned up after the respective purpose and evidence periods have expired. Certain security- and administration-relevant records, such as user reports, trust movings and admin audit logs, may be stored for longer for abuse prevention and traceability. Push tokens are stored only for as long as they are required for push notifications and are automatically cleaned up after inactivity. Download links for data exports are time-limited.",
section17Text4: "As soon as the respective purpose no longer applies and no legal retention obligations or legitimate interests prevent deletion, personal data is deleted or anonymized.",
section17Text5: "You may request deletion of your user account at any time. Where no legal retention obligations or overriding legitimate interests prevent deletion, the personal data associated with your user account will be deleted or anonymized.",
section17Text6: "Separately, API inputs and outputs transmitted to OpenAI may, according to current provider information, generally be retained for up to 30 days for service provision and abuse monitoring.",

section18Title: "18. Your rights",
section18Text1: "Within the framework of legal provisions, you have in particular the following rights:",
section18List1: "Right of access pursuant to Art. 15 GDPR",
section18List2: "Right to rectification pursuant to Art. 16 GDPR",
section18List3: "Right to erasure pursuant to Art. 17 GDPR",
section18List4: "Right to restriction of processing pursuant to Art. 18 GDPR",
section18List5: "Right to data portability pursuant to Art. 20 GDPR",
section18List6: "Right to object pursuant to Art. 21 GDPR",
section18List7: "Right to withdraw consent that has been granted with effect for the future",
section18List8: "Right to lodge a complaint with a data protection supervisory authority pursuant to Art. 77 GDPR",
section18Text2: "To exercise your rights or if you have any questions about data protection, you can contact us at any time at",

section19Title: "19. Minor users",
section19Text1: "VaultQuest may be used from a minimum age of 13. An age group is provided during registration. In this regard, we observe the applicable legal requirements of data protection and youth protection law.",
section19Text2: "The optional OpenAI-assisted dispute analysis is available only to adult users. Minor users cannot provide consent for this. Dispute cases involving minor users are reviewed manually by authorized VaultQuest administrators without external AI analysis. In all other respects, personal data of minor users is processed only within the framework of applicable data protection and youth protection laws.",

section20Title: "20. Data security",
section20Text1: "We take appropriate technical and organizational measures to protect your personal data against loss, unauthorized access, manipulation, disclosure or other misuse.",
section20Text2: "These include in particular:",
section20List1: "encrypted data transmissions,",
section20List2: "access restrictions,",
section20List3: "protection of server, database and account infrastructure,",
section20List4: "regular technical security reviews,",
section20List5: "measures to ensure the availability and integrity of our systems.",
section20Text3: "Despite all security measures taken, complete security of data transmission on the internet cannot be guaranteed.",

section21Title: "21. Changes to this privacy policy",
section21Text1: "We reserve the right to adapt this Privacy Policy if this becomes necessary due to legal, technical or organizational changes.",
section21Text2: "The current version of this Privacy Policy is available at any time on the website and within VaultQuest.",
section21Text3: "If material changes are made, we will inform you about them in an appropriate manner where this is legally required.",
},


agb: {
  title: "General Terms and Conditions (GTC)",
  section1Title: "Section 1 – Scope",
  section1Text1: "These General Terms and Conditions (GTC) apply to the use of the digital platform VaultQuest via web browsers and other supported end devices.",
  section1Text2: "VaultQuest provides users in particular with the following functions:",
  section1List1: "Registration and management of a user account",
  section1List2: "Participation in gaming tournaments and community tournaments",
  section1List3: "Participation in single matches",
  section1List4: "Match assignment",
  section1List5: "Result reporting",
  section1List6: "Dispute cases with evidence upload",
  section1List7: "Notifications about tournament status and prizes",
  section1Text3: "Use of the platform is currently completely free of charge.",

section2Title: "Section 2 – Provider",
providerName: "Timon Eßer",
providerStreet: "Lessingstraße 14",
providerCity: "77966 Kappel-Grafenhausen",
providerCountry: "Germany",
providerEmailLabel: "Email",
providerEmail: "info@vaultquest.de",

section3Title: "Section 3 - Subject matter of the contract and platform character",
section3Text1: "The subject matter of the contract is the provision of a technical platform through which users can participate in gaming tournaments, community tournaments, and single matches. For community tournaments, creators may propose or configure tournament details such as name, time, number of participants, visibility, prizes, and supplementary rules; publication takes place only after review and approval by VaultQuest.",
section3Text2: "VaultQuest itself does not provide any video games. The actual games are carried out exclusively via external gaming platforms or consoles. Participation requires that the user has the necessary games, access credentials, and technical requirements.",
section3Text3: "There is no entitlement to specific tournaments, functions, prizes, or the permanent availability of individual content.",
section3Text4: "VaultQuest is partially in an ongoing testing and development phase. Functions may therefore be temporarily restricted, modified, or removed. For community tournaments, VaultQuest operates the technical platform functions, in particular publication after approval, joining, tournament logic, reporting, and dispute handling; creators remain responsible for their own organizational statements and commitments outside the platform.",

section4Title: "Section 4 - Registration and user account",
section4Text1: "Use of the platform requires a personal, person-specific user account. The account may only be used by the registered user.",
section4Text2: "The following applies:",
section4List1: "Registration only for natural persons",
section4List2: "Only one user account per person",
section4List3: "All information must be complete and truthful",
section4List4: "Access credentials must be kept confidential; sharing or joint use of the account is not permitted",
section4Text3: "Multiple registrations, fake accounts, or attempts to circumvent existing bans are not permitted.",
section4Text4: "VaultQuest reserves the right to reject registrations where there is a legitimate interest. Usernames must not violate legal provisions or platform rules; VaultQuest may reject such usernames or require them to be changed.",
section4Text5: "Minor users may only use VaultQuest within the scope permitted by applicable law.",

section5Title: "Section 5 - User obligations",
section5Text1: "Users undertake to:",
section5List1: "Use the platform fairly",
section5List2: "Provide truthful information",
section5List3: "Report within the specified deadlines",
section5List4: "Treat other players respectfully",
section5List5: "Comply with the rules of the game being used",
section5Text2: "In particular, the following are prohibited:",
section5List6: "Cheats",
section5List7: "Exploits, intentional abuse of technical errors, or circumvention of technical protection mechanisms",
section5List8: "Intentional disconnects",
section5List9: "Rage quits",
section5List10: "Result manipulation or abuse of the reporting or dispute system",
section5List11: "Multiple accounts",
section5List12: "Uploading false evidence or other attempts to manipulate platform operations",
section5Text3: "Violations may lead to sanctions up to and including permanent exclusion.",

section6Title: "Section 6 - Tournaments and single matches",
section6Text1: "VaultQuest organizes and manages official tournaments as well as single matches. For community tournaments, creators may propose tournament details such as tournament name, time, number of participants, visibility, prize information, and additional rules. Publication takes place only after review and approval by VaultQuest. After approval, VaultQuest provides the technical execution via the platform, in particular tournament display, joining, match assignment, bracket and tournament logic, reporting, status updates, and dispute handling. VaultQuest is not a party to the actual gameplay between users.",
section6Text2: "There is no entitlement to:",
section6List1: "successful match assignment",
section6List2: "continuation of a game",
section6List3: "a specific tournament size",
section6List4: "a specific reward",
section6Text3: "exists. Tournaments may be cancelled, postponed, or adjusted in particular due to technical problems, organizational reasons, or an insufficient number of participants.",
section6Text4: "Usernames, rankings, results, statistics, trust levels, and leaderboards may be processed and displayed within the platform where necessary for platform and tournament operations.",

section7Title: "Section 7 - Result reporting",
section7Text1: "Match results must be reported within the deadlines specified on the platform. VaultQuest provides various reporting options for this purpose, including:",
section7List1: "regular result",
section7List2: "time extension",
section7List3: "opponent did not appear",
section7List4: "rage quit",
section7List5: "connection problems",
section7Text2: "All information must be complete and truthful.",
section7Text3: "False reports or abusive use of the system are considered a serious violation of these GTC. Reports must be submitted within the specified deadlines; if deadlines expire, automatic decisions or dispute procedures may be triggered. The reporting processes provided by VaultQuest are binding.",

section8Title: "Section 8 - Dispute cases and evidence",
section8Text1: "If a reported result is rejected by one player, a dispute case arises.",
section8Text2: "In dispute cases, both parties may upload evidence, in particular:",
section8List1: "Screenshots",
section8List2: "Images of the final result",
section8List3: "Other evidence",
section8Text3: "For proper review, the following should in particular be visible on the evidence:",
section8List4: "Score",
section8List5: "Team name",
section8List6: "Console ID / opponent identifier",
section8Text4: "VaultQuest decides on the basis of the available information at its reasonable discretion. If no evidence or insufficient evidence is submitted within the specified deadlines, the decision may be made on the basis of the available information.",
section8Text5: "The decision regarding:",
section8List7: "Progression",
section8List8: "Elimination",
section8List9: "Replay",
section8List10: "Match valuation",
section8List11: "Sanctions",
section8Text6: "is decisive for the further conduct and evaluation of the respective competition. Dispute decisions may be made by authorized VaultQuest administrators.",
section8Text7: "VaultQuest may use automated or AI-assisted analysis systems to support dispute handling where the required data protection requirements and consents of the involved users are in place and the involved users meet the applicable requirements. If the required consent has not been fully provided, dispute handling will take place manually. These systems may evaluate dispute-related information, match and tournament information, chat content related to the dispute and uploaded evidence, and provide authorized administrators with an assessment or recommendation. The AI-assisted analysis serves exclusively to support dispute handling. The final decision on a dispute case and any resulting measures is made by authorized VaultQuest administrators. Further information on the processing of personal data in connection with AI-assisted dispute analysis is provided in the privacy policy.",

section9Title: "Section 9 - Fair play and sanctions",
section9Text1: "The platform is based on fairness and competition.",
section9Text2: "Violations of fair play, in particular:",
section9List1: "False statements",
section9List2: "Intentional deception",
section9List3: "Harassment of other users",
section9List4: "Manipulation of matches or platform operations",
section9List5: "Repeated unsportsmanlike conduct",
section9Text3: "may lead to the following measures:",
section9List6: "Correction of the result",
section9List7: "Tournament exclusion",
section9List8: "Temporary suspension",
section9List9: "Permanent account suspension",
section9List10: "Exclusion from future rewards",
section9Text4: "Moderation and sanction decisions may be made on the basis of the VaultQuest rules applicable at the time of the decision and the information available at that time. After expiry of the retention periods applicable to the underlying data and evidence, a renewed full review of the original facts may no longer be possible.",

section10Title: "Section 10 - Prizes, vouchers, and coins",
section10Text1: "As part of tournaments, prizes or rewards, in particular vouchers or prize money, may be awarded.",
section10Text2: "Provision takes place via:",
section10List1: "the VaultQuest notification system",
section10List2: "the stored email address",
section10Text3: "There is no legal entitlement to:",
section10List3: "prizes",
section10List4: "a specific type of voucher",
section10List5: "a specific voucher value",
section10Text4: "The type and form of a prize are determined by the respective tournament announcement. If prize money is expressly announced, it will be paid out in accordance with the tournament announcement. Cash payment of vouchers or other physical or digital prizes will only take place if this is expressly stated. Coins are exclusively a virtual platform currency, do not constitute legal tender, cannot be paid out or exchanged for real money, and do not establish any ownership or payout claim. In the event of abuse or rule violations, VaultQuest may withdraw coins in whole or in part.",
section10Text5: "VaultQuest is not liable for restrictions or conditions of the respective voucher provider. Vouchers may be subject to additional terms or expiry dates of the respective voucher provider, which the user must observe.",

section11Title: "Section 11 - Availability and changes",
section11Text1: "VaultQuest strives for the highest possible availability.",
section11Text2: "However, restrictions may occur in particular due to:",
section11List1: "maintenance",
section11List2: "updates",
section11List3: "third-party provider issues",
section11List4: "external game servers",
section11List5: "technical disruptions",
section11Text3: "restrictions may occur.",
section11Text4: "VaultQuest may adapt, expand, or discontinue functions for objective reasons, in particular due to technical, security-related, legal, or organizational requirements, provided this is reasonable for users.",

section12Title: "Section 12 – Liability",
section12Text1: "VaultQuest is liable without limitation in cases of intent, gross negligence, culpable injury to life, body, or health, and in any other cases where liability is mandatory by law.",
section12Text2: "In the event of a slightly negligent breach of essential contractual obligations, liability is limited, to the extent permitted by law, to the foreseeable damage typical for this type of contract. Essential contractual obligations are obligations whose fulfillment makes the proper performance of the contract possible in the first place and on whose compliance users may regularly rely.",
section12Text3: "For disruptions caused by external services or circumstances outside VaultQuest's sphere of influence, VaultQuest is liable only to the extent that VaultQuest is responsible for the respective disruption under statutory provisions. This applies in particular to:",
section12List1: "technical failures of external games",
section12List2: "server problems of third-party providers",
section12List3: "internet or connection problems",
section12List4: "results not reported or reported late due to a user's conduct",
section12List5: "misconduct of other users",

section13Title: "Section 13 - Suspension and termination",
section13Text1: "VaultQuest may temporarily or permanently suspend user accounts, in particular in cases of:",
section13List1: "violations of these GTC",
section13List2: "multiple accounts",
section13List3: "manipulation",
section13List4: "serious dispute cases",
section13List5: "abuse of the platform",
section13Text2: "In the event of a justified permanent suspension, there is generally no entitlement to restoration of the user account. After a justified permanent suspension, there is no entitlement to create a new user account; VaultQuest may take measures to prevent circumvention of suspensions.",

section14Title: "Section 14 - Community tournaments by creators",
section14Text1: "Creators may request community tournaments through VaultQuest and propose in particular the tournament name, time, number of participants, visibility, prize information, and additional tournament rules.",
section14Text2: "Community tournaments are published only after review and approval by VaultQuest. After approval, VaultQuest provides the technical execution via the platform, in particular tournament display, joining, match and bracket logic, reporting, status updates, and dispute handling.",
section14Text3: "Creator rules must not conflict with the general Competition Terms or the tournament rules displayed in VaultQuest.",
section14Text4: "VaultQuest is responsible for prizes officially displayed to participants on VaultQuest, unless a different prize provider is expressly stated in the specific tournament display. Independent commitments made by creators outside the platform are not part of the tournament operation provided by VaultQuest.",
section14Text5: "VaultQuest may reject creator tournament requests, request changes, cancel, postpone, or adjust published community tournaments, and, in the event of violations, may in particular:",
section14List1: "withdraw the creator function",
section14List2: "reject future community tournaments",
section14List3: "restrict or suspend the user account in accordance with the terms of use",

section15Title: "Section 15 – Data protection",
section15Text1: "Personal data is processed exclusively in accordance with the separate privacy policy.",

section16Title: "Section 16 - Changes to the GTC",
section16Text1: "VaultQuest may adapt these GTC for objective reasons, in particular due to changes in law, changes in case law, regulatory requirements, security requirements, technical changes, or changes and extensions to VaultQuest functions.",
section16Text2: "Changes must not unreasonably disadvantage users. VaultQuest will inform users of material changes in an appropriate manner. Changes generally apply to future use of the platform; mandatory statutory rights remain unaffected.",

section17Title: "Section 17 - Applicable law",
section17Text1: "The law of the Federal Republic of Germany shall apply. For consumers, this choice of law applies only to the extent that it does not deprive them of the protection afforded by mandatory provisions of the law of the country of their habitual residence.",





},



  },
};
